/**!
 * heytapsign
 * 2024-01-30
 * feeds-relatedSearch.js
 * Version 1.0.0
 * (c) 2018-2024 v-luojunfeng@oppo.com
 * 信息流详情页相关搜索.
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? factory(exports)
    : typeof define === 'function' && define.amd
    ? define(['exports'], factory)
    : ((global =
        typeof globalThis !== 'undefined' ? globalThis : global || self),
      factory((global['feeds-relatedSearch'] = {})));
})(this, function (exports) {
  'use strict';

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(
            gen,
            resolve,
            reject,
            _next,
            _throw,
            'next',
            value,
          );
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
        }
        _next(undefined);
      });
    };
  }

  var regeneratorRuntime$1 = { exports: {} };

  var _typeof$2 = { exports: {} };

  (function (module) {
    function _typeof(o) {
      '@babel/helpers - typeof';

      return (
        ((module.exports = _typeof =
          'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
            ? function (o) {
                return typeof o;
              }
            : function (o) {
                return o &&
                  'function' == typeof Symbol &&
                  o.constructor === Symbol &&
                  o !== Symbol.prototype
                  ? 'symbol'
                  : typeof o;
              }),
        (module.exports.__esModule = true),
        (module.exports['default'] = module.exports)),
        _typeof(o)
      );
    }
    (module.exports = _typeof),
      (module.exports.__esModule = true),
      (module.exports['default'] = module.exports);
  })(_typeof$2);

  (function (module) {
    var _typeof = _typeof$2.exports['default'];
    function _regeneratorRuntime() {
      (module.exports = _regeneratorRuntime =
        function _regeneratorRuntime() {
          return e;
        }),
        (module.exports.__esModule = true),
        (module.exports['default'] = module.exports);
      var t,
        e = {},
        r = Object.prototype,
        n = r.hasOwnProperty,
        o =
          Object.defineProperty ||
          function (t, e, r) {
            t[e] = r.value;
          },
        i = 'function' == typeof Symbol ? Symbol : {},
        a = i.iterator || '@@iterator',
        c = i.asyncIterator || '@@asyncIterator',
        u = i.toStringTag || '@@toStringTag';
      function define(t, e, r) {
        return (
          Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          }),
          t[e]
        );
      }
      try {
        define({}, '');
      } catch (t) {
        define = function define(t, e, r) {
          return (t[e] = r);
        };
      }
      function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator,
          a = Object.create(i.prototype),
          c = new Context(n || []);
        return (
          o(a, '_invoke', {
            value: makeInvokeMethod(t, r, c),
          }),
          a
        );
      }
      function tryCatch(t, e, r) {
        try {
          return {
            type: 'normal',
            arg: t.call(e, r),
          };
        } catch (t) {
          return {
            type: 'throw',
            arg: t,
          };
        }
      }
      e.wrap = wrap;
      var h = 'suspendedStart',
        l = 'suspendedYield',
        f = 'executing',
        s = 'completed',
        y = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var p = {};
      define(p, a, function () {
        return this;
      });
      var d = Object.getPrototypeOf,
        v = d && d(d(values([])));
      v && v !== r && n.call(v, a) && (p = v);
      var g =
        (GeneratorFunctionPrototype.prototype =
        Generator.prototype =
          Object.create(p));
      function defineIteratorMethods(t) {
        ['next', 'throw', 'return'].forEach(function (e) {
          define(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }
      function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
          var c = tryCatch(t[r], t, o);
          if ('throw' !== c.type) {
            var u = c.arg,
              h = u.value;
            return h && 'object' == _typeof(h) && n.call(h, '__await')
              ? e.resolve(h.__await).then(
                  function (t) {
                    invoke('next', t, i, a);
                  },
                  function (t) {
                    invoke('throw', t, i, a);
                  },
                )
              : e.resolve(h).then(
                  function (t) {
                    (u.value = t), i(u);
                  },
                  function (t) {
                    return invoke('throw', t, i, a);
                  },
                );
          }
          a(c.arg);
        }
        var r;
        o(this, '_invoke', {
          value: function value(t, n) {
            function callInvokeWithMethodAndArg() {
              return new e(function (e, r) {
                invoke(t, n, e, r);
              });
            }
            return (r = r
              ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg)
              : callInvokeWithMethodAndArg());
          },
        });
      }
      function makeInvokeMethod(e, r, n) {
        var o = h;
        return function (i, a) {
          if (o === f) throw new Error('Generator is already running');
          if (o === s) {
            if ('throw' === i) throw a;
            return {
              value: t,
              done: !0,
            };
          }
          for (n.method = i, n.arg = a; ; ) {
            var c = n.delegate;
            if (c) {
              var u = maybeInvokeDelegate(c, n);
              if (u) {
                if (u === y) continue;
                return u;
              }
            }
            if ('next' === n.method) n.sent = n._sent = n.arg;
            else if ('throw' === n.method) {
              if (o === h) throw ((o = s), n.arg);
              n.dispatchException(n.arg);
            } else 'return' === n.method && n.abrupt('return', n.arg);
            o = f;
            var p = tryCatch(e, r, n);
            if ('normal' === p.type) {
              if (((o = n.done ? s : l), p.arg === y)) continue;
              return {
                value: p.arg,
                done: n.done,
              };
            }
            'throw' === p.type &&
              ((o = s), (n.method = 'throw'), (n.arg = p.arg));
          }
        };
      }
      function maybeInvokeDelegate(e, r) {
        var n = r.method,
          o = e.iterator[n];
        if (o === t)
          return (
            (r.delegate = null),
            ('throw' === n &&
              e.iterator['return'] &&
              ((r.method = 'return'),
              (r.arg = t),
              maybeInvokeDelegate(e, r),
              'throw' === r.method)) ||
              ('return' !== n &&
                ((r.method = 'throw'),
                (r.arg = new TypeError(
                  "The iterator does not provide a '" + n + "' method",
                )))),
            y
          );
        var i = tryCatch(o, e.iterator, r.arg);
        if ('throw' === i.type)
          return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), y;
        var a = i.arg;
        return a
          ? a.done
            ? ((r[e.resultName] = a.value),
              (r.next = e.nextLoc),
              'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
              (r.delegate = null),
              y)
            : a
          : ((r.method = 'throw'),
            (r.arg = new TypeError('iterator result is not an object')),
            (r.delegate = null),
            y);
      }
      function pushTryEntry(t) {
        var e = {
          tryLoc: t[0],
        };
        1 in t && (e.catchLoc = t[1]),
          2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
          this.tryEntries.push(e);
      }
      function resetTryEntry(t) {
        var e = t.completion || {};
        (e.type = 'normal'), delete e.arg, (t.completion = e);
      }
      function Context(t) {
        (this.tryEntries = [
          {
            tryLoc: 'root',
          },
        ]),
          t.forEach(pushTryEntry, this),
          this.reset(!0);
      }
      function values(e) {
        if (e || '' === e) {
          var r = e[a];
          if (r) return r.call(e);
          if ('function' == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              i = function next() {
                for (; ++o < e.length; )
                  if (n.call(e, o))
                    return (next.value = e[o]), (next.done = !1), next;
                return (next.value = t), (next.done = !0), next;
              };
            return (i.next = i);
          }
        }
        throw new TypeError(_typeof(e) + ' is not iterable');
      }
      return (
        (GeneratorFunction.prototype = GeneratorFunctionPrototype),
        o(g, 'constructor', {
          value: GeneratorFunctionPrototype,
          configurable: !0,
        }),
        o(GeneratorFunctionPrototype, 'constructor', {
          value: GeneratorFunction,
          configurable: !0,
        }),
        (GeneratorFunction.displayName = define(
          GeneratorFunctionPrototype,
          u,
          'GeneratorFunction',
        )),
        (e.isGeneratorFunction = function (t) {
          var e = 'function' == typeof t && t.constructor;
          return (
            !!e &&
            (e === GeneratorFunction ||
              'GeneratorFunction' === (e.displayName || e.name))
          );
        }),
        (e.mark = function (t) {
          return (
            Object.setPrototypeOf
              ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
              : ((t.__proto__ = GeneratorFunctionPrototype),
                define(t, u, 'GeneratorFunction')),
            (t.prototype = Object.create(g)),
            t
          );
        }),
        (e.awrap = function (t) {
          return {
            __await: t,
          };
        }),
        defineIteratorMethods(AsyncIterator.prototype),
        define(AsyncIterator.prototype, c, function () {
          return this;
        }),
        (e.AsyncIterator = AsyncIterator),
        (e.async = function (t, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new AsyncIterator(wrap(t, r, n, o), i);
          return e.isGeneratorFunction(r)
            ? a
            : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
        }),
        defineIteratorMethods(g),
        define(g, u, 'Generator'),
        define(g, a, function () {
          return this;
        }),
        define(g, 'toString', function () {
          return '[object Generator]';
        }),
        (e.keys = function (t) {
          var e = Object(t),
            r = [];
          for (var n in e) r.push(n);
          return (
            r.reverse(),
            function next() {
              for (; r.length; ) {
                var t = r.pop();
                if (t in e) return (next.value = t), (next.done = !1), next;
              }
              return (next.done = !0), next;
            }
          );
        }),
        (e.values = values),
        (Context.prototype = {
          constructor: Context,
          reset: function reset(e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = t),
              (this.done = !1),
              (this.delegate = null),
              (this.method = 'next'),
              (this.arg = t),
              this.tryEntries.forEach(resetTryEntry),
              !e)
            )
              for (var r in this)
                't' === r.charAt(0) &&
                  n.call(this, r) &&
                  !isNaN(+r.slice(1)) &&
                  (this[r] = t);
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ('throw' === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
              return (
                (a.type = 'throw'),
                (a.arg = e),
                (r.next = n),
                o && ((r.method = 'next'), (r.arg = t)),
                !!o
              );
            }
            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                a = i.completion;
              if ('root' === i.tryLoc) return handle('end');
              if (i.tryLoc <= this.prev) {
                var c = n.call(i, 'catchLoc'),
                  u = n.call(i, 'finallyLoc');
                if (c && u) {
                  if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                } else if (c) {
                  if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                } else {
                  if (!u)
                    throw new Error('try statement without catch or finally');
                  if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (
                o.tryLoc <= this.prev &&
                n.call(o, 'finallyLoc') &&
                this.prev < o.finallyLoc
              ) {
                var i = o;
                break;
              }
            }
            i &&
              ('break' === t || 'continue' === t) &&
              i.tryLoc <= e &&
              e <= i.finallyLoc &&
              (i = null);
            var a = i ? i.completion : {};
            return (
              (a.type = t),
              (a.arg = e),
              i
                ? ((this.method = 'next'), (this.next = i.finallyLoc), y)
                : this.complete(a)
            );
          },
          complete: function complete(t, e) {
            if ('throw' === t.type) throw t.arg;
            return (
              'break' === t.type || 'continue' === t.type
                ? (this.next = t.arg)
                : 'return' === t.type
                ? ((this.rval = this.arg = t.arg),
                  (this.method = 'return'),
                  (this.next = 'end'))
                : 'normal' === t.type && e && (this.next = e),
              y
            );
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t)
                return (
                  this.complete(r.completion, r.afterLoc), resetTryEntry(r), y
                );
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.tryLoc === t) {
                var n = r.completion;
                if ('throw' === n.type) {
                  var o = n.arg;
                  resetTryEntry(r);
                }
                return o;
              }
            }
            throw new Error('illegal catch attempt');
          },
          delegateYield: function delegateYield(e, r, n) {
            return (
              (this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n,
              }),
              'next' === this.method && (this.arg = t),
              y
            );
          },
        }),
        e
      );
    }
    (module.exports = _regeneratorRuntime),
      (module.exports.__esModule = true),
      (module.exports['default'] = module.exports);
  })(regeneratorRuntime$1);

  // TODO(Babel 8): Remove this file.

  var runtime = regeneratorRuntime$1.exports();
  var regenerator = runtime;

  // Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    if (typeof globalThis === 'object') {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function('r', 'regeneratorRuntime = r')(runtime);
    }
  }

  // Unique ID creation requires a high quality random # generator. In the browser we therefore
  // require the crypto API and do not support built-in fallback to lower quality random number
  // generators (like Math.random()).
  var getRandomValues;
  var rnds8 = new Uint8Array(16);
  function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
      // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
      // find the complete implementation of crypto (msCrypto) on IE11.
      getRandomValues =
        (typeof crypto !== 'undefined' &&
          crypto.getRandomValues &&
          crypto.getRandomValues.bind(crypto)) ||
        (typeof msCrypto !== 'undefined' &&
          typeof msCrypto.getRandomValues === 'function' &&
          msCrypto.getRandomValues.bind(msCrypto));

      if (!getRandomValues) {
        throw new Error(
          'crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported',
        );
      }
    }

    return getRandomValues(rnds8);
  }

  var REGEX =
    /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

  function validate(uuid) {
    return typeof uuid === 'string' && REGEX.test(uuid);
  }

  /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */

  var byteToHex = [];

  for (var i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).substr(1));
  }

  function stringify(arr) {
    var offset =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (
      byteToHex[arr[offset + 0]] +
      byteToHex[arr[offset + 1]] +
      byteToHex[arr[offset + 2]] +
      byteToHex[arr[offset + 3]] +
      '-' +
      byteToHex[arr[offset + 4]] +
      byteToHex[arr[offset + 5]] +
      '-' +
      byteToHex[arr[offset + 6]] +
      byteToHex[arr[offset + 7]] +
      '-' +
      byteToHex[arr[offset + 8]] +
      byteToHex[arr[offset + 9]] +
      '-' +
      byteToHex[arr[offset + 10]] +
      byteToHex[arr[offset + 11]] +
      byteToHex[arr[offset + 12]] +
      byteToHex[arr[offset + 13]] +
      byteToHex[arr[offset + 14]] +
      byteToHex[arr[offset + 15]]
    ).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields

    if (!validate(uuid)) {
      throw TypeError('Stringified UUID is invalid');
    }

    return uuid;
  }

  function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80; // Copy bytes to buffer, if provided

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = rnds[i];
      }

      return buf;
    }

    return stringify(rnds);
  }

  /**
   * 获取kkua 的header头数据
   */
  var getHeaderKKUA = /*#__PURE__*/ (function () {
    var _ref = _asyncToGenerator(
      /*#__PURE__*/ regenerator.mark(function _callee() {
        var headers;
        return regenerator.wrap(function _callee$(_context) {
          while (1)
            switch ((_context.prev = _context.next)) {
              case 0:
                headers = {};
                if (!(typeof wv !== 'undefined')) {
                  _context.next = 34;
                  break;
                }
                if (!window.wv.isMethodValid('getKKUAV3')) {
                  _context.next = 14;
                  break;
                }
                _context.t0 = getResult;
                _context.next = 7;
                return window.wv.getKKUAV3();
              case 7:
                _context.t1 = _context.sent;
                if (_context.t1) {
                  _context.next = 10;
                  break;
                }
                _context.t1 = null;
              case 10:
                _context.t2 = _context.t1;
                headers['X-KKBrowser-UA-V3'] = (0, _context.t0)(_context.t2);
                _context.next = 34;
                break;
              case 14:
                if (!window.wv.isMethodValid('getKKUAV2')) {
                  _context.next = 25;
                  break;
                }
                _context.t3 = getResult;
                _context.next = 18;
                return window.wv.getKKUAV2();
              case 18:
                _context.t4 = _context.sent;
                if (_context.t4) {
                  _context.next = 21;
                  break;
                }
                _context.t4 = null;
              case 21:
                _context.t5 = _context.t4;
                headers['X-KKBrowser-UA-V2'] = (0, _context.t3)(_context.t5);
                _context.next = 34;
                break;
              case 25:
                if (!window.wv.isMethodValid('getKKUA')) {
                  _context.next = 34;
                  break;
                }
                _context.t6 = getResult;
                _context.next = 29;
                return window.wv.getKKUA();
              case 29:
                _context.t7 = _context.sent;
                if (_context.t7) {
                  _context.next = 32;
                  break;
                }
                _context.t7 = null;
              case 32:
                _context.t8 = _context.t7;
                headers['X-KKBrowser-UA'] = (0, _context.t6)(_context.t8);
              case 34:
                return _context.abrupt('return', headers);
              case 35:
              case 'end':
                return _context.stop();
            }
        }, _callee);
      }),
    );
    return function getHeaderKKUA() {
      return _ref.apply(this, arguments);
    };
  })();

  // 获取真实结果，如果code不为0，就返回null
  function getResult(obj) {
    if (obj && obj.code === 0) {
      return obj.data;
    }
    return null;
  }

  // 获取当前客户端搜索引擎
  function getEngine() {
    var engineData =
      window.wv.getSearchEngine() && window.wv.getSearchEngine().data;
    var engine;
    if (engineData) {
      engine = engineData.split('<|>')[0];
    } else {
      engine = 'toutiao';
    }
    return engine;
  }

  /**
   * 判断当前版本号是否高于指定版本，忽略小版本号
   * @param baseVersion {String} - 要比较的版本号，如“7.26”
   * @param currentVersion {String} - 当前版本号，如“40.7.26.1der”
   * @param containEqual {Boolean} - 是否包含等号
   * @returns {boolean} 是否高于指定版本
   */
  function isBrowserVersionHigherThan(baseVersion, currentVersion) {
    var containEqual =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    try {
      var parseVersion = function parseVersion(versionArr) {
        // 给大版本号一个权重，防止 8.1 < 7.26 的现象
        // [8000, 1] [7000, 39]
        return versionArr[0] * 1000 + versionArr[1] * 1;
      };
      // 转换成数字的版本，方便比较
      var versionToNum = function versionToNum(version) {
        version = version.split('.');
        if (version.length >= 4) {
          // 去掉前面的 10/20/40，保留三位
          version = version.slice(1, 4);
        }
        // 去掉最后的小版本号
        version = version.slice(0, -1);
        return Number(parseVersion(version));
      };
      var version = currentVersion;
      if (!currentVersion) {
        // 没传版本时，取 ua 上的版本
        var ua = window.navigator.userAgent.toLowerCase();
        var regExpUa = /(oppo|nearme|realme|oneplus|heytap)browser\/([0-9.]+)/i;
        var matched = ua.match(regExpUa);
        if (matched && matched.length === 3) {
          version = matched[2];
        }
      } else {
        // 去掉版本号最后可能存在的 der 等后缀
        var regExpNum = /[0-9.]+/;
        var _matched = version.match(regExpNum);
        if (_matched) {
          version = _matched[0];
        }
      }
      if (version) {
        var baseVersionNum = Number(
          parseVersion(('' + baseVersion).split('.')),
        );
        return containEqual
          ? versionToNum(version) >= baseVersionNum
          : versionToNum(version) > baseVersionNum;
      }
      return false;
    } catch (e) {
      return false;
    }
  }
  var query = new URLSearchParams(window.location.search);
  function getBrowserInfo() {
    try {
      var _window$wv$getBrowser, _window$wv;
      var result =
        (_window$wv$getBrowser = (_window$wv = window.wv).getBrowserInfo) ===
          null || _window$wv$getBrowser === void 0
          ? void 0
          : _window$wv$getBrowser.call(_window$wv);
      return result ? result.data : {};
    } catch (error) {
      console.error('getBrowserInfo is error', error);
      return {};
    }
  }

  function _typeof$1(o) {
    '@babel/helpers - typeof';

    return (
      (_typeof$1 =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (o) {
              return typeof o;
            }
          : function (o) {
              return o &&
                'function' == typeof Symbol &&
                o.constructor === Symbol &&
                o !== Symbol.prototype
                ? 'symbol'
                : typeof o;
            }),
      _typeof$1(o)
    );
  }

  function _toPrimitive$1(input, hint) {
    if (_typeof$1(input) !== 'object' || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || 'default');
      if (_typeof$1(res) !== 'object') return res;
      throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
  }

  function _toPropertyKey$1(arg) {
    var key = _toPrimitive$1(arg, 'string');
    return _typeof$1(key) === 'symbol' ? key : String(key);
  }

  function _defineProperty$1(obj, key, value) {
    key = _toPropertyKey$1(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true,
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }

  function ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r &&
        (o = o.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })),
        t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread$1(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2
        ? ownKeys$1(Object(t), !0).forEach(function (r) {
            _defineProperty$1(e, r, t[r]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
        : ownKeys$1(Object(t)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
          });
    }
    return e;
  }
  // 获取相关推荐
  function fetchGetRelatedSearch(_x) {
    return _fetchGetRelatedSearch.apply(this, arguments);
  }
  function _fetchGetRelatedSearch() {
    _fetchGetRelatedSearch = _asyncToGenerator(
      /*#__PURE__*/ regenerator.mark(function _callee(params) {
        var _window$OppoFlow, _window$OppoFlow$getI;
        var env,
          host,
          headers,
          url,
          encodeParams,
          item,
          encodedKey,
          encodedValue,
          result,
          jsonData;
        return regenerator.wrap(function _callee$(_context) {
          while (1)
            switch ((_context.prev = _context.next)) {
              case 0:
                env =
                  (_window$OppoFlow = window.OppoFlow) === null ||
                  _window$OppoFlow === void 0 ||
                  (_window$OppoFlow$getI = _window$OppoFlow.getIflowHost) ===
                    null ||
                  _window$OppoFlow$getI === void 0
                    ? void 0
                    : _window$OppoFlow$getI
                        .call(_window$OppoFlow)
                        .indexOf('heytapmobi');
                host =
                  env > -1
                    ? 'https://bs.sc.heytapmobi.com/'
                    : 'http://i-test-browser-cpc.wanyol.com/';
                _context.t0 = _objectSpread$1;
                _context.t1 = {
                  'Content-Type': 'application/json',
                };
                _context.next = 6;
                return getHeaderKKUA();
              case 6:
                _context.t2 = _context.sent;
                headers = (0, _context.t0)(_context.t1, _context.t2);
                console.log('params', params);
                url = host + 'v1/search/browser/relsearch';
                if (params) {
                  encodeParams = [];
                  for (item in params) {
                    encodedKey = encodeURIComponent(item);
                    encodedValue = encodeURIComponent(params[item]);
                    encodeParams.push(encodedKey + '=' + encodedValue);
                  }
                  encodeParams = encodeParams.join('&');
                  url += '?' + encodeParams;
                }
                _context.next = 13;
                return fetch(url, {
                  method: 'GET',
                  headers: headers,
                  mode: 'cors',
                });
              case 13:
                result = _context.sent;
                _context.next = 16;
                return result.json();
              case 16:
                jsonData = _context.sent;
                return _context.abrupt('return', jsonData);
              case 18:
              case 'end':
                return _context.stop();
            }
        }, _callee);
      }),
    );
    return _fetchGetRelatedSearch.apply(this, arguments);
  }

  var dcsreport = { exports: {} };

  /**!
    * heytapsign
    * @cpc/lib-dcs-report.js
    * Version 1.2.8
    * build time 2022-11-09 15:44:55
    * (c) 2018-2022
    * ```
 $ npm install  @cpc/lib-dcs-report
 ```
    */

  (function (module, exports) {
    (function (global, factory) {
      module.exports = factory();
    })(this, function () {
      function _typeof(obj) {
        '@babel/helpers - typeof';

        return (
          (_typeof =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function (obj) {
                  return typeof obj;
                }
              : function (obj) {
                  return obj &&
                    'function' == typeof Symbol &&
                    obj.constructor === Symbol &&
                    obj !== Symbol.prototype
                    ? 'symbol'
                    : typeof obj;
                }),
          _typeof(obj)
        );
      }

      var DcsReport = function DcsReport() {
        var options =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : {};

        if (!(this instanceof DcsReport)) {
          return new DcsReport(options);
        }

        var defaultOptions = {
          isHeyTap: false,
          testEnvironmentFlag: /.wanyol.com|test|localhost/,
          //测试环境标识
          appId: '',
          //产品ID
          logTag: '',
          //业务ID
          defaultHead: {
            imei: '',
            model: '',
            osVersion: '',
            romVersion: '',
            androidVersion: '',
            region: 'CN',
            operatorID1: '',
            operatorID2: '',
            brand: 'OPPO',
          },
          //默认header
          commonBody: {
            //公共body
            appPackage: '',
            appVersion: '',
            appName: '',
          },
          callback: null, //埋点成功回调
        };
        this.dcsUrl = '//event.dc.oppomobile.com/stat/dcs'; //数据上报Api地址
        // this.options = this.extend(options, defaultOptions);

        this.options = this.merge({}, defaultOptions, options);
        var isHeyTap = this.options.isHeyTap;

        if (isHeyTap) {
          this.dcsUrl = '//event.dc.heytapmobi.com/stat/dcs'; //数据上报Api地址
        }

        if (this.options.defaultHead && this.options.defaultHead.region) {
          var region = this.options.defaultHead.region;

          if (
            region == 404 ||
            region == 405 ||
            region == 406 ||
            region == 'IN'
          ) {
            this.dcsUrl = isHeyTap
              ? '//event-in-dc.heytapmobile.com/stat/dcs'
              : '//stat-in.dc.oppomobile.com/stat/dcs'; //印度上报Api地址
          } else if (
            region != 460 &&
            region != 461 &&
            region != 454 &&
            region != 455 &&
            region != 'CN'
          ) {
            this.dcsUrl = isHeyTap
              ? '//event-sg-dc.heytapmobile.com/stat/dcs'
              : '//stat-sg.dc.oppomobile.com/stat/dcs'; //海外上报Api地址
          }
        }

        try {
          if (this.options.testEnvironmentFlag.test(window.location.href)) {
            this.dcsUrl = '//stat-dg-dc-test.wanyol.com/stat/dcs'; //测试环境数据上报Api地址
          }
        } catch (error) {}
      };

      DcsReport.prototype = {
        extend: function extend(source, target) {
          if (source == null) {
            return target;
          }

          for (var k in source) {
            if (source[k] != null && target[k] !== source[k]) {
              if (
                _typeof(source[k]) == 'object' &&
                _typeof(target[k]) == 'object' &&
                Object.prototype.toString.call(target[k]) !== '[object RegExp]'
              ) {
                this.extend(source[k], target[k]);
              } else {
                target[k] = source[k];
              }
            }
          }

          return target;
        },
        isObject: function isObject(obj) {
          return _typeof(obj) === 'object' && obj !== null;
        },

        /**
         * 递归合并
         * @param {Object} target
         * @param  {...Array<Object>} arg
         * @returns
         */
        merge: function merge(target) {
          var _this = this;

          for (
            var _len = arguments.length,
              arg = new Array(_len > 1 ? _len - 1 : 0),
              _key = 1;
            _key < _len;
            _key++
          ) {
            arg[_key - 1] = arguments[_key];
          }

          return arg.reduce(function (acc, cur) {
            return Object.keys(cur).reduce(function (subAcc, key) {
              var srcVal = cur[key];

              if (
                Object.prototype.toString.call(srcVal) === '[object RegExp]'
              ) {
                subAcc[key] = srcVal;
              } else if (_this.isObject(srcVal)) {
                subAcc[key] = _this.merge(
                  subAcc[key] ? subAcc[key] : {},
                  srcVal,
                );
              } else if (Array.isArray(srcVal)) {
                subAcc[key] = srcVal.map(function (item, idx) {
                  if (
                    Object.prototype.toString.call(item) === '[object RegExp]'
                  ) {
                    return item;
                  } else if (_this.isObject(item)) {
                    var curAccVal = subAcc[key] ? subAcc[key] : [];
                    return _this.merge(
                      curAccVal[idx] ? curAccVal[idx] : {},
                      item,
                    );
                  } else {
                    return item;
                  }
                });
              } else {
                subAcc[key] = srcVal;
              }

              return subAcc;
            }, acc);
          }, target);
        },
        //格式化时间
        format: function format(fmt, date) {
          fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
          date = date || new Date();
          var o = {
            'M+': date.getMonth() + 1,
            //月份
            'd+': date.getDate(),
            //日
            'h+': date.getHours(),
            //小时
            'm+': date.getMinutes(),
            //分
            's+': date.getSeconds(),
            //秒
            'q+': Math.floor((date.getMonth() + 3) / 3),
            //季度
            S: date.getMilliseconds(), //毫秒
          };
          if (/(y+)/.test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              (date.getFullYear() + '').substr(4 - RegExp.$1.length),
            );

          for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt))
              fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                  ? o[k]
                  : ('00' + o[k]).substr(('' + o[k]).length),
              );
          }

          return fmt;
        },
        //请求数据接口
        send: function send(body, head, useSendBeacon) {
          var data = {
            head: {},
            body: [],
          };
          head = head || {}; // data.head = this.extend(this.options.defaultHead, head);

          data.head = this.merge({}, this.options.defaultHead, head);
          body = body || [];
          var appId = this.options.appId;
          var logTag = this.options.logTag;
          var eventTime = this.format();
          var commonBody = this.options.commonBody;
          var callback = this.options.callback;

          if (Object.prototype.toString.call(body) == '[object Array]') {
            for (var i = 0, len = body.length; i < len; i++) {
              var item = body[i];
              item.logTag = item.logTag || logTag || appId;
              item.appId = item.appId || appId;
              item.eventTime = item.eventTime || eventTime;
              item.appName = item.appName || commonBody.appName;
              item.appPackage = item.appPackage || commonBody.appPackage;
              item.appVersion = item.appVersion || commonBody.appVersion;
              data.body.push(item);
            }
          } else if (
            Object.prototype.toString.call(body) == '[object Object]'
          ) {
            var _item = body;
            _item.logTag = _item.logTag || logTag || appId;
            _item.appId = _item.appId || appId;
            _item.eventTime = _item.eventTime || eventTime;
            _item.appName = _item.appName || commonBody.appName;
            _item.appPackage = _item.appPackage || commonBody.appPackage;
            _item.appVersion = _item.appVersion || commonBody.appVersion;
            data.body.push(_item);
          }

          if (useSendBeacon) {
            try {
              var blob = new Blob([JSON.stringify(data)], {
                type: 'application/x-www-form-urlencoded',
              });
              var result = window.navigator.sendBeacon(this.dcsUrl, blob);
              result && callback && callback();
              return result;
            } catch (error) {
              console.log(error);
            }
          }

          var xmlhttp = XMLHttpRequest
            ? new XMLHttpRequest()
            : new ActiveXObject('Microsoft.XMLHTTP');
          xmlhttp.open('post', this.dcsUrl, true);
          xmlhttp.setRequestHeader(
            'Content-Type',
            'application/x-www-form-urlencoded',
          );

          xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState == 4) {
              if (xmlhttp.status == 200) {
                callback && callback();
              }
            }
          };

          xmlhttp.send(JSON.stringify(data));
        },
      };

      return DcsReport;
    });
  })(dcsreport);

  var DcsReport = dcsreport.exports;

  function _extends() {
    _extends = Object.assign
      ? Object.assign.bind()
      : function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
    return _extends.apply(this, arguments);
  }

  function _ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r &&
        (o = o.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })),
        t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2
        ? _ownKeys(Object(t), !0).forEach(function (r) {
            _defineProperty$1(e, r, t[r]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
        : _ownKeys(Object(t)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
          });
    }
    return e;
  }
  /**!
    * heytapsign
    * 2024-01-16
    * ObusReport.js
    * Version 1.0.9
    * (c) 2018-2024
    * ```
 $ npm install  @cpc/lib-obus-report
 ```.
    */

  var formatDate = function formatDate(val, format) {
    var o = {
      'M+': val.getMonth() + 1,
      'd+': val.getDate(),
      'h+': val.getHours(),
      'm+': val.getMinutes(),
      's+': val.getSeconds(),
      'q+': Math.floor((val.getMonth() + 3) / 3),
      S: val.getMilliseconds(), //millisecond
    };

    if (/(y+)/.test(format))
      format = format.replace(
        RegExp.$1,
        (val.getFullYear() + '').substr(4 - RegExp.$1.length),
      );
    for (var k in o)
      if (new RegExp('(' + k + ')').test(format))
        // @ts-ignore
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length),
        );
    return format;
  };
  var toString = Object.prototype.toString;
  var TypeChecks = {
    isObject: function isObject(obj) {
      if (obj == null) {
        return false;
      } else {
        return toString.call(obj) == '[object Object]';
      }
    },
    isDate: function isDate(obj) {
      return toString.call(obj) == '[object Date]';
    },
    isArray: function isArray(obj) {
      return (
        (Array.isArray && Array.isArray(obj)) ||
        toString.call(obj) === '[object Array]'
      );
    },
    isFunction: function isFunction(obj) {
      return toString.call(obj) == '[object Function]';
    },
    getType: function getType(obj) {
      return toString.call(obj).slice(8, -1);
    },
  };
  var EventUtils = {
    addEvent: function addEvent(elem, evnt, func) {
      if (!elem) return;
      if (elem.addEventListener)
        // W3C DOM
        elem.addEventListener(evnt, func, false);
      // @ts-ignore
      else if (elem.attachEvent) {
        // IE DOM
        // @ts-ignore
        elem.attachEvent('on' + evnt, func);
      } else {
        // No much to do
        // @ts-ignore
        elem['on' + evnt] = func;
      }
    },
    removeEvent: function removeEvent(elem, evnt, func) {
      if (!elem) return;
      if (elem.removeEventListener)
        // W3C DOM
        elem.removeEventListener(evnt, func, false);
      // @ts-ignore
      else if (elem.detachEvent) {
        // IE DOM
        // @ts-ignore
        elem.detachEvent('on' + evnt, func);
      } else {
        // No much to do
        // @ts-ignore
        elem['on' + evnt] = null;
      }
    },
  };
  function _iterableToArrayLimit(arr, i) {
    var _i =
      null == arr
        ? null
        : ('undefined' != typeof Symbol && arr[Symbol.iterator]) ||
          arr['@@iterator'];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else
          for (
            ;
            !(_n = (_s = _x.call(_i)).done) &&
            (_arr.push(_s.value), _arr.length !== i);
            _n = !0
          );
      } catch (err) {
        (_d = !0), (_e = err);
      } finally {
        try {
          if (
            !_n &&
            null != _i.return &&
            ((_r = _i.return()), Object(_r) !== _r)
          )
            return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly &&
        (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })),
        keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2
        ? ownKeys(Object(source), !0).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(
            target,
            Object.getOwnPropertyDescriptors(source),
          )
        : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(
              target,
              key,
              Object.getOwnPropertyDescriptor(source, key),
            );
          });
    }
    return target;
  }
  function _typeof(obj) {
    '@babel/helpers - typeof';

    return (
      (_typeof =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (obj) {
              return typeof obj;
            }
          : function (obj) {
              return obj &&
                'function' == typeof Symbol &&
                obj.constructor === Symbol &&
                obj !== Symbol.prototype
                ? 'symbol'
                : typeof obj;
            }),
      _typeof(obj)
    );
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', {
      writable: false,
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true,
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _slicedToArray(arr, i) {
    return (
      _arrayWithHoles(arr) ||
      _iterableToArrayLimit(arr, i) ||
      _unsupportedIterableToArray(arr, i) ||
      _nonIterableRest()
    );
  }
  function _toConsumableArray(arr) {
    return (
      _arrayWithoutHoles(arr) ||
      _iterableToArray(arr) ||
      _unsupportedIterableToArray(arr) ||
      _nonIterableSpread()
    );
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _iterableToArray(iter) {
    if (
      (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) ||
      iter['@@iterator'] != null
    )
      return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor) n = o.constructor.name;
    if (n === 'Map' || n === 'Set') return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError(
      'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
    );
  }
  function _nonIterableRest() {
    throw new TypeError(
      'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
    );
  }
  function _toPrimitive(input, hint) {
    if (_typeof$1(input) !== 'object' || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || 'default');
      if (_typeof$1(res) !== 'object') return res;
      throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof$1(key) === 'symbol' ? key : String(key);
  }
  var _isGlobalShowLog = true;
  var _logLevel = 'info';
  var LevelValueMap = {
    debug: 0,
    info: 10,
    warn: 100,
    error: 1000,
  };
  function formatJsonString(obj) {
    try {
      return JSON.stringify(obj, null, '  ');
    } catch (e) {
      return serialize(obj);
    }
  }
  var isSimpleType = function isSimpleType(val) {
    var types = ['string', 'number', 'boolean', 'undefined', 'null'];
    return types.indexOf(_typeof(val)) > -1;
  };
  var LoggerFactory = /*#__PURE__*/ (function () {
    function LoggerFactory(options) {
      _classCallCheck(this, LoggerFactory);
      this.namespace = '';
      this.isShowMills = false;
      this.isShowLog = true;
      this.info = this.genLog('info');
      this.warn = this.genLog('warn');
      this.error = this.genLog('error');
      this.debug = this.genLog('debug');
      if (options) {
        this.setLogConfig(options);
      }
    }
    _createClass(LoggerFactory, [
      {
        key: 'setLogConfig',
        value: function setLogConfig(options) {
          var _options$isShowLog = options.isShowLog,
            isShowLog =
              _options$isShowLog === void 0 ? true : _options$isShowLog,
            _options$isShowMills = options.isShowMills,
            isShowMills =
              _options$isShowMills === void 0 ? false : _options$isShowMills,
            _options$namespace = options.namespace,
            namespace = _options$namespace === void 0 ? '' : _options$namespace;
          this.isShowLog = isShowLog;
          this.isShowMills = isShowMills;
          this.namespace = namespace;
        },
      },
      {
        key: 'config',
        get: function get() {
          return {
            namespace: this.namespace,
            isShowMills: this.isShowMills,
            isShowLog: this.isShowLog,
          };
        },
      },
      {
        key: 'clone',
        value: function clone(options) {
          return new LoggerFactory(
            _objectSpread2(_objectSpread2({}, this.config), options),
          );
        },
      },
      {
        key: 'genLog',
        value: function genLog(type) {
          var _this = this;
          return function () {
            var DEBUG_SWITCH = '__otrack_debug';
            var logSwitch = false;
            try {
              var _localStorage;
              logSwitch = JSON.parse(
                ((_localStorage = localStorage) === null ||
                _localStorage === void 0
                  ? void 0
                  : _localStorage.getItem(DEBUG_SWITCH)) || 'false',
              );
            } catch (e) {}
            if (logSwitch) {
              _isGlobalShowLog = true;
            }
            if (
              !(_isGlobalShowLog && _this.isShowLog) &&
              ['warn', 'error'].indexOf(type) === -1
            ) {
              return false;
            }
            if (LevelValueMap[type] < LevelValueMap[_logLevel]) {
              return false;
            }
            for (
              var _len = arguments.length, rest = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              rest[_key] = arguments[_key];
            }
            var args = rest.map(function (item, index, list) {
              if (TypeChecks.isObject(item)) {
                return formatJsonString(item);
              }
              if (TypeChecks.isArray(item)) {
                if (
                  item.every(function (item) {
                    return isSimpleType(item) || TypeChecks.isArray(item);
                  })
                ) {
                  return item;
                }
                return formatJsonString(item);
              }
              if (isSimpleType(item) && index !== list.length - 1) {
                return String(item);
              }
              return item;
            });
            var date = new Date();
            if (_this.namespace !== '') {
              args.unshift(_this.namespace);
            }
            args.unshift(
              ''.concat(
                formatDate(
                  date,
                  'yyyy-MM-dd hh:mm:ss' + (_this.isShowMills ? '.S' : ''),
                ),
              ),
            );
            var newArgs = args.filter(function (item) {
              return item !== '';
            });
            if (
              (typeof console === 'undefined'
                ? 'undefined'
                : _typeof(console)) === 'object' &&
              console[type]
            ) {
              try {
                return console[type].call(console, newArgs.join(', '));
              } catch (e) {
                console[type](newArgs[0]);
              }
            }
          };
        },
      },
    ]);
    return LoggerFactory;
  })();
  LoggerFactory.disableAllLog = function () {
    _isGlobalShowLog = false;
    LoggerFactory.disableAllLog = function () {
      return void 0;
    };
  };
  LoggerFactory.setLogLevel = function (level) {
    if (['info', 'debug', 'error', 'warn'].includes(level)) {
      _logLevel = level;
    }
  };
  var Logger = new LoggerFactory();

  /**
   * @copyright Maichong Software Ltd. 2016 http://maichong.it
   * @date 2016-01-20
   * @author Liang <liang@maichong.it>
   */

  var numbers = '0123456789';
  var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var specials = '~!@#$%^*()_+-=[]{}|;:,./<>?';
  /**
   * Generate random string
   * @param {Number} length
   * @param {Object} options
   */
  function random() {
    var length =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    var options =
      arguments.length > 1 && arguments[1] !== undefined
        ? arguments[1]
        : {
            specials: false,
            letters: true,
            numbers: true,
          };
    length || (length = 8);
    options || (options = {});
    var chars = '';
    var result = '';
    if (options === true) {
      chars = numbers + letters + specials;
    } else if (typeof options === 'string') {
      chars = options;
    } else {
      if (options.numbers !== false) {
        chars +=
          typeof options.numbers === 'string' ? options.numbers : numbers;
      }
      if (options.letters !== false) {
        chars +=
          typeof options.letters === 'string' ? options.letters : letters;
      }
      if (options.specials) {
        chars +=
          typeof options.specials === 'string' ? options.specials : specials;
      }
    }
    while (length > 0) {
      length--;
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  }
  var LIFEID = random(8);
  function arrayNonRepeat(arr) {
    var map = {};
    var array = [];
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      if (map.hasOwnProperty(item)) {
        map[item] = true;
      } else {
        map[item] = false;
        array.push(arr[i]);
      }
    }
    return array;
  }
  function listToObject(list, keyFunc) {
    var isOnlyOneAttr =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var ret = {};
    list.filter(Boolean).forEach(function (item) {
      var key = typeof keyFunc === 'function' ? keyFunc(item) : keyFunc;
      if (!!ret[item[key]]) {
        !isOnlyOneAttr && ret[item[key]].push(item);
      } else {
        ret[item[key]] = !isOnlyOneAttr ? [item] : item;
      }
    });
    return ret;
  }
  function serialize(val, depth, replacer, space, onGetObjID) {
    depth = depth !== undefined ? (isNaN(+depth) ? 6 : depth) : 6;
    var recursMap = new WeakMap();
    function _build(val, depth, o, a, r) {
      return !val || _typeof(val) != 'object'
        ? val
        : ((r = recursMap.has(val)),
          recursMap.set(val, true),
          (a = Array.isArray(val)),
          r
            ? (o = (onGetObjID && onGetObjID(val)) || null)
            : JSON.stringify(val, function (k, v) {
                if (a || depth > 0) {
                  if (replacer) v = replacer(k, v);
                  if (!k) return (a = Array.isArray(v)), (val = v);
                  !o && (o = a ? [] : {});
                  o[k] = _build(v, a ? depth : depth - 1);
                }
              }),
          o === void 0 ? (a ? [] : {}) : o);
    }
    return JSON.stringify(_build(val, depth), null, space);
  }
  // export function serialize(value: any) {
  //   // Convert object values to JSON
  //   let cache: any[] = []
  //   const str = JSON.stringify(value, function (key, values) {
  //     if (typeof values === 'function') return
  //     if (typeof values === 'object' && values !== null) {
  //       if (cache.indexOf(values) !== -1) return
  //       cache.push(values)
  //     }
  //     return values
  //   })
  //   cache = []
  //   return str
  // }
  function deserialize(data) {
    // Try to parse JSON...
    if (typeof data === 'undefined' || data === null) {
      return data;
    }
    try {
      data = JSON.parse(data);
    } catch (e) {
      // it means data is not json,
      // dont do anything
    }
    return data;
  }
  var getCookieTopLevelDomain = function getCookieTopLevelDomain(hostname) {
    var _location;
    hostname =
      hostname ||
      ((_location = location) === null || _location === void 0
        ? void 0
        : _location.hostname);
    if (!hostname) {
      return '';
    }
    var splitResult = hostname.split('.');
    if (
      TypeChecks.isArray(splitResult) &&
      splitResult.length >= 2 &&
      !/^(\d+\.)+\d+$/.test(hostname)
    ) {
      var domainStr = '.' + splitResult.splice(splitResult.length - 1, 1);
      while (splitResult.length > 0) {
        domainStr =
          '.' + splitResult.splice(splitResult.length - 1, 1) + domainStr;
        document.cookie =
          'otrack_jssdk_domain_test=true; path=/; domain=' + domainStr;
        if (document.cookie.indexOf('otrack_jssdk_domain_test=true') !== -1) {
          var now = new Date();
          now.setTime(now.getTime() - 1000);
          document.cookie =
            'otrack_jssdk_domain_test=true; expires=' +
            now.toUTCString() +
            '; path=/; domain=' +
            domainStr;
          return domainStr;
        }
      }
    }
    return '';
  };
  /**
   * Creates new cookie or removes cookie with negative expiration
   * @param  key       The key or identifier for the store
   * @param  value     Contents of the store
   * @param  exp       Expiration - creation defaults to 30 days
   * @param options
   * @options.cross_subdomain boolean should cross_subdomain
   */
  function createCookie(key, value, exp, options) {
    options = _objectSpread2(
      {
        cross_subdomain: false,
        domain: '',
      },
      options,
    );
    var date = new Date();
    var expire = 0;
    if (typeof exp === 'number') {
      expire = date.getTime() + exp * 24 * 60 * 60 * 1000;
    } else if (TypeChecks.isDate(exp)) {
      //@ts-ignore
      expire = exp.getTime();
    }
    date.setTime(expire);
    var expires = '; expires=' + date.toUTCString();
    if (exp === 0) expires = ''; // session cookie
    if (options.cross_subdomain) {
      options.domain = getCookieTopLevelDomain();
    }
    document.cookie =
      key +
      '=' +
      value +
      expires +
      '; path=/' +
      (options.domain ? '; domain=' + options.domain : '');
  }
  function prepareParams(params) {
    var str = [];
    for (var i in params) {
      str.push(i + '=' + encodeURIComponent(params[i]));
    }
    return str.join('&');
  }
  /**
   * Returns contents of cookie
   * @param  key       The key or identifier for the store
   */
  function readCookie(key) {
    var nameEQ = key + '=';
    var ca = document.cookie.split(';');
    for (var i = 0, max = ca.length; i < max; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }
  var lsSupport = true;
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('testLocal', 'true');
      localStorage.removeItem('testLocal');
    }
  } catch (e) {
    Logger.warn('localStorage不支持', e);
    lsSupport = false;
  }
  /**
   * Simple localStorage with Cookie Fallback
   * v.1.0.0
   *
   * USAGE:
   * ----------------------------------------
   * Set New / Modify:
   *   store("my_key", "some_value");
   *
   * Retrieve:
   *   store("my_key");
   *
   * Delete / Remove:
   *   store("my_key", null);

   */
  function store(key, value, storageOnly) {
    if (key.indexOf('-queue') > 0) key = ''.concat(key, '/').concat(LIFEID);
    storageOnly = typeof storageOnly === 'undefined' ? true : storageOnly; // 默认使用 storage
    var data;
    // If value is detected, set new or modify store
    if (typeof value !== 'undefined' && value !== null) {
      value = serialize(value);
      // Set the store
      if (lsSupport) {
        // Native support
        try {
          var _localStorage;
          (_localStorage = localStorage) === null || _localStorage === void 0
            ? void 0
            : _localStorage.setItem(key, value);
        } catch (e) {
          // https://stackoverflow.com/questions/19574966/catch-quota-exceeded-err-on-localstorage
          // @ts-ignore
          if (
            [
              'QUOTA_EXCEEDED_ERR',
              'NS_ERROR_DOM_QUOTA_REACHED',
              'QuotaExceededError',
              'W3CException_DOM_QUOTA_EXCEEDED_ERR',
            ].indexOf(e.name) > -1
          ) {
            // remove data
            try {
              for (
                var i = 0;
                i <
                ((_localStorage2 = localStorage) === null ||
                _localStorage2 === void 0
                  ? void 0
                  : _localStorage2.length);
                i++
              ) {
                var _localStorage2, _localStorage3;
                var _key =
                  (_localStorage3 = localStorage) === null ||
                  _localStorage3 === void 0
                    ? void 0
                    : _localStorage3.key(i);
                if (_key && /^obus-track_/.test(_key)) {
                  if (
                    _key.indexOf('track-queue') === -1 &&
                    _key.indexOf('request-queue') === -1
                  ) {
                    var _localStorage4;
                    (_localStorage4 = localStorage) === null ||
                    _localStorage4 === void 0
                      ? void 0
                      : _localStorage4.removeItem(_key); // 非对账数据删除
                  } else {
                    var _localStorage5, _localStorage6;
                    var _data =
                      ((_localStorage5 = localStorage) === null ||
                      _localStorage5 === void 0
                        ? void 0
                        : _localStorage5.getItem(_key)) || [];
                    (_localStorage6 = localStorage) === null ||
                    _localStorage6 === void 0
                      ? void 0
                      : _localStorage6.setItem(
                          _key,
                          serialize({
                            version: Date.now(),
                            data:
                              _data.length > 100
                                ? _data.slice(100 - _data.length)
                                : _data,
                          }),
                        );
                  }
                }
              }
            } catch (e) {}
            return;
          }
          console.log('[OTrack] setStorage error');
        }
      } else if (!storageOnly) {
        // Use Cookie
        createCookie(key, value, 30);
      }
    }
    // No value supplied, return value
    if (typeof value === 'undefined') {
      // Get value
      if (lsSupport) {
        var _localStorage7;
        // Native support
        data =
          (_localStorage7 = localStorage) === null || _localStorage7 === void 0
            ? void 0
            : _localStorage7.getItem(key);
      } else if (!storageOnly) {
        // Use cookie
        data = readCookie(key);
      }
      return deserialize(data);
    }
    // Null specified, remove store
    if (value === null) {
      if (lsSupport) {
        var _localStorage8;
        // Native support
        (_localStorage8 = localStorage) === null || _localStorage8 === void 0
          ? void 0
          : _localStorage8.removeItem(key);
      } else if (!storageOnly) {
        // Use cookie
        createCookie(key, '', -1);
      }
    }
  }
  var ssSupport = true;
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('testLocal', 'true');
      sessionStorage.removeItem('testLocal');
    }
  } catch (e) {
    Logger.warn('sessionStorage不支持', e);
    ssSupport = false;
  }
  function storeSession(key, value, storageOnly) {
    storageOnly = typeof storageOnly === 'undefined' ? true : storageOnly; // 默认使用 storage
    var data;
    // If value is detected, set new or modify store
    if (typeof value !== 'undefined' && value !== null) {
      value = serialize(value);
      // Set the store
      if (ssSupport) {
        // Native support
        try {
          sessionStorage.setItem(key, value);
        } catch (e) {
          console.log('[OTrack] sessionStorage error');
        }
      } else if (!storageOnly) {
        // Use Cookie
        createCookie(key, value, 30);
      }
    }
    // No value supplied, return value
    if (typeof value === 'undefined') {
      // Get value
      if (ssSupport) {
        // Native support
        data = sessionStorage.getItem(key);
      } else if (!storageOnly) {
        // Use cookie
        data = readCookie(key);
      }
      return deserialize(data);
    }
    // Null specified, remove store
    if (value === null) {
      if (ssSupport) {
        // Native support
        sessionStorage.removeItem(key);
      } else if (!storageOnly) {
        // Use cookie
        createCookie(key, '', -1);
      }
    }
  }
  /**
   *  Generate random UUID value
   *  @memberof Countly._internals
   *  @returns {String} random UUID value
   */
  function generateUUID(len) {
    var d = new Date().getTime();
    var str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      },
    );
    return len && len > 0 ? str.slice(0, len) : str;
  }
  /**
   *  Get unix timestamp
   *  @memberof Countly._internals
   *  @returns {Number} unix timestamp
   */
  function getTimestamp() {
    return Math.floor(new Date().getTime() / 1000);
  }
  /**
   *  Check if object has any properties
   *  @param {Object} ob - object to check
   *  @returns {Boolean} true if has propertyes and false if not
   */
  function hasAnyProperties(ob) {
    if (ob) {
      for (var prop in ob) {
        if (Object.prototype.hasOwnProperty.call(ob, prop)) {
          return true;
        }
      }
    }
    return false;
  }
  function pickByCb(source, callback) {
    var ret = {};
    for (var key in source)
      if (source.hasOwnProperty(key)) {
        if (callback(source[key], key, source)) {
          ret[key] = source[key];
        }
      }
    return ret;
  }
  function removeAttr(source, list) {
    return pickByCb(source, function (val, key) {
      return list.indexOf(key) === -1;
    });
  }
  var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var btoa = function btoa(string) {
    string = String(string);
    var bitmap,
      a,
      b,
      c,
      result = '',
      i = 0,
      rest = string.length % 3;
    for (; i < string.length; ) {
      if (
        (a = string.charCodeAt(i++)) > 255 ||
        (b = string.charCodeAt(i++)) > 255 ||
        (c = string.charCodeAt(i++)) > 255
      )
        console.log(
          "Failed to execute 'btoa' on 'Window': The string to be encoded contains characters outside of the Latin1 range.",
        );
      bitmap = (a << 16) | (b << 8) | c;
      result +=
        b64.charAt((bitmap >> 18) & 63) +
        b64.charAt((bitmap >> 12) & 63) +
        b64.charAt((bitmap >> 6) & 63) +
        b64.charAt(bitmap & 63);
    }
    return rest ? result.slice(0, rest - 3) + '==='.substring(rest) : result;
  };
  var throttle = function throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
      var _options;
      previous =
        ((_options = options) === null || _options === void 0
          ? void 0
          : _options.leading) === false
          ? 0
          : Date.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function () {
      var _options2, _options3;
      for (
        var _len = arguments.length, rest = new Array(_len), _key2 = 0;
        _key2 < _len;
        _key2++
      ) {
        rest[_key2] = arguments[_key2];
      }
      var now = Date.now();
      if (
        !previous &&
        ((_options2 = options) === null || _options2 === void 0
          ? void 0
          : _options2.leading) === false
      )
        previous = now;
      var remaining = wait - (now - previous);
      // @ts-ignore
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (
        !timeout &&
        ((_options3 = options) === null || _options3 === void 0
          ? void 0
          : _options3.trailing) !== false
      ) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };
  function trim(str) {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  }
  function stripsEmptyAttrs(p) {
    var ret = {};
    for (var key in p) {
      if (p[key] !== null) {
        ret[key] = p[key];
      }
    }
    return ret;
  }
  function getQuery(key) {
    var _location2;
    var search =
        (_location2 = location) === null || _location2 === void 0
          ? void 0
          : _location2.search.substr(1),
      ret = {};
    if (search) {
      try {
        var query = search.split('&').filter(Boolean);
        query.forEach(function (kv) {
          var _kv$split = kv.split('='),
            _kv$split2 = _slicedToArray(_kv$split, 2),
            k = _kv$split2[0],
            v = _kv$split2[1];
          ret[k] = decodeURIComponent(v);
        });
      } catch (e) {}
    }
    if (key) return ret[key] || null;
    return ret;
  }
  function parseUrl(url) {
    if (!url) return null;
    var reg = /^(https?:\/\/)([^\/]+)(.*)$/i;
    var map = url.match(reg);
    if (map) {
      var _map = _slicedToArray(map, 4);
      _map[0];
      var schema = _map[1],
        host = _map[2],
        end = _map[3];
      var _split = (end || '').split('?'),
        _split2 = _slicedToArray(_split, 2),
        path = _split2[0],
        tail = _split2[1];
      var _split3 = (tail || '').split('#'),
        _split4 = _slicedToArray(_split3, 2),
        search = _split4[0],
        hash = _split4[1];
      var query = (search || '').split('&').filter(Boolean),
        qry = {};
      query.forEach(function (kv) {
        var _kv$split3 = kv.split('='),
          _kv$split4 = _slicedToArray(_kv$split3, 2),
          k = _kv$split4[0],
          v = _kv$split4[1];
        qry[k] = decodeURIComponent(v);
      });
      return {
        schema: schema,
        host: host,
        path: path,
        search: search,
        query: qry,
        hash: hash || '',
      };
    } else {
      return null;
    }
  }
  function spreadFunction(obj) {
    var ret = {};
    if (TypeChecks.isObject(obj)) {
      Object.keys(obj).forEach(function (k) {
        if (typeof obj[k] === 'function') {
          ret[k] = obj[k]();
        } else {
          ret[k] = obj[k];
        }
      });
    }
    return ret;
  }
  function isSameOrigin() {
    var _location3, _document;
    var a = parseUrl(
      (_location3 = location) === null || _location3 === void 0
        ? void 0
        : _location3.href,
    );
    var b = parseUrl(
      (_document = document) === null || _document === void 0
        ? void 0
        : _document.referrer,
    );
    if (a && b) {
      var h1 = a.host.split('.');
      var h2 = b.host.split('.');
      var idx = Math.min(h1.length, h2.length) - 1;
      var t1 = h1.slice(-idx).join('.');
      var t2 = h2.slice(-idx).join('.');
      if (t1 === t2) {
        // 同源站点
        return true;
      }
    }
    return false;
  }
  var getRandomBasic = (function () {
    var today = new Date();
    var seed = today.getTime();
    function rnd() {
      seed = (seed * 9301 + 49297) % 233280;
      return seed / 233280.0;
    }
    return function rand(number) {
      return Math.ceil(rnd() * number);
    };
  })();
  var getRandom = function getRandom() {
    if (typeof Uint32Array === 'function') {
      var cry = '';
      if (typeof crypto !== 'undefined') {
        cry = crypto;
      } else if (typeof msCrypto !== 'undefined') {
        cry = msCrypto;
      }
      if (TypeChecks.isObject(cry) && cry.getRandomValues) {
        var typedArray = new Uint32Array(1);
        var randomNumber = cry.getRandomValues(typedArray)[0];
        var integerLimit = Math.pow(2, 32);
        return randomNumber / integerLimit;
      }
    }
    return getRandomBasic(10000000000000000000) / 10000000000000000000;
  };
  var UUID = (function () {
    var T = function T() {
      var d = 1 * new Date().getTime(),
        i = 0;
      while (d == 1 * new Date().getTime()) {
        i++;
      }
      return d.toString(16) + i.toString(16);
    };
    var R = function R() {
      return getRandom().toString(16).replace('.', '');
    };
    var UA = function UA() {
      var ua = navigator.userAgent,
        i,
        ch,
        buffer = [],
        ret = 0;
      function xor(result, byte_array) {
        var j,
          tmp = 0;
        for (j = 0; j < byte_array.length; j++) {
          tmp |= buffer[j] << (j * 8);
        }
        return result ^ tmp;
      }
      for (i = 0; i < ua.length; i++) {
        ch = ua.charCodeAt(i);
        buffer.unshift(ch & 0xff);
        if (buffer.length >= 4) {
          ret = xor(ret, buffer);
          buffer = [];
        }
      }
      if (buffer.length > 0) {
        ret = xor(ret, buffer);
      }
      return ret.toString(16);
    };
    return function () {
      var se = screen.height * screen.width;
      if (se && /\d{5,}/.test(String(se))) {
        se = se.toString(16);
      } else {
        se = String(getRandom() * 31242)
          .replace('.', '')
          .slice(0, 8);
      }
      var val = T() + '-' + R() + '-' + UA() + '-' + se + '-' + T();
      if (val) {
        return val;
      } else {
        return (
          String(getRandom()) +
          String(getRandom()) +
          String(getRandom())
        ).slice(2, 15);
      }
    };
  })();
  function init() {
    var life_id = storeSession('LIFEID');
    if (!life_id) {
      storeSession('LIFEID', LIFEID); // jssdk生命期ID
    } else {
      LIFEID = life_id; // 单一页面多次刷新ID不变
    }
    // clean old data
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key && /^obus-track_/.test(key)) {
          var item = localStorage.getItem(key),
            now = Date.now();
          item = deserialize(item) || {
            version: 0,
          };
          var version = item.version;
          if (version && now - version > 86400000) {
            localStorage.removeItem(key);
          }
        }
      }
    } catch (e) {}
  }
  init();
  function initXhr() {
    var win = window;
    if (typeof win.XMLHttpRequest !== 'undefined') {
      return new win.XMLHttpRequest();
    }
    // @ts-ignore
    if (win.ActiveXObject) {
      try {
        // @ts-ignore
        return new win.ActiveXObject('Msxml2.XMLHTTP');
      } catch (d) {
        try {
          // @ts-ignore
          return new win.ActiveXObject('Microsoft.XMLHTTP');
        } catch (d) {
          Logger.error(d);
          return null;
        }
      }
    }
  }
  function getJSON(data) {
    if (!data) {
      return '';
    }
    try {
      return JSON.parse(data);
    } catch (e) {
      return {};
    }
  }
  var asyncLabel = true;
  function asyncFlag(flag) {
    if (flag === undefined) {
      return asyncLabel;
    } else {
      asyncLabel = flag;
    }
  }
  function fetch$1(url, options) {
    var _navigator;
    var _options$method = options.method,
      method = _options$method === void 0 ? 'GET' : _options$method,
      _options$data = options.data,
      data = _options$data === void 0 ? {} : _options$data,
      _options$timeout = options.timeout,
      timeout = _options$timeout === void 0 ? 20 : _options$timeout;
    var onLineStatus =
      'onLine' in (navigator || {})
        ? (_navigator = navigator) === null || _navigator === void 0
          ? void 0
          : _navigator.onLine
        : true;
    var oldsuccess = options.success;
    var oldfail = options.fail;
    var errorTimer;
    timeout = timeout || 20;
    var errorCb = function errorCb(callback) {
      if (options.reTryCount === undefined || options.reTryCount <= 0) {
        typeof callback === 'function' && callback(true);
        return true;
      }
      options.success = oldsuccess;
      options.fail = oldfail;
      Logger.warn('retry fetch with '.concat(--options.reTryCount, ' count.'));
      fetch$1(url, options);
    };
    var xhr = initXhr();
    var isAsync = asyncFlag();
    if (options.withCredentials) {
      xhr.withCredentials = options.withCredentials;
    }
    method = method.toUpperCase();
    if (xhr === null || xhr === undefined) {
      Logger.error('xhr object is null, exiting');
      return false;
    }
    if (!onLineStatus) {
      Logger.warn('当前网络离线，请检查网络状态!');
      options.fail && options.fail('NOT ONLINE', 404);
      return false;
    }
    function abort() {
      try {
        if (TypeChecks.isObject(xhr)) {
          xhr.abort();
        }
      } catch (error) {
        Logger.error(error);
      }
      if (errorTimer) {
        clearTimeout(errorTimer);
        errorTimer = 0;
        options.fail && options.fail('TIMEOUT', 408);
        xhr.onreadystatechange = null;
        xhr.onload = null;
        xhr.onerror = null;
      }
    }
    options.success = function (data) {
      oldsuccess && oldsuccess(data);
      if (errorTimer) {
        clearTimeout(errorTimer);
        errorTimer = 0;
      }
    };
    options.fail = function () {
      for (
        var _len = arguments.length, rest = new Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        rest[_key] = arguments[_key];
      }
      // done --- reTryFinish
      errorCb(function (done) {
        oldfail && oldfail.apply(null, rest);
      });
      if (errorTimer) {
        clearTimeout(errorTimer);
        errorTimer = 0;
      }
    };
    errorTimer = window.setTimeout(function () {
      abort();
    }, timeout * 1000);
    xhr.onreadystatechange = function () {
      try {
        if (xhr.readyState == 4) {
          if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
            options.success && options.success(getJSON(xhr.responseText));
          } else {
            options.fail && options.fail(xhr.responseText, xhr.status);
          }
          xhr.onreadystatechange = null;
          xhr.onload = null;
        }
      } catch (e) {
        console.error(e);
        xhr.onreadystatechange = null;
        xhr.onload = null;
      }
    };
    if (method.toUpperCase() === 'GET') {
      var suffix = hasAnyProperties(data) ? '?' + prepareParams(data) : '';
      xhr.open('GET', url + suffix, isAsync);
    } else {
      xhr.open('POST', url, isAsync);
    }
    if (TypeChecks.isObject(options.headers)) {
      for (var key in options.headers)
        if (options.headers.hasOwnProperty(key)) {
          xhr.setRequestHeader &&
            xhr.setRequestHeader(key, options.headers[key]);
        }
    }
    if (method === 'GET') {
      xhr.send();
      return true;
    }
    var contentType = options.headers
      ? options.headers['Content-Type'] || options.headers['Content-type'] || ''
      : '';
    if (contentType.indexOf('application/x-www-form-urlencoded') >= 0) {
      var _navigator2;
      if (
        ((_navigator2 = navigator) === null || _navigator2 === void 0
          ? void 0
          : _navigator2.sendBeacon) &&
        !isAsync &&
        window.URLSearchParams
      ) {
        // 同步请求sendBeacon
        var formData = new URLSearchParams();
        Object.keys(data).forEach(function (k) {
          formData.append(k, data[k]);
        });
        navigator.sendBeacon(url, formData); //因为不会有返回内容，所以无法判断上报失败还是成功
        options.success(data);
        // navigator.sendBeacon('https://putsreq.herokuapp.com/4GE2nVUuDoDGsNyKES2G', formData) //调试用的地址
      } else xhr.send(prepareParams(data));
    } else if (contentType.indexOf('application/json') >= 0) {
      xhr.send(JSON.stringify(data));
    } else {
      xhr.send(data);
    }
  }
  var countryCodeMap = {
    AT: 'EU',
    BE: 'EU',
    DK: 'EU',
    FI: 'EU',
    FR: 'EU',
    DE: 'EU',
    GR: 'EU',
    IE: 'EU',
    IT: 'EU',
    LU: 'EU',
    NL: 'EU',
    PT: 'EU',
    ES: 'EU',
    SE: 'EU',
    GB: 'EU',
    HU: 'EU',
    PL: 'EU',
    CZ: 'EU',
    SI: 'EU',
    SK: 'EU',
    EE: 'EU',
    LT: 'EU',
    MT: 'EU',
    CY: 'EU',
    RO: 'EU',
    BG: 'EU',
    LV: 'EU',
    HR: 'EU',
    NO: 'EU',
    IS: 'EU',
    LI: 'EU',
    CH: 'EU',
    TR: 'EU',
    RS: 'EU',
    BA: 'EU',
    MX: 'US',
  };
  var countryToRegion = function countryToRegion() {
    var country =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    country = (country || '').toUpperCase();
    switch (country.toUpperCase()) {
      case 'EU':
      case 'CN':
      case 'SG':
      case 'IN':
        return country;
      case 'SGP':
        return 'SG';
      case 'US':
        return 'US';
      case '':
        return 'SG';
      default:
        // @ts-ignore
        return countryCodeMap[country] || 'SG';
    }
  };

  /**
   *  Current device data
   *  @memberof Countly._internals
   *  @prop {String} device - device type
   *  @prop {Function} detect - detect device type
   *  @prop {Boolean} isMobile - true if mobile device
   *  @prop {String} userAgent - userAgent value
   */
  var detect_device = (function () {
    var _navigator, _navigator$userAgent;
    var b =
        (_navigator = navigator) === null || _navigator === void 0
          ? void 0
          : (_navigator$userAgent = _navigator.userAgent) === null ||
            _navigator$userAgent === void 0
          ? void 0
          : _navigator$userAgent.toLowerCase(),
      a = function a(t) {
        if (t) {
          b = (t + '').toLowerCase();
        }
        return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
          b,
        )
          ? 'tablet'
          : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(
              b,
            )
          ? 'mobile'
          : 'desktop';
      };
    return {
      device: a(),
      detect: a,
      isMobile: 'desktop' !== a() ? !0 : !1,
      userAgent: b,
    };
  })();
  /**
   *  Get width of whole document
   *  @memberof Countly._internals
   *  @returns {Number} width in pixels
   */
  function getDocWidth() {
    var D = document;
    return Math.max(
      Math.max(D.body.scrollWidth, D.documentElement.scrollWidth),
      Math.max(D.body.offsetWidth, D.documentElement.offsetWidth),
      Math.max(D.body.clientWidth, D.documentElement.clientWidth),
    );
  }
  /**
   *  Get height of viewable area
   *  @memberof Countly._internals
   *  @returns {Number} height in pixels
   */
  function getViewportHeight() {
    var D = document;
    return Math.min(
      Math.min(D.body.clientHeight, D.documentElement.clientHeight),
      Math.min(D.body.offsetHeight, D.documentElement.offsetHeight),
      window.innerHeight,
    );
  }
  /**
   *  Get device's orientation
   *  @returns {String} device orientation
   */
  function getOrientation() {
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  }
  var browserMaps = {
    ucbrowser: 'UC',
    sogou: 'Sogou',
    '2345browser': '2345',
    baidu: 'Baidu',
    liebao: 'LieBao',
    huawei: 'Huawei',
    360: 360,
    heytap: 'oppo',
    oppo: 'oppo',
    quark: 'quark',
    vivo: 'vivo',
    meizu: 'meizu',
    samsung: 'samsung',
    realme: 'realme',
    oneplus: 'oneplus',
    weibo: 'Weibo',
  };
  var getVersion = function getVersion(str, reg) {
    var index =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var matches = str.match(reg);
    return matches ? matches[index] : '0';
  };
  function getBrowser() {
    var _navigator2, _navigator2$userAgent, _navigator3, _navigator3$userAgent;
    if (
      (typeof __wxConfig === 'undefined'
        ? 'undefined'
        : _typeof(__wxConfig)) === 'object'
    ) {
      // const w = wx && wx.getAccountInfoSync()
      console.log('wx', __wxConfig, '__wxConfig');
      return;
    }
    var win = window || Object.create(null);
    var userAgent =
      ((_navigator2 = navigator) === null || _navigator2 === void 0
        ? void 0
        : (_navigator2$userAgent = _navigator2.userAgent) === null ||
          _navigator2$userAgent === void 0
        ? void 0
        : _navigator2$userAgent.toLowerCase()) || '';
    var browserInfo = {
      type: '',
      versions: '',
    };
    var browserArray = {
      // @ts-ignore
      IE: win.ActiveXObject || 'ActiveXObject' in win,
      Chrome:
        userAgent.indexOf('chrome') > -1 && userAgent.indexOf('safari') > -1,
      Firefox: userAgent.indexOf('firefox') > -1,
      // @ts-ignore
      Opera:
        (!!win.opr && !!win.opr.addons) ||
        !!win.opera ||
        ((_navigator3 = navigator) === null || _navigator3 === void 0
          ? void 0
          : (_navigator3$userAgent = _navigator3.userAgent) === null ||
            _navigator3$userAgent === void 0
          ? void 0
          : _navigator3$userAgent.indexOf('OPR/')) !== -1,
      Safari:
        userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') == -1,
      Edge: userAgent.indexOf('edge') > -1,
      QQBrowser: /qqbrowser/i.test(userAgent),
      WeixinBrowser: /MicroMessenger/i.test(userAgent),
      QQInnerBrowser: /QQ\//i.test(userAgent),
      WeiboInnerBrowser: /weibo/i.test(userAgent),
    };
    for (var i in browserArray) {
      // @ts-ignore
      if (browserArray[i]) {
        var versions = '';
        if (i == 'IE') {
          versions = getVersion(userAgent, /(msie\s|trident.*rv:)([\w.]+)/, 2);
        } else if (i == 'Chrome') {
          for (var mt in navigator.mimeTypes) {
            //检测是否是360浏览器(测试只有pc端的360才起作用)
            if (
              navigator.mimeTypes[mt]['type'] == 'application/360softmgrplugin'
            ) {
              i = '360';
            }
          }
          var reg = new RegExp(
            '('.concat(Object.keys(browserMaps).join('|'), ')'),
            'gi',
          );
          var match = userAgent.toLowerCase().match(reg);
          if (match) {
            i = browserMaps[match[0]] || 'Chrome';
          }
          versions = getVersion(userAgent, /chrome\/([\d.]+)/, 1);
        } else if (i == 'Firefox') {
          versions = getVersion(userAgent, /firefox\/([\d.]+)/, 1);
        } else if (i == 'Opera') {
          versions = getVersion(userAgent, /(?:opera|opr)\/([\d.]+)/, 1);
        } else if (i == 'Safari') {
          versions = getVersion(userAgent, /version\/([\d.]+)/, 1);
        } else if (i == 'Edge') {
          versions = getVersion(userAgent, /edge\/([\d.]+)/, 1);
        } else if (i == 'QQBrowser') {
          versions = getVersion(userAgent, /qqbrowser\/([\d.]+)/, 1);
        } else if (i == 'WeixinBrowser') {
          versions = getVersion(userAgent, /MicroMessenger\/([\d.]+)/, 1);
        } else if (i == 'QQInnerBrowser') {
          versions = getVersion(userAgent, /QQ\/([\d.]+)/, 1);
        } else if (i == 'WeiboInnerBrowser') {
          versions = getVersion(userAgent, /__weibo__([\d.]+)/, 1);
        }
        browserInfo.type = i;
        browserInfo.versions = parseInt(versions, 10);
      }
    }
    return browserInfo;
  }
  var detectOS = function detectOS() {
    var _navigator4,
      _navigator5,
      _navigator6,
      _navigator7,
      _navigator8,
      _navigator9,
      _navigator10,
      _navigator11,
      _navigator12,
      _navigator13,
      _navigator14,
      _sUserAgent$toLowerCa;
    var sUserAgent =
      ((_navigator4 = navigator) === null || _navigator4 === void 0
        ? void 0
        : _navigator4.userAgent) || '';
    var isWin =
      ((_navigator5 = navigator) === null || _navigator5 === void 0
        ? void 0
        : _navigator5.platform) == 'Win32' ||
      ((_navigator6 = navigator) === null || _navigator6 === void 0
        ? void 0
        : _navigator6.platform) == 'Windows';
    var isMac =
      ((_navigator7 = navigator) === null || _navigator7 === void 0
        ? void 0
        : _navigator7.platform) == 'Mac68K' ||
      ((_navigator8 = navigator) === null || _navigator8 === void 0
        ? void 0
        : _navigator8.platform) == 'MacPPC' ||
      ((_navigator9 = navigator) === null || _navigator9 === void 0
        ? void 0
        : _navigator9.platform) == 'Macintosh' ||
      ((_navigator10 = navigator) === null || _navigator10 === void 0
        ? void 0
        : _navigator10.platform) == 'MacIntel';
    if (isMac) return 'Mac';
    if (
      ((_navigator11 = navigator) === null || _navigator11 === void 0
        ? void 0
        : _navigator11.platform) &&
      ((_navigator12 = navigator) === null || _navigator12 === void 0
        ? void 0
        : _navigator12.platform.toLowerCase()) == 'iphone'
    )
      return 'iPhone';
    var isUnix =
      ((_navigator13 = navigator) === null || _navigator13 === void 0
        ? void 0
        : _navigator13.platform) == 'X11' &&
      !isWin &&
      !isMac;
    if (isUnix) return 'Unix';
    var isLinux =
      String(
        (_navigator14 = navigator) === null || _navigator14 === void 0
          ? void 0
          : _navigator14.platform,
      ).indexOf('Linux') > -1;
    var bIsAndroid =
      sUserAgent === null || sUserAgent === void 0
        ? void 0
        : (_sUserAgent$toLowerCa = sUserAgent.toLowerCase()) === null ||
          _sUserAgent$toLowerCa === void 0
        ? void 0
        : _sUserAgent$toLowerCa.match(/android/i);
    if (isLinux) {
      if (bIsAndroid) return 'Android';
      else return 'Linux';
    }
    if (isWin) {
      var isWin2K =
        sUserAgent.indexOf('Windows NT 5.0') > -1 ||
        sUserAgent.indexOf('Windows 2000') > -1;
      if (isWin2K) return 'Win2000';
      var isWinXP =
        sUserAgent.indexOf('Windows NT 5.1') > -1 ||
        sUserAgent.indexOf('Windows XP') > -1 ||
        sUserAgent.indexOf('Windows XP') > -1;
      if (isWinXP) return 'WinXP';
      var isWin2003 =
        sUserAgent.indexOf('Windows NT 5.2') > -1 ||
        sUserAgent.indexOf('Windows 2003') > -1;
      if (isWin2003) return 'Win2003';
      var isWinVista =
        sUserAgent.indexOf('Windows NT 6.0') > -1 ||
        sUserAgent.indexOf('Windows Vista') > -1;
      if (isWinVista) return 'WinVista';
      var isWin7 =
        sUserAgent.indexOf('Windows NT 6.1') > -1 ||
        sUserAgent.indexOf('Windows 7') > -1;
      if (isWin7) return 'Win7';
      var isWin8 =
        sUserAgent.indexOf('Windows NT 6.2') > -1 ||
        sUserAgent.indexOf('Windows 8') > -1;
      if (isWin8) return 'Win8';
      var isWin10 =
        sUserAgent.indexOf('Windows NT 10.0') > -1 ||
        sUserAgent.indexOf('Windows 10') > -1;
      if (isWin10) return 'Win10';
    }
    return 'Others';
  };
  var browserInfo = getBrowser();
  var os = detectOS();
  var _excluded = ['callback'];
  var PING = /*#__PURE__*/ (function () {
    function PING(timeout) {
      _classCallCheck(this, PING);
      this.cacheMap = {};
      this.timeout = 0;
      this.pendingImgs = [];
      this.timeout = timeout || 3000;
    }
    _createClass(
      PING,
      [
        {
          key: 'pong',
          value: function pong(options) {
            var _this = this;
            if (this.cacheMap[options.key]) {
              return false;
            }
            var reset = function reset() {
              if (_this.cacheMap[options.key]) {
                clearTimeout(_this.cacheMap[options.key]);
                img.src = '';
                delete _this.cacheMap[options.key];
                _this.pendingImgs = _this.pendingImgs.filter(function (item) {
                  return item.alt !== options.key;
                });
              }
            };
            var img = new Image();
            var callback = options.callback || function (isSucc, data) {};
            img.onload = function () {
              callback(true, true);
              reset();
            };
            img.onerror = function () {
              callback(true, false);
              reset();
            };
            img.alt = options.key;
            this.cacheMap[options.key] = window.setTimeout(function () {
              callback(false, 'timeout');
              reset();
            }, this.timeout);
            img.src = options.url + '/favicon.ico?v=' + +new Date(); // Trigger image load with cache buster
            this.pendingImgs.push(img);
          },
        },
        {
          key: 'stopLoadImgs',
          value: function stopLoadImgs() {
            this.pendingImgs.forEach(function (item) {
              item.src = '';
            });
          },
        },
      ],
      [
        {
          key: 'racePong',
          value: function racePong(opts, memoCallback) {
            var instance = new PING();
            var TIMEOUT_MILLS = 3000;
            var count = opts.length;
            var resolved = false;
            var timerId = setTimeout(function () {
              resolved = true;
              memoCallback(null);
            }, TIMEOUT_MILLS);
            var spy = function spy(options, connection) {
              if (!resolved) {
                if (connection) {
                  memoCallback(
                    _objectSpread2(
                      _objectSpread2({}, options),
                      {},
                      {
                        connection: connection,
                      },
                    ),
                  );
                  instance.stopLoadImgs();
                  resolved = true;
                  clearTimeout(timerId);
                }
              }
              if (--count === 0) {
                clearTimeout(timerId);
                !resolved && memoCallback(null);
              }
            };
            opts.forEach(function (item) {
              item.callback;
              var rest = _objectWithoutProperties(item, _excluded);
              instance.pong(
                _objectSpread2(
                  _objectSpread2({}, item),
                  {},
                  {
                    callback: function callback(isSuccess, data) {
                      if (!isSuccess) spy(rest, false);
                      else spy(rest, data);
                    },
                  },
                ),
              );
            });
          },
        },
      ],
    );
    return PING;
  })();
  var CloudEnvDetector = /*#__PURE__*/ (function () {
    function CloudEnvDetector(isTest) {
      _classCallCheck(this, CloudEnvDetector);
      var envConf = store('is_virtual_env') || '';
      var _envConf$split = envConf.split('|'),
        _envConf$split2 = _slicedToArray(_envConf$split, 2),
        expire = _envConf$split2[1];
      if (
        isTest &&
        (envConf === '' || (expire && Date.now() - +expire > 240 * 3600 * 1000))
      ) {
        // 240小时, 10天
        this.refreshEnv();
      }
    }
    _createClass(CloudEnvDetector, [
      {
        key: 'isInCloud',
        value: function isInCloud() {
          var envConf = store('is_virtual_env');
          if (envConf == null) {
            if (this.isNotVirtual()) {
              envConf = 'false';
            } else {
              envConf = 'true';
            }
          }
          return envConf.split('|')[0] === 'true';
        },
      },
      {
        key: 'refreshEnv',
        value: function refreshEnv() {
          var opts = [
            // {
            //   key: 'baidu',
            //   url: 'https://www.baidu.com'
            // },
            // {
            //   key: 'google',
            //   url: 'https://www.google.com'
            // },
            {
              key: 'gitlab',
              url: 'http://gitlab.os.adc.com',
            },
          ];
          if (this.isNotVirtual()) return;
          PING.racePong(opts, function (item) {
            if (item && item.key === 'gitlab' && item.connection) {
              store('is_virtual_env', ''.concat(true, '|', Date.now()));
            } else {
              store('is_virtual_env', ''.concat(false, '|', Date.now()));
            }
          });
        },
      },
      {
        key: 'isNotVirtual',
        value: function isNotVirtual() {
          return os.toLowerCase().indexOf('win') === -1 || screen.width < 1240;
        },
      },
    ]);
    return CloudEnvDetector;
  })();
  function merge() {
    for (
      var _len = arguments.length, items = new Array(_len), _key = 0;
      _key < _len;
      _key++
    ) {
      items[_key] = arguments[_key];
    }
    return _merge(items[0] === true, false, items);
  }
  function recursive() {
    for (
      var _len2 = arguments.length, items = new Array(_len2), _key2 = 0;
      _key2 < _len2;
      _key2++
    ) {
      items[_key2] = arguments[_key2];
    }
    return _merge(items[0] === true, true, items);
  }
  function clone(input) {
    if (Array.isArray(input)) {
      var output = [];
      for (var index = 0; index < input.length; ++index)
        output.push(clone(input[index]));
      return output;
    } else if (isPlainObject(input)) {
      var _output = {};
      for (var _index in input) _output[_index] = clone(input[_index]);
      return _output;
    } else {
      return input;
    }
  }
  function isPlainObject(input) {
    return input && _typeof(input) === 'object' && !Array.isArray(input);
  }
  function _recursiveMerge(base, extend) {
    if (!isPlainObject(base)) return extend;
    for (var key in extend) {
      if (key === '__proto__' || key === 'constructor' || key === 'prototype')
        continue;
      base[key] =
        isPlainObject(base[key]) && isPlainObject(extend[key])
          ? _recursiveMerge(base[key], extend[key])
          : extend[key];
    }
    return base;
  }
  function _merge(isClone, isRecursive, items) {
    var result;
    if (isClone || !isPlainObject((result = items.shift()))) result = {};
    for (var index = 0; index < items.length; ++index) {
      var item = items[index];
      if (!isPlainObject(item)) continue;
      for (var key in item) {
        if (key === '__proto__' || key === 'constructor' || key === 'prototype')
          continue;
        var value = isClone ? clone(item[key]) : item[key];
        result[key] = isRecursive ? _recursiveMerge(result[key], value) : value;
      }
    }
    return result;
  }
  var getLocation = function getLocation() {
    var _location, _location2, _location3;
    return {
      origin:
        (_location = location) === null || _location === void 0
          ? void 0
          : _location.origin,
      pathname:
        (_location2 = location) === null || _location2 === void 0
          ? void 0
          : _location2.pathname,
      href:
        (_location3 = location) === null || _location3 === void 0
          ? void 0
          : _location3.href,
    };
  };
  var prev = null;
  var current = getLocation();
  var delay = 1000; // ms
  var pre = null; // eventListener专用
  var cur = current; // eventListener专用
  var singleSpaTrigger = '';
  var firstCome = false; // 首次进来
  var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
  };
  // let historyPushState = window?.history?.pushState
  // let historyReplaceState = window?.history?.replaceState
  var historyPushStateNew;
  var historyReplaceStateNew;
  function addSinglePageEvent(callback, ignoreFunc) {
    var _window, _window$history, _window2, _window2$history, _window5;
    var historyPushState =
      (_window = window) === null || _window === void 0
        ? void 0
        : (_window$history = _window.history) === null ||
          _window$history === void 0
        ? void 0
        : _window$history.pushState;
    var historyReplaceState =
      (_window2 = window) === null || _window2 === void 0
        ? void 0
        : (_window2$history = _window2.history) === null ||
          _window2$history === void 0
        ? void 0
        : _window2$history.replaceState;
    var callCallback = function callCallback() {
      if (!ignoreFunc(location, prev)) {
        callback(location, prev);
      }
    };
    var pending = true; //解决pushState循环调用
    var pushState = function pushState() {
      var _window3;
      pending = !pending;
      if (pending) {
        var f = history.__proto__.pushState;
        f.apply(history, arguments);
        return;
      }
      singleSpaTrigger = 'pushState';
      cur = prev = getLocation();
      // @ts-ignore
      var fn = historyPushStateNew || historyPushState;
      historyPushStateNew = null;
      fn.apply(
        (_window3 = window) === null || _window3 === void 0
          ? void 0
          : _window3.history,
        arguments,
      );
      current = getLocation();
      pending = true;
      callCallback();
      if (firstCome) {
        firstCome = false;
        return; // 首次进来不需要触发路由监听器
      }

      if (!ignoreFunc(current, prev))
        UrlListener.watchRoutes().forEach(function (fn) {
          return fn(current, prev);
        });
    };
    var replaceState = function replaceState() {
      var _window4;
      pending = !pending;
      if (pending) {
        var f = history.__proto__.replaceState;
        f.apply(history, arguments);
        return;
      }
      singleSpaTrigger = 'replaceState';
      cur = prev = getLocation();
      // @ts-ignore
      var fn = historyReplaceStateNew || historyReplaceState;
      historyReplaceStateNew = null;
      fn.apply(
        (_window4 = window) === null || _window4 === void 0
          ? void 0
          : _window4.history,
        arguments,
      );
      current = getLocation();
      pending = true;
      callCallback();
      if (firstCome) {
        firstCome = false;
        return; // 首次进来不需要触发路由监听器
      }

      if (!ignoreFunc(current, prev))
        UrlListener.watchRoutes().forEach(function (fn) {
          return fn(current, prev);
        });
    };
    var eventListener = function eventListener() {
      // console.log('EventUtils.addEvent', 'prev', prev, 'current', current)
      prev = current;
      if (!prev && !pre) firstCome = true;
      pre = current;
      if (!singleSpaTrigger) {
        prev = pre;
      }
      singleSpaTrigger = '';
      current = cur = getLocation();
      callCallback();
      if (firstCome) {
        firstCome = false;
        return; // 首次进来不需要触发路由监听器
      }

      if (!ignoreFunc(cur, pre))
        UrlListener.watchRoutes().forEach(function (fn) {
          return fn(cur, pre);
        });
    };
    if (isFunction(historyPushState)) {
      window.history.pushState = pushState;
    }
    if (isFunction(historyReplaceState)) {
      window.history.replaceState = replaceState;
    }
    var singlePageEvent;
    // @ts-ignore for ie8
    if (
      (_window5 = window) === null || _window5 === void 0
        ? void 0
        : _window5.document.documentMode
    ) {
      singlePageEvent = 'hashchange';
    } else {
      singlePageEvent = !!historyPushState ? 'popstate' : 'hashchange';
    }
    EventUtils.addEvent(window, singlePageEvent, eventListener);
    var tick = function tick() {
      var _window6;
      var next = false;
      var history =
        ((_window6 = window) === null || _window6 === void 0
          ? void 0
          : _window6.history) || {};
      if (isFunction(historyPushState)) {
        if (history.pushState !== pushState) {
          historyPushStateNew = history.pushState;
          next = true;
        }
      }
      if (isFunction(historyReplaceState)) {
        if (history.replaceState !== replaceState) {
          historyReplaceStateNew = history.replaceState;
          next = true;
        }
      }
      if (next) {
        EventUtils.removeEvent(window, singlePageEvent, eventListener);
        EventUtils.addEvent(window, singlePageEvent, eventListener);
      }
      setTimeout(tick, delay); // 轮询判断history接口是否被替换
    };
    // debugger
    setTimeout(tick, delay);
  }
  var UrlListener = /*#__PURE__*/ (function () {
    function UrlListener() {
      _classCallCheck(this, UrlListener);
    }
    _createClass(UrlListener, null, [
      {
        key: 'init',
        value: function init(isSingleApp, listeners, ignoreList) {
          var _this = this;
          if (this.inited) {
            throw new Error('TrackUrlListener重复初始化!');
          }
          this.listeners =
            typeof listeners === 'function'
              ? [listeners]
              : _toConsumableArray(this.listeners);
          this.isSingleApp = isSingleApp;
          if (isSingleApp) {
            addSinglePageEvent(function (curr, prev) {
              _this.listeners.forEach(function (item) {
                item(curr, prev);
              });
            }, ignoreList);
          }
          this.inited = true;
          return this;
        },
      },
      {
        key: 'push',
        value: function push(listener) {
          // console.log('url-listener-push', 'listener', listener)
          if (listener) {
            this.listeners.push(listener);
          }
        },
      },
      {
        key: 'remove',
        value: function remove(listener) {
          // console.log('url-listener-remove', 'listener', listener)
          this.listeners = this.listeners.filter(function (item) {
            return item !== listener;
          });
        },
      },
      {
        key: 'getPrevUrl',
        value: function getPrevUrl() {
          // console.log('url-listener-getPrevUrl', 'this.isSingleApp', this.isSingleApp, 'prev', prev, 'document.referrer', document.referrer)
          if (this.isSingleApp) {
            return prev ? prev.href : document.referrer || '';
          }
          return document.referrer || '';
        },
      },
      {
        key: 'watchRoutes',
        value: function watchRoutes(listeners) {
          if (typeof listeners !== 'undefined') {
            this.routerListeners = listeners;
          }
          return this.routerListeners;
        },
      },
    ]);
    return UrlListener;
  })();
  UrlListener.listeners = [];
  UrlListener.routerListeners = [];
  UrlListener.isSingleApp = void 0;
  UrlListener.inited = void 0;
  function s$1(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(t);
      e &&
        (o = o.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })),
        n.push.apply(n, o);
    }
    return n;
  }
  function a$1(t) {
    for (var e = 1; arguments.length > e; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2
        ? s$1(Object(n), !0).forEach(function (e) {
            h$1(t, e, n[e]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
        : s$1(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
    }
    return t;
  }
  function f$1(t, e) {
    if (!(t instanceof e))
      throw new TypeError('Cannot call a class as a function');
  }
  function l$1(t, e) {
    for (var n = 0; e.length > n; n++) {
      var o = e[n];
      (o.enumerable = o.enumerable || !1),
        (o.configurable = !0),
        'value' in o && (o.writable = !0),
        Object.defineProperty(t, o.key, o);
    }
  }
  function p$1(t, e, n) {
    return (
      e && l$1(t.prototype, e),
      n && l$1(t, n),
      Object.defineProperty(t, 'prototype', {
        writable: !1,
      }),
      t
    );
  }
  function h$1(t, e, n) {
    return (
      e in t
        ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (t[e] = n),
      t
    );
  }
  function d$1(t, e) {
    if (null == t) return {};
    var n,
      o,
      r = (function (t, e) {
        if (null == t) return {};
        var n,
          o,
          r = {},
          i = Object.keys(t);
        for (o = 0; i.length > o; o++)
          0 > e.indexOf((n = i[o])) && (r[n] = t[n]);
        return r;
      })(t, e);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);
      for (o = 0; i.length > o; o++)
        0 > e.indexOf((n = i[o])) &&
          Object.prototype.propertyIsEnumerable.call(t, n) &&
          (r[n] = t[n]);
    }
    return r;
  }
  function g$1(t) {
    return (
      (function (t) {
        if (Array.isArray(t)) return y$1(t);
      })(t) ||
      (function (t) {
        if (
          ('undefined' != typeof Symbol && null != t[Symbol.iterator]) ||
          null != t['@@iterator']
        )
          return Array.from(t);
      })(t) ||
      (function (t, e) {
        if (!t) return;
        if ('string' == typeof t) return y$1(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        'Object' === n && t.constructor && (n = t.constructor.name);
        if ('Map' === n || 'Set' === n) return Array.from(t);
        if (
          'Arguments' === n ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
        )
          return y$1(t, e);
      })(t) ||
      (function () {
        throw new TypeError(
          'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
        );
      })()
    );
  }
  function y$1(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var n = 0, o = Array(e); e > n; n++) o[n] = t[n];
    return o;
  }
  var v$1 = '1.5.46',
    m$1 = ['config_code'],
    b$1 = {
      dev: 'https://dev-appconf.wanyol.com',
      test: 'https://app-conf.wanyol.com',
      getProdUrl: function getProdUrl(t) {
        return 'cn' === t
          ? 'https://appconf.heytapdownload.com'
          : 'sg' === t || 'sgp' === t
          ? 'https://appconf-sgp.heytapdl.com'
          : 'https://appconf-'.concat(t.toLocaleLowerCase(), '.heytapdl.com');
      },
    },
    O = function O(t) {
      switch (t) {
        case 'cn':
          return 'https://obus-jssdk-cn.heytapmobi.com';
        case 'us':
        case 'in':
        case 'sg':
          return 'https://obus-jssdk-'.concat(t, '.heytapmobile.com');
        case 'eu':
          return 'https://obus-jssdk-fr.heytapmobile.com';
        default:
          return 'https://obus-jssdk-sg.heytapmobile.com';
      }
    },
    E$1 = (function () {
      function t(e) {
        f$1(this, t),
          (this.cloudEnvDetector = null),
          (this.cloudEnvDetector = new CloudEnvDetector(e));
      }
      return (
        p$1(t, [
          {
            key: 'checkUpdateUrl',
            value: function value(t, e) {
              if (readCookie('__VPN__')) return t;
              var n = e || 'sg',
                o = (countryCodeMap[n.toUpperCase()] || n).toLocaleLowerCase();
              return ''.concat(O(o), '/api/checkUpdate');
            },
          },
          {
            key: 'cdnUrl',
            value: function value(t, e) {
              if (readCookie('__VPN__')) return t;
              var n = e || 'sg',
                o = (countryCodeMap[n.toUpperCase()] || n).toLocaleLowerCase();
              return ''.concat(O(o), '/api/fetchCdnFile');
            },
          },
        ]),
        t
      );
    })(),
    w$1 = (function () {
      function c(e) {
        f$1(this, c),
          (this.options = void 0),
          (this.configList = []),
          (this.proxyConfigHost = void 0);
        if (
          ((this.options = a$1(
            a$1(
              {},
              {
                env: 'prod',
                countryCode: 'cn',
                productId: '',
                expires: '6h',
                condition: null,
              },
            ),
            e,
          )),
          (this.options.env = this.options.env || 'prod'),
          (this.configList = store(this.STORAGE_KEY) || []),
          (this.proxyConfigHost = new E$1(this.isDebugEnv())),
          store(this.STORAGE_KEY_NO_USED))
        )
          try {
            localStorage.removeItem(this.STORAGE_KEY_NO_USED);
          } catch (t) {}
      }
      return (
        p$1(
          c,
          [
            {
              key: 'fetch',
              value: function value(t, e) {
                var r = this,
                  i =
                    arguments.length > 2 &&
                    void 0 !== arguments[2] &&
                    arguments[2],
                  c = Array.isArray(t) ? t : [t],
                  u = this.configMap,
                  s = [];
                (c = arrayNonRepeat(c)),
                  i
                    ? (s = c.map(function (t) {
                        return {
                          configCode: t,
                          version: 0,
                        };
                      }))
                    : c.forEach(function (t) {
                        u[t]
                          ? r.isConfigExpired(u[t]) &&
                            s.push({
                              configCode: t,
                              version: u[t].version,
                            })
                          : s.push({
                              configCode: t,
                              version: 0,
                            });
                      });
                var f = c.filter(function (t) {
                    return s.every(function (e) {
                      return t !== e.configCode;
                    });
                  }),
                  l = f.map(function (t) {
                    return u[t];
                  });
                this.fetchConfig(s, function (t, n) {
                  if (
                    ((n = (n = n || []).map(function (t) {
                      return a$1(
                        {
                          name: t.config_code,
                        },
                        d$1(t, m$1),
                      );
                    })),
                    -1 === t)
                  )
                    return (
                      e &&
                        e.call(
                          r,
                          c.map(function (t) {
                            return r.configMap[t];
                          }),
                        ),
                      Logger.error('fetch config error occur.')
                    );
                  Logger.debug(
                    '拉取配置'.concat(
                      n.map(function (t) {
                        return t.name;
                      }),
                      '成功',
                    ),
                    n,
                  ),
                    1 === t && r.writeStorage(n),
                    e && e.call(r, [].concat(g$1(n), g$1(l)));
                });
              },
            },
            {
              key: 'refresh',
              value: function value() {
                var t = this,
                  e =
                    arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0],
                  n = arguments.length > 1 ? arguments[1] : void 0,
                  r = this.configList,
                  i = r;
                e ||
                  (i = r.filter(function (e) {
                    return t.isConfigExpired(e);
                  })),
                  this.fetchConfig(
                    i.map(function (t) {
                      return {
                        version: t.version,
                        configCode: t.name,
                      };
                    }),
                    function (e, r) {
                      if (-1 === e)
                        return Logger.error('fetch config error occur.');
                      Logger.info('刷新应用云控配置成功, 即将刷新页面'),
                        1 === e &&
                          (t.writeStorage(r),
                          setTimeout(function () {
                            'function' == typeof n && n();
                          }, 200));
                    },
                  );
              },
            },
            {
              key: 'writeStorage',
              value: function value(e) {
                var n = this,
                  o = [],
                  r = {};
                e.forEach(function (t) {
                  (r[t.name] = !0),
                    o.push({
                      name: t.name,
                      version: t.version,
                      expire: n.getExpireTime(t.interval_time),
                      created: Date.now(),
                      content: t.content,
                    });
                }),
                  this.configList.forEach(function (t) {
                    r[t.name] || o.push(t);
                  }),
                  (this.configList = o),
                  store(this.STORAGE_KEY, o);
              },
            },
            {
              key: 'getExpireTime',
              value: function value(t) {
                return Date.now() + this.getExpireTimeMills(t);
              },
            },
            {
              key: 'getExpireTimeMills',
              value: function value(t) {
                var e = this.options.expires || '',
                  n = 1;
                if (
                  '' !== (e = e.replace(/^\s+.*?\s+$/, '')) &&
                  e.length >= 2
                ) {
                  var o = e.charAt(e.length - 1).toLocaleLowerCase();
                  'd' === o
                    ? (n = 864e5)
                    : 'h' === o
                    ? (n = 36e5)
                    : 'm' === o
                    ? (n = 6e4)
                    : 's' === o && (n = 1e3);
                }
                return e ? n * parseInt(e.slice(0, -1), 10) : 1e3 * t;
              },
            },
            {
              key: 'fetchConfig',
              value: function value(t, e) {
                var n = this,
                  i = this.options,
                  c = {
                    itemList: t,
                    productId: i.productId,
                  };
                if (
                  (i.condition && (c.systemCondition = i.condition),
                  !t || (Array.isArray(t) && 0 === t.length))
                )
                  return e && e(0, this.configList);
                Logger.debug(
                  '拉取云控配置',
                  t.map(function (t) {
                    return t.configCode;
                  }),
                );
                var u = this.getCheckUpdateUrl();
                fetch$1(this.proxyConfigHost.checkUpdateUrl(u, i.countryCode), {
                  data: {
                    body: JSON.stringify(c),
                    url: u,
                  },
                  reTryCount: 2,
                  success: function success(t) {
                    if (200 == +t.error_code) {
                      var r = t.item_list.filter(function (t) {
                        return t.version > 0 && !!t.url;
                      });
                      if (!r || 0 === r.length)
                        return (
                          Logger.warn('合法的配置树为0，请检查配置项名称'),
                          e && e(-1, null),
                          !1
                        );
                      n.fetchCdnFile(r, function (t, n) {
                        if (t)
                          return (
                            Logger.info('拉取cdn文件异常'), e && e(-1, null), !1
                          );
                        e && e(1, n);
                      });
                    }
                  },
                  fail: function fail() {
                    return e && e(-1, null), Logger.error('fetch config error');
                  },
                });
              },
            },
            {
              key: 'fetchCdnFile',
              value: function value(t, e) {
                var n = this,
                  o = [],
                  i = t.length;
                t.forEach(function (t) {
                  fetch$1(
                    n.proxyConfigHost.cdnUrl(t.url, n.options.countryCode),
                    {
                      data: {
                        url: t.url,
                      },
                      reTryCount: 2,
                      success: function success(n) {
                        i--,
                          o.push(
                            a$1(
                              a$1({}, t),
                              {},
                              {
                                content: n,
                              },
                            ),
                          ),
                          0 === i && e && e(!1, o);
                      },
                      fail: function fail() {
                        0 === i && e && e(!1, o);
                      },
                    },
                  );
                });
              },
            },
            {
              key: 'isConfigExpired',
              value: function value(t) {
                var e = Date.now();
                return (
                  (!!t.created &&
                    e - (null == t ? void 0 : t.created) >=
                      this.getExpireTimeMills(1)) ||
                  (!!t.expire && e >= (null == t ? void 0 : t.expire))
                );
              },
            },
            {
              key: 'config',
              get: function get() {
                return this.configList;
              },
            },
            {
              key: 'getCheckUpdateUrl',
              value: function value() {
                var t = this.options.env || 'prod',
                  e = this.options.countryCode || 'sg',
                  n = 'sg';
                return 0 > ['dev', 'test'].indexOf(t)
                  ? ('prod' === t.toLocaleLowerCase() &&
                      (n = (
                        countryCodeMap[e.toUpperCase()] || e
                      ).toLocaleLowerCase()),
                    ''.concat(b$1.getProdUrl(n), '/js/v2/checkUpdate'))
                  : ''.concat(b$1[t], '/js/v2/checkUpdate');
              },
            },
            {
              key: 'isDebugEnv',
              value: function value() {
                var t,
                  e =
                    (null === (t = location) || void 0 === t
                      ? void 0
                      : t.hostname) || '';
                return !!(
                  /\.example$/.test(e) ||
                  'localhost' === e ||
                  /\.wanyol\.com$/.test(e) ||
                  -1 !== e.indexOf('test') ||
                  -1 !== e.indexOf('dev') ||
                  /^\d+(?:.\d+){3}$/.test(e)
                );
              },
            },
            {
              key: 'configMap',
              get: function get() {
                for (var t = {}, e = 0; this.configList.length > e; e++)
                  t[this.configList[e].name] = this.configList[e];
                return t;
              },
            },
            {
              key: 'STORAGE_KEY',
              get: function get() {
                return '__mdp_cloud_config/'
                  .concat(this.options.productId, '_')
                  .concat(this.options.env);
              },
            },
            {
              key: 'STORAGE_KEY_NO_USED',
              get: function get() {
                return '__mdp_cloud_config/'.concat(this.options.productId);
              },
            },
          ],
          [
            {
              key: 'multiFetch',
              value: function value(t, n) {
                if ('Array' !== Object.prototype.toString.call(t).slice(8, -1))
                  throw Error('参数错误');
                if (
                  (t.forEach(function (t) {
                    if ('function' != typeof t) throw Error('参数错误');
                  }),
                  (n.timeout = n.timeout || 20),
                  1 === t.length)
                )
                  return t[0](function (t) {
                    var o = h$1(
                      {},
                      this.options.productId,
                      listToObject(t, 'name', !0),
                    );
                    return n.success(o);
                  });
                var o = t.length,
                  r = {},
                  i = setTimeout(function () {
                    o > 0 && n.fail && n.fail(r, t.length - o);
                  }, 1e3 * n.timeout);
                t.forEach(function (t) {
                  t(function (t) {
                    (r = a$1(
                      a$1({}, r),
                      {},
                      h$1(
                        {},
                        this.options.productId,
                        listToObject(t, 'name', !0),
                      ),
                    )),
                      0 == --o && (n.success(r), window.clearTimeout(i));
                  });
                });
              },
            },
          ],
        ),
        c
      );
    })();
  w$1.VERSION = '1.5.46';
  var e,
    n,
    t,
    r,
    a = -1,
    o = function o(e) {
      addEventListener(
        'pageshow',
        function (n) {
          n.persisted && ((a = n.timeStamp), e(n));
        },
        !0,
      );
    },
    c = function c() {
      return (
        window.performance &&
        performance.getEntriesByType &&
        performance.getEntriesByType('navigation')[0]
      );
    },
    u = function u() {
      var e = c();
      return (e && e.activationStart) || 0;
    },
    f = function f(e, n) {
      var t = c(),
        r = 'navigate';
      return (
        a >= 0
          ? (r = 'back-forward-cache')
          : t &&
            (r =
              document.prerendering || u() > 0
                ? 'prerender'
                : document.wasDiscarded
                ? 'restore'
                : t.type.replace(/_/g, '-')),
        {
          name: e,
          value: void 0 === n ? -1 : n,
          rating: 'good',
          delta: 0,
          entries: [],
          id: 'v3-'
            .concat(Date.now(), '-')
            .concat(Math.floor(8999999999999 * Math.random()) + 1e12),
          navigationType: r,
        }
      );
    },
    s = function s(e, n, t) {
      try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
          var r = new PerformanceObserver(function (e) {
            Promise.resolve().then(function () {
              n(e.getEntries());
            });
          });
          return (
            r.observe(
              _extends(
                {
                  type: e,
                  buffered: !0,
                },
                t || {},
              ),
            ),
            r
          );
        }
      } catch (e) {}
    },
    d = function d(e, n, t, r) {
      var i, a;
      return function (o) {
        n.value >= 0 &&
          (o || r) &&
          ((a = n.value - (i || 0)) || void 0 === i) &&
          ((i = n.value),
          (n.delta = a),
          (n.rating = (function (e, n) {
            return e > n[1] ? 'poor' : e > n[0] ? 'needs-improvement' : 'good';
          })(n.value, t)),
          e(n));
      };
    },
    l = function l(e) {
      requestAnimationFrame(function () {
        return requestAnimationFrame(function () {
          return e();
        });
      });
    },
    p = function p(e) {
      var n = function n(_n2) {
        ('pagehide' !== _n2.type && 'hidden' !== document.visibilityState) ||
          e(_n2);
      };
      addEventListener('visibilitychange', n, !0),
        addEventListener('pagehide', n, !0);
    },
    v = function v(e) {
      var n = !1;
      return function (t) {
        n || (e(t), (n = !0));
      };
    },
    m = -1,
    h = function h() {
      return 'hidden' !== document.visibilityState || document.prerendering
        ? 1 / 0
        : 0;
    },
    g = function g(e) {
      'hidden' === document.visibilityState &&
        m > -1 &&
        ((m = 'visibilitychange' === e.type ? e.timeStamp : 0), T());
    },
    y = function y() {
      addEventListener('visibilitychange', g, !0),
        addEventListener('prerenderingchange', g, !0);
    },
    T = function T() {
      removeEventListener('visibilitychange', g, !0),
        removeEventListener('prerenderingchange', g, !0);
    },
    E = function E() {
      return (
        m < 0 &&
          ((m = h()),
          y(),
          o(function () {
            setTimeout(function () {
              (m = h()), y();
            }, 0);
          })),
        {
          get firstHiddenTime() {
            return m;
          },
        }
      );
    },
    C = function C(e) {
      document.prerendering
        ? addEventListener(
            'prerenderingchange',
            function () {
              return e();
            },
            !0,
          )
        : e();
    },
    L = [1800, 3e3],
    b = function b(e, n) {
      (n = n || {}),
        C(function () {
          var t,
            r = E(),
            i = f('FCP'),
            a = s('paint', function (e) {
              e.forEach(function (e) {
                'first-contentful-paint' === e.name &&
                  (a.disconnect(),
                  e.startTime < r.firstHiddenTime &&
                    ((i.value = Math.max(e.startTime - u(), 0)),
                    i.entries.push(e),
                    t(!0)));
              });
            });
          a &&
            ((t = d(e, i, L, n.reportAllChanges)),
            o(function (r) {
              (i = f('FCP')),
                (t = d(e, i, L, n.reportAllChanges)),
                l(function () {
                  (i.value = performance.now() - r.timeStamp), t(!0);
                });
            }));
        });
    },
    w = [0.1, 0.25],
    S = function S(e, n) {
      (n = n || {}),
        b(
          v(function () {
            var t,
              r = f('CLS', 0),
              i = 0,
              a = [],
              c = function c(e) {
                e.forEach(function (e) {
                  if (!e.hadRecentInput) {
                    var n = a[0],
                      t = a[a.length - 1];
                    i &&
                    e.startTime - t.startTime < 1e3 &&
                    e.startTime - n.startTime < 5e3
                      ? ((i += e.value), a.push(e))
                      : ((i = e.value), (a = [e]));
                  }
                }),
                  i > r.value && ((r.value = i), (r.entries = a), t());
              },
              u = s('layout-shift', c);
            u &&
              ((t = d(e, r, w, n.reportAllChanges)),
              p(function () {
                c(u.takeRecords()), t(!0);
              }),
              o(function () {
                (i = 0),
                  (r = f('CLS', 0)),
                  (t = d(e, r, w, n.reportAllChanges)),
                  l(function () {
                    return t();
                  });
              }),
              setTimeout(t, 0));
          }),
        );
    },
    A = {
      passive: !0,
      capture: !0,
    },
    I = new Date(),
    P = function P(r, i) {
      e || ((e = i), (n = r), (t = new Date()), k(removeEventListener), F());
    },
    F = function F() {
      if (n >= 0 && n < t - I) {
        var i = {
          entryType: 'first-input',
          name: e.type,
          target: e.target,
          cancelable: e.cancelable,
          startTime: e.timeStamp,
          processingStart: e.timeStamp + n,
        };
        r.forEach(function (e) {
          e(i);
        }),
          (r = []);
      }
    },
    M = function M(e) {
      if (e.cancelable) {
        var n =
          (e.timeStamp > 1e12 ? new Date() : performance.now()) - e.timeStamp;
        'pointerdown' == e.type
          ? (function (e, n) {
              var t = function t() {
                  P(e, n), i();
                },
                r = function r() {
                  i();
                },
                i = function i() {
                  removeEventListener('pointerup', t, A),
                    removeEventListener('pointercancel', r, A);
                };
              addEventListener('pointerup', t, A),
                addEventListener('pointercancel', r, A);
            })(n, e)
          : P(n, e);
      }
    },
    k = function k(e) {
      ['mousedown', 'keydown', 'touchstart', 'pointerdown'].forEach(function (
        n,
      ) {
        return e(n, M, A);
      });
    },
    D = [100, 300],
    x = function x(t, i) {
      (i = i || {}),
        C(function () {
          var a,
            c = E(),
            u = f('FID'),
            l = function l(e) {
              e.startTime < c.firstHiddenTime &&
                ((u.value = e.processingStart - e.startTime),
                u.entries.push(e),
                a(!0));
            },
            m = function m(e) {
              e.forEach(l);
            },
            h = s('first-input', m);
          (a = d(t, u, D, i.reportAllChanges)),
            h &&
              p(
                v(function () {
                  m(h.takeRecords()), h.disconnect();
                }),
              ),
            h &&
              o(function () {
                var o;
                (u = f('FID')),
                  (a = d(t, u, D, i.reportAllChanges)),
                  (r = []),
                  (n = -1),
                  (e = null),
                  k(addEventListener),
                  (o = l),
                  r.push(o),
                  F();
              });
        });
    },
    U = [2500, 4e3],
    V = {},
    W$1 = function W$1(e, n) {
      (n = n || {}),
        C(function () {
          var t,
            r = E(),
            i = f('LCP'),
            a = function a(e) {
              var n = e[e.length - 1];
              n &&
                n.startTime < r.firstHiddenTime &&
                ((i.value = Math.max(n.startTime - u(), 0)),
                (i.entries = [n]),
                t());
            },
            c = s('largest-contentful-paint', a);
          if (c) {
            t = d(e, i, U, n.reportAllChanges);
            var m = v(function () {
              V[i.id] ||
                (a(c.takeRecords()), c.disconnect(), (V[i.id] = !0), t(!0));
            });
            ['keydown', 'click'].forEach(function (e) {
              addEventListener(e, m, !0);
            }),
              p(m),
              o(function (r) {
                (i = f('LCP')),
                  (t = d(e, i, U, n.reportAllChanges)),
                  l(function () {
                    (i.value = performance.now() - r.timeStamp),
                      (V[i.id] = !0),
                      t(!0);
                  });
              });
          }
        });
    },
    X$1 = [800, 1800],
    Y$1 = function e(n) {
      document.prerendering
        ? C(function () {
            return e(n);
          })
        : 'complete' !== document.readyState
        ? addEventListener(
            'load',
            function () {
              return e(n);
            },
            !0,
          )
        : setTimeout(n, 0);
    },
    Z$1 = function Z$1(e, n) {
      n = n || {};
      var t = f('TTFB'),
        r = d(e, t, X$1, n.reportAllChanges);
      Y$1(function () {
        var i = c();
        if (i) {
          var a = i.responseStart;
          if (a <= 0 || a > performance.now()) return;
          (t.value = Math.max(a - u(), 0)),
            (t.entries = [i]),
            r(!0),
            o(function () {
              (t = f('TTFB', 0)), (r = d(e, t, X$1, n.reportAllChanges))(!0);
            });
        }
      });
    };
  function B(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t &&
        (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })),
        i.push.apply(i, n);
    }
    return i;
  }
  function W(e) {
    for (var t = 1; arguments.length > t; t++) {
      var i = null != arguments[t] ? arguments[t] : {};
      t % 2
        ? B(Object(i), !0).forEach(function (t) {
            Z(e, t, i[t]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
        : B(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
    }
    return e;
  }
  function z(e) {
    return (
      (z =
        'function' == typeof Symbol && 'symbol' == _typeof$1(Symbol.iterator)
          ? function (e) {
              return _typeof$1(e);
            }
          : function (e) {
              return e &&
                'function' == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? 'symbol'
                : _typeof$1(e);
            }),
      z(e)
    );
  }
  function K(e, t) {
    if (!(e instanceof t))
      throw new TypeError('Cannot call a class as a function');
  }
  function J(e, t) {
    for (var i = 0; t.length > i; i++) {
      var n = t[i];
      (n.enumerable = n.enumerable || !1),
        (n.configurable = !0),
        'value' in n && (n.writable = !0),
        Object.defineProperty(e, fe(n.key), n);
    }
  }
  function Y(e, t, i) {
    return (
      t && J(e.prototype, t),
      i && J(e, i),
      Object.defineProperty(e, 'prototype', {
        writable: !1,
      }),
      e
    );
  }
  function Z(e, t, i) {
    return (
      (t = fe(t)) in e
        ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = i),
      e
    );
  }
  function X(e, t) {
    if ('function' != typeof t && null !== t)
      throw new TypeError('Super expression must either be null or a function');
    (e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0,
      },
    })),
      Object.defineProperty(e, 'prototype', {
        writable: !1,
      }),
      t && te(e, t);
  }
  function ee(e) {
    return (
      (ee = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }),
      ee(e)
    );
  }
  function te(e, t) {
    return (
      (te = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (e, t) {
            return (e.__proto__ = t), e;
          }),
      te(e, t)
    );
  }
  function ie(e, t) {
    if (null == e) return {};
    var i,
      n,
      r = (function (e, t) {
        if (null == e) return {};
        var i,
          n,
          r = {},
          o = Object.keys(e);
        for (n = 0; o.length > n; n++)
          0 > t.indexOf((i = o[n])) && (r[i] = e[i]);
        return r;
      })(e, t);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (n = 0; o.length > n; n++)
        0 > t.indexOf((i = o[n])) &&
          Object.prototype.propertyIsEnumerable.call(e, i) &&
          (r[i] = e[i]);
    }
    return r;
  }
  function ne(e) {
    if (void 0 === e)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    return e;
  }
  function re(e) {
    var t = (function () {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;
      try {
        return (
          Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {}),
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    })();
    return function () {
      var i,
        n = ee(e);
      if (t) {
        var r = ee(this).constructor;
        i = Reflect.construct(n, arguments, r);
      } else i = n.apply(this, arguments);
      return (function (e, t) {
        if (t && ('object' == _typeof$1(t) || 'function' == typeof t)) return t;
        if (void 0 !== t)
          throw new TypeError(
            'Derived constructors may only return object or undefined',
          );
        return ne(e);
      })(this, i);
    };
  }
  function oe(e, t) {
    return (
      se(e) ||
      (function (e, t) {
        var i =
          null == e
            ? null
            : ('undefined' != typeof Symbol && e[Symbol.iterator]) ||
              e['@@iterator'];
        if (null != i) {
          var n,
            r,
            o,
            a,
            s = [],
            c = !0,
            u = !1;
          try {
            if (((o = (i = i.call(e)).next), 0 === t)) {
              if (Object(i) !== i) return;
              c = !1;
            } else
              for (
                ;
                !(c = (n = o.call(i)).done) &&
                (s.push(n.value), s.length !== t);
                c = !0
              );
          } catch (e) {
            (u = !0), (r = e);
          } finally {
            try {
              if (!c && null != i.return && ((a = i.return()), Object(a) !== a))
                return;
            } finally {
              if (u) throw r;
            }
          }
          return s;
        }
      })(e, t) ||
      ue(e, t) ||
      de()
    );
  }
  function ae(e) {
    return (
      (function (e) {
        if (Array.isArray(e)) return le(e);
      })(e) ||
      ce(e) ||
      ue(e) ||
      (function () {
        throw new TypeError(
          'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
        );
      })()
    );
  }
  function se(e) {
    if (Array.isArray(e)) return e;
  }
  function ce(e) {
    if (
      ('undefined' != typeof Symbol && null != e[Symbol.iterator]) ||
      null != e['@@iterator']
    )
      return Array.from(e);
  }
  function ue(e, t) {
    if (e) {
      if ('string' == typeof e) return le(e, t);
      var i = Object.prototype.toString.call(e).slice(8, -1);
      return (
        'Object' === i && e.constructor && (i = e.constructor.name),
        'Map' === i || 'Set' === i
          ? Array.from(e)
          : 'Arguments' === i ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
          ? le(e, t)
          : void 0
      );
    }
  }
  function le(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var i = 0, n = Array(t); t > i; i++) n[i] = e[i];
    return n;
  }
  function de() {
    throw new TypeError(
      'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
    );
  }
  function fe(e) {
    var t = (function (e, t) {
      if ('object' != _typeof$1(e) || null === e) return e;
      var i = e[Symbol.toPrimitive];
      if (void 0 !== i) {
        var n = i.call(e, t || 'default');
        if ('object' != _typeof$1(n)) return n;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === t ? String : Number)(e);
    })(e, 'string');
    return 'symbol' == _typeof$1(t) ? t : t + '';
  }
  var pe,
    he,
    ve,
    ge = {
      app_id: '',
      app_key: '',
      env: 'prod',
      region: 'sg',
      region_code: '',
      session_cutting_time: 30,
      sdk_auto_track: !0,
      is_single_page_app: !0,
      is_track_visittime: !0,
      log_level: 'info',
      reported_platforms: ['web'],
      pageview: {
        delay: 100,
        track_pageview_type: 'auto',
        track_ignore: function track_ignore() {
          return !1;
        },
        is_trigger_pageload: !0,
        watch_utm: !0,
        url_alias: {},
      },
      exposure: {
        once: !0,
        duration_threshold: 300,
        intersection_threshold: 1,
        root_margin: '0px',
      },
      develop: {
        catch_js_error: !1,
        performance: !1,
        errorRatio: 0.2,
        errorSplit: 500,
      },
      app_version: '',
      is_cross_subdomain: !1,
      is_print_header: !1,
      event_rule: [],
      event_blacklist: [],
      project: 'default',
      quarantine_report: !1,
    },
    _e = {
      balance: !0,
      flush: !0,
      is_print_header: !1,
      interval_time: 1,
      max_batch_events: 10,
      max_request_queue: 10,
      fail_timeout: 5,
      fail_retry_count: 1,
    };
  !(function (e) {
    (e[(e.INIT = 0)] = 'INIT'),
      (e[(e.FETCH_CONFIG = 1)] = 'FETCH_CONFIG'),
      (e[(e.READY = 2)] = 'READY');
  })(pe || (pe = {})),
    (function (e) {
      (e.TRACK = 'track'),
        (e.DEFERRED = 'deferred'),
        (e.REQUEST = 'request'),
        (e.TRACK_PENDING = 'track-pending');
    })(he || (he = {})),
    (function (e) {
      (e.BALANCE = 'balance'), (e.BALANCE_REQ = 'balance_req');
    })(ve || (ve = {}));
  var me,
    ye = [he.TRACK],
    ke = {
      PageView: {
        eventId: '$page_view',
        eventGroup: '$track_page_view',
      },
      PageDuration: {
        eventId: '$page_duration',
        eventGroup: '$track_page_view',
      },
      PageLoad: {
        eventId: '$page_load',
        eventGroup: '$track_page_load',
      },
      JS_ERROR_CATCH: {
        eventId: '$catch_error',
        eventGroup: '$track_develop',
      },
      TRACK_VERSION: {
        eventId: '$track_version',
        eventGroup: '$track_develop',
      },
      HEATMAP: {
        clickId: '$web_click',
        stayId: '$web_stay',
        eventGroup: '$track_heatmap',
      },
      Sensors: {
        eventId: '$',
        eventGroup: '$track_sensors',
      },
      PERFORMANCE: {},
    };
  !(function (e) {
    (e.DOMESTIC = 'https://static-common.heytapdownload.com'),
      (e.FOREIGN = 'https://static-common.heytapdl.com'),
      (e.INTRANET = 'https://static-common.oppoer.me'),
      (e.FILES_COMMON = 'common-files');
  })(me || (me = {}));
  var we = {
      utm: [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
      ],
      search: [
        'www.baidu.',
        'm.baidu.',
        'm.sm.cn',
        'so.com',
        'sogou.com',
        'youdao.com',
        'google.',
        'yahoo.com/',
        'bing.com/',
        'ask.com/',
      ],
      social: [
        'weibo.com',
        'renren.com',
        'kaixin001.com',
        'douban.com',
        'qzone.qq.com',
        'zhihu.com',
        'tieba.baidu.com',
        'weixin.qq.com',
      ],
      keyword: {
        baidu: ['wd', 'word', 'kw', 'keyword'],
        google: ['q'],
        bing: ['q'],
        yahoo: ['p'],
        sogou: ['query', 'keyword'],
        so: ['q'],
        sm: ['q'],
      },
    },
    be = function be(e) {
      return (
        'object' === z(e) && (e = JSON.stringify(e)),
        btoa(
          encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, function (e, t) {
            return String.fromCharCode('0x' + t);
          }),
        )
      );
    },
    Te = function Te(t) {
      var i,
        n,
        r = {
          domestic: ''
            .concat(me.DOMESTIC, '/')
            .concat(me.FILES_COMMON, '/')
            .concat(t),
          foreign: ''
            .concat(me.FOREIGN, '/')
            .concat(me.FILES_COMMON, '/')
            .concat(t),
          intranet: ''
            .concat(me.INTRANET, '/')
            .concat(me.FILES_COMMON, '/')
            .concat(t),
        },
        o = new CloudEnvDetector(
          ((n =
            (null === (i = location) || void 0 === i ? void 0 : i.hostname) ||
            ''),
          !!(
            /\.example$/.test(n) ||
            'localhost' === n ||
            /\.wanyol\.com$/.test(n) ||
            -1 !== n.indexOf('test') ||
            -1 !== n.indexOf('dev') ||
            /^\d+(?:.\d+){3}$/.test(n)
          )),
        );
      return 'zh-CN' === navigator.language
        ? o.isInCloud()
          ? r.intranet
          : r.domestic
        : o.isInCloud()
        ? r.intranet
        : r.foreign;
    },
    Ie = function Ie(e) {
      if (!e) return e;
      var t = atob(e)
        .split('')
        .map(function (e) {
          return '%' + ('00' + e.charCodeAt(0).toString(16)).slice(-2);
        });
      return decodeURIComponent(t.join(''));
    },
    Se = function Se(e, i) {
      var n =
        arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 'SG';
      i = i || {};
      var r = countryToRegion(n).toUpperCase(),
        o = (i['AreaCode_'.concat(r)] || '').trim();
      return e
        ? e[n.toUpperCase()] || e[r] || o
        : o || 'https://obus-sg.dc.heytapmobile.com';
    },
    Ee = function Ee(e, t, i) {
      return e.replace('$HOST', t).replace('$APPID', i);
    },
    Ce = {
      interval_time: [1, 0, 15],
      max_batch_events: [3, 0, 15],
      fail_timeout: [30, 0, 90],
      fail_retry_count: [1, 0, 3],
    };
  function $e(e, t) {
    for (var i in e)
      if (e.hasOwnProperty(i)) {
        if ('number' != typeof e[i]) continue;
        var n = +e[i],
          r = t[i];
        if (-1 === n || void 0 === r) continue;
        'number' == typeof r[0] &&
          (null == r[1] && (r[1] = -1 / 0), void 0 === r[2] && (r[1] = 1 / 0)),
          (r[1] > n || n > r[2]) && (n = +r[0]),
          (e[i] = n);
      }
    return e;
  }
  var Ae = function Ae(e) {
      var t, i, s, c, u;
      if (
        (removeAttr(e, ['balance', 'flush', 'event_rule', 'event_blacklist']),
        (u = merge(!0, e)),
        !e.app_id || !e.app_key || '**' == e.app_id)
      )
        return console.error('app_id, app_key为空或者不合法'), [!1, ''];
      if (
        ((e.env && ['test', 'pre', 'prod'].includes(e.env)) || (u.env = 'prod'),
        (e.region &&
          ['sg', 'cn', 'in', 'eu', 'us'].includes(e.region.toLowerCase())) ||
          (Logger.warn(
            '当前region为：'.concat(
              e.region,
              ',请填写正确的region，如：sg,cn,in,eu,us中的一个',
            ),
          ),
          (u.region = 'sg')),
        'number' != typeof e.interval_time ||
          (15 >= e.interval_time && e.interval_time > 0) ||
          (u.interval_time = 1),
        'number' == typeof e.max_batch_events &&
          (e.max_batch_events > 20 || 0 > e.max_batch_events) &&
          (u.max_batch_events = 3),
        'number' == typeof e.max_request_queue &&
          (e.max_request_queue > 20 || 0 > e.max_request_queue) &&
          (u.max_request_queue = 10),
        (u.session_cutting_time > 150 || 20 > u.session_cutting_time) &&
          (u.session_cutting_time = 30),
        TypeChecks.isArray(
          null === (t = e.pageview) || void 0 === t ? void 0 : t.track_ignore,
        ))
      ) {
        var l,
          d =
            null === (l = e.pageview) || void 0 === l ? void 0 : l.track_ignore;
        u.pageview.track_ignore = function (e) {
          return 0 !== d.length && -1 !== d.indexOf(e.pathname);
        };
      }
      'number' ==
        typeof (null === (i = e.pageview) || void 0 === i ? void 0 : i.delay) &&
        (null === (s = e.pageview) || void 0 === s ? void 0 : s.delay) > 5e3 &&
        0 > (null === (c = e.pageview) || void 0 === c ? void 0 : c.delay) &&
        (e.pageview.delay = 10);
      var f = function f() {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        return {
          catch_js_error: e,
          performance: e,
          errorRatio: 0.2,
          errorSplit: 500,
        };
      };
      return (
        'boolean' == typeof e.develop && e.develop
          ? (u.develop = f(!0))
          : 'boolean' == typeof e.develop || e.develop || (u.develop = f()),
        (u.develop = merge(!0, f(), e.develop)),
        [!0, u]
      );
    },
    De = function De(e) {
      if (!e)
        return {
          event_rule: [],
          event_blacklist: [],
          business: {},
        };
      (e.event_rule = (null == e ? void 0 : e.event_rule) || []),
        (e.event_blacklist = (null == e ? void 0 : e.event_blacklist) || []);
      var t = pickByCb(null == e ? void 0 : e.business, function (e) {
        return -1 !== e;
      });
      return (e.business = $e(t, Ce)), e;
    },
    Oe = {},
    Ne = (function () {
      function e() {
        K(this, e);
      }
      return (
        Y(e, null, [
          {
            key: 'init',
            value: function value(t, i) {
              var n, r, a;
              this.oTrack = i;
              var s = oe(Ae(t), 2),
                l = s[0],
                d = s[1];
              if (this._conf) Logger.warn('基础配置不能重复初始化, 请检查');
              else if (l && 'string' != typeof d) {
                'prod' === d.env && LoggerFactory.disableAllLog(),
                  d.log_level && LoggerFactory.setLogLevel(d.log_level),
                  Logger.info(
                    '当前埋点SDK版本'
                      .concat(
                        null === (n = e.pkgInfo) || void 0 === n
                          ? void 0
                          : n.version,
                        ', 当前云控SDK版本',
                      )
                      .concat(v$1),
                  ),
                  Logger.info('用户配置', t),
                  (this._conf = recursive(!0, _e, ge, d));
                var f = 'AreaCode_',
                  p = 'https://',
                  h = '.heytapmobile.com',
                  v = 'https://obus-dct-cn.heytapmobi.com';
                (this.cfg = {
                  upload_host:
                    'prod' === d.env
                      ? ((r = {}),
                        Z(
                          r,
                          ''.concat(f, 'CN'),
                          ''.concat(p, 'obus-cn.dc.heytapmobi.com'),
                        ),
                        Z(
                          r,
                          ''.concat(f, 'IN'),
                          ''.concat(p, 'obus-in.dc').concat(h),
                        ),
                        Z(
                          r,
                          ''.concat(f, 'SG'),
                          ''.concat(p, 'obus-sg.dc').concat(h),
                        ),
                        Z(
                          r,
                          ''.concat(f, 'EU'),
                          ''.concat(p, 'obus-dc-eu').concat(h),
                        ),
                        Z(
                          r,
                          ''.concat(f, 'US'),
                          ''.concat(p, 'obus-dc-us').concat(h),
                        ),
                        r)
                      : ((a = {}),
                        Z(a, ''.concat(f, 'CN'), v),
                        Z(a, ''.concat(f, 'IN'), v),
                        Z(a, ''.concat(f, 'SG'), v),
                        Z(a, ''.concat(f, 'EU'), v),
                        Z(a, ''.concat(f, 'US'), v),
                        a),
                }),
                  (this.uploadHost = Se('', this.cfg.upload_host, d.region)),
                  this.fetchCloudConfig(d);
              } else Logger.error(d);
            },
          },
          {
            key: 'fetchCloudConfig',
            value: function value(e) {
              var t = this,
                i = this.pkgInfo.version,
                n = +i.split('.')[0] > 1 ? +i.split('.')[0] : 1,
                r = 'TrackGlobalWeb'.concat(n),
                a = 'BUSINESS_WEB_'.concat(e.app_id, '_CONFIG');
              ('pre' !== e.env && 'test' !== e.env) ||
                (r = ''.concat(r, '_').concat(e.env)),
                (this.readyState = pe.FETCH_CONFIG),
                (this.uploadHost = Se('', this.cfg.upload_host, e.region)),
                (this.cloudAppConfig = new w$1({
                  env:
                    e.env && 'prod' === e.env.toLowerCase() ? 'prod' : 'test',
                  productId: 'compass_'.concat(e.app_id),
                  countryCode: e.region,
                  expires: 'prod' === e.env ? '3h' : '30s',
                  condition: {
                    regionCode:
                      'eu' === e.region.toLowerCase() ? 'EUEX' : e.region,
                  },
                })),
                w$1.multiFetch(
                  [
                    function (e) {
                      return t.cloudAppConfig.fetch([a], e);
                    },
                  ],
                  {
                    success: function success(i) {
                      var n,
                        r,
                        s,
                        c =
                          null === (n = i['compass_'.concat(e.app_id)][a]) ||
                          void 0 === n
                            ? void 0
                            : n.content,
                        f =
                          (null === (r = c) || void 0 === r
                            ? void 0
                            : r.domain) || '';
                      Logger.debug('应用ID:' + e.app_id, '应用配置', c),
                        c ||
                          Logger.error(
                            '云控配置拉取异常',
                            '请你先在OBus创建类型为web的应用, 有问题请联系80252692, 80346696',
                          );
                      var p,
                        h =
                          null === (s = c = De(c)) || void 0 === s
                            ? void 0
                            : s.business,
                        v = c || {
                          event_rule: [],
                          event_blacklist: [],
                        },
                        g = recursive(
                          !0,
                          _e,
                          ge,
                          e,
                          {
                            appDomain: f,
                            event_rule: v.event_rule,
                            event_blacklist: v.event_blacklist,
                          },
                          h,
                        ),
                        _ = store('host') || '';
                      if (
                        '' ===
                          (p =
                            (function () {
                              var e = window.location.host;
                              return (
                                e.indexOf('localhost') >= 0 ||
                                e.indexOf('.example') >= 0 ||
                                e.indexOf('.wanyol.com') >= 0 ||
                                /\d+(.\d+)+/.test(e)
                              );
                            })() && '' !== _
                              ? _
                              : Se(f, t.cfg.upload_host, g.region)) ||
                        !/^https?:\/\//.test(p)
                      )
                        return (
                          Logger.error(
                            '云控配置',
                            p,
                            '上报域名不合法, 请联系OBus',
                          ),
                          !1
                        );
                      UrlListener.init(
                        g.is_single_page_app,
                        [],
                        g.pageview.track_ignore,
                      ),
                        (t.uploadHost = p),
                        (t.readyState = pe.READY),
                        (t._conf = g),
                        t.consumeListeners(),
                        Logger.debug(
                          '应用ID:' + g.app_id,
                          'host: '.concat(p),
                          '埋点配置',
                          g,
                        );
                    },
                    fail: function fail(e, i) {
                      Logger.error('应用ID:' + e.app_id, '拉取云配置失败'),
                        (t.readyState = pe.INIT);
                    },
                  },
                );
            },
          },
          {
            key: 'registerCallbacks',
            value: function value(e) {
              this.isReady()
                ? (this.listeners.push(e), this.consumeListeners())
                : this.listeners.push(e);
            },
          },
          {
            key: 'setPkgInfo',
            value: function value(e) {
              this.pkgInfo = e;
            },
          },
          {
            key: 'getPkgInfo',
            value: function value() {
              return this.pkgInfo;
            },
          },
          {
            key: 'config',
            get: function get() {
              if (!this._conf) throw Error('配置没有初始化');
              return this._conf;
            },
          },
          {
            key: 'isReady',
            value: function value() {
              return this.readyState === pe.READY;
            },
          },
          {
            key: 'consumeListeners',
            value: function value() {
              var e = this;
              this.listeners.forEach(function (t) {
                TypeChecks.isFunction(t) && t(e._conf);
              }),
                (this.listeners = []);
            },
          },
        ]),
        e
      );
    })();
  (Ne._conf = void 0),
    (Ne.pkgInfo = void 0),
    (Ne.readyState = pe.INIT),
    (Ne.cloudGlobalConfig = void 0),
    (Ne.cloudAppConfig = void 0),
    (Ne.listeners = []),
    (Ne.uploadHost = ''),
    (Ne.oTrack = void 0),
    (Ne.cfg = void 0);
  var Pe,
    je,
    Re,
    xe,
    Le = ['stack', 'message'];
  function Me(e, t) {
    var i = window.onerror;
    (window.onerror = function (n, r, o, a, s) {
      if (!t().catch_js_error) return !1;
      var c = 0 > t().errorRatio || t().errorRatio > 1 ? 0.2 : t().errorRatio;
      if (Pe) {
        if (1 > (Date.now() - Pe) / 6e4) {
          if (Math.random() - c > c) return;
          Pe = Date.now();
        }
      } else Pe = Date.now();
      var u = n;
      s &&
        s.stack &&
        (u = (function (e) {
          var t = (e.stack || '')
              .replace(/\n/gi, '')
              .split(/\bat\b/)
              .slice(0, 9)
              .join('@')
              .replace(/\?[^:]+/gi, ''),
            i = '' + e;
          return 0 > t.indexOf(i) && (t = i + '@' + t), t;
        })(s)),
        e({
          msg: u,
          target: r,
          rowNum: o,
          colNum: a,
          orgMsg: n,
          level: 4,
        }),
        i && i.apply(window, arguments);
    }),
      window.addEventListener('unhandledrejection', function (i) {
        if ((i.preventDefault(), !t().catch_js_error)) return !1;
        var n = i.reason;
        if (i && i.reason)
          try {
            (n = (function (e) {
              if ('string' == typeof e) return e;
              try {
                return JSON.stringify(e, Le);
              } catch (e) {
                return 'error happen when stringify: \n '
                  .concat(e.message, '\n ')
                  .concat(e.stack);
              }
            })(i.reason)),
              console.error(n);
          } catch (e) {
            console.error('[oReport] stringify error'), console.error(e);
          }
        e({
          msg: n || 'unhandledrejection',
          target: 'unhandledrejection',
          rowNum: 0,
          colNum: 0,
          level: 4,
        });
      });
  }
  function qe(e) {
    return new qe.init(e);
  }
  function He(e, t) {
    return e.indexOf(t);
  }
  function Ue(e, t) {
    return e.hasAttribute
      ? e.hasAttribute(t)
      : e.attributes
      ? !(!e.attributes[t] || !e.attributes[t].specified)
      : void 0;
  }
  function Fe(e, t) {
    if ('string' == typeof t) return Ue(e, t);
    if (TypeChecks.isArray(t)) {
      for (var i = !1, n = 0; t.length > n; n++) {
        if (Ue(e, t[n])) {
          i = !0;
          break;
        }
      }
      return i;
    }
  }
  function Ve(e, t, i) {
    function n(e, t, i) {
      var n = null;
      if (
        ((e = e || {}).ele && (n = e.ele),
        e.event && (n = e.target ? e.target : e.event.target),
        (i = i || {}),
        !n || 'object' !== z(n))
      )
        return !1;
      if (
        !n.href ||
        /^javascript/.test(n.href) ||
        n.target ||
        n.download ||
        n.onclick
      )
        return je(t, i), !1;
      function r(e) {
        e.stopPropagation(), e.preventDefault();
        var r = !1;
        function o() {
          r || ((r = !0), (location.href = n.href));
        }
        setTimeout(o, 1e3), je(t, i, o);
      }
      e.event && r(e.event),
        e.ele &&
          EventUtils.EventUtils(e.ele, 'click', function (e) {
            r(e);
          });
    }
    'object' === z(e) && e.tagName
      ? n(
          {
            ele: e,
          },
          t,
          i,
        )
      : 'object' === z(e) && e.target && e.event && n(e, t, i);
  }
  function Ge(e) {
    if (!e.target) return !1;
    var t = e.target,
      i = t.tagName.toLowerCase(),
      n = {};
    return (
      (n.$element_type = i),
      (n.$element_name = t.getAttribute('name')),
      (n.$element_id = t.getAttribute('id')),
      (n.$element_class_name =
        'string' == typeof t.className ? t.className : null),
      (n.$element_target_url = t.getAttribute('href')),
      (n.$element_content = (function (e, t) {
        var i = '',
          n = '';
        e.textContent
          ? (i = trim(e.textContent))
          : e.innerText && (i = trim(e.innerText));
        i &&
          (i = i
            .replace(/[\r\n]/g, ' ')
            .replace(/[ ]+/g, ' ')
            .substring(0, 255));
        (n = i || ''),
          ('input' === t || 'INPUT' === t) &&
            ('button' === e.type ||
              'submit' === e.type ||
              (Re &&
                'function' == typeof Re.collect_input &&
                Re.collect_input(e))) &&
            (n = e.value || '');
        return n;
      })(t, i)),
      (n = stripsEmptyAttrs(n))
    );
  }
  (qe.init = function (e) {
    this.ele = e;
  }).prototype = {
    addClass: function addClass(e) {
      return (
        -1 === (' ' + this.ele.className + ' ').indexOf(' ' + e + ' ') &&
          (this.ele.className =
            this.ele.className + ('' === this.ele.className ? '' : ' ') + e),
        this
      );
    },
    removeClass: function removeClass(e) {
      var t = ' ' + this.ele.className + ' ';
      return (
        -1 !== t.indexOf(' ' + e + ' ') &&
          (this.ele.className = t.replace(' ' + e + ' ', ' ').slice(1, -1)),
        this
      );
    },
    hasClass: function hasClass(e) {
      return -1 !== (' ' + this.ele.className + ' ').indexOf(' ' + e + ' ');
    },
    attr: function attr(e, t) {
      return 'string' == typeof e && isUndefined(t)
        ? this.ele.getAttribute(e)
        : ('string' == typeof e && this.ele.setAttribute(e, (t += '')), this);
    },
    offset: function offset() {
      var e = this.ele.getBoundingClientRect();
      if (e.width || e.height) {
        var t = this.ele.ownerDocument.documentElement;
        return {
          top: e.top + window.pageYOffset - t.clientTop,
          left: e.left + window.pageXOffset - t.clientLeft,
        };
      }
      return {
        top: 0,
        left: 0,
      };
    },
    getSize: function getSize() {
      if (!window.getComputedStyle)
        return {
          width: this.ele.offsetWidth,
          height: this.ele.offsetHeight,
        };
      try {
        var e = this.ele.getBoundingClientRect();
        return {
          width: e.width,
          height: e.height,
        };
      } catch (e) {
        return {
          width: 0,
          height: 0,
        };
      }
    },
    getStyle: function getStyle(e) {
      return this.ele.currentStyle
        ? this.ele.currentStyle[e]
        : this.ele.ownerDocument.defaultView
            .getComputedStyle(this.ele, null)
            .getPropertyValue(e);
    },
    wrap: function wrap(e) {
      var t,
        i =
          null === (t = document) || void 0 === t ? void 0 : t.createElement(e);
      return (
        this.ele.parentNode.insertBefore(i, this.ele),
        i.appendChild(this.ele),
        qe(i)
      );
    },
    getCssStyle: function getCssStyle(e) {
      var t = this.ele.style.getPropertyValue(e);
      if (t) return t;
      var i = null;
      if (
        ('function' == typeof window.getMatchedCSSRules &&
          (i = window.getMatchedCSSRules(this.ele)),
        !i || !isArray(i))
      )
        return null;
      for (var n = i.length - 1; n >= 0; n--) {
        if ((t = i[n].style.getPropertyValue(e))) return t;
      }
    },
    sibling: function sibling(e, t) {
      for (; (e = e[t]) && 1 !== e.nodeType; );
      return e;
    },
    next: function next() {
      return this.sibling(this.ele, 'nextSibling');
    },
    prev: function prev() {
      return this.sibling(this.ele, 'previousSibling');
    },
    siblings: function siblings() {
      return this.siblings((this.ele.parentNode || {}).firstChild, this.ele);
    },
    children: function children() {
      return this.siblings(this.ele.firstChild);
    },
    parent: function parent() {
      var e = this.ele.parentNode;
      return (e = e && 11 !== e.nodeType ? e : null), qe(e);
    },
    previousElementSibling: function previousElementSibling() {
      var e = this.ele;
      if ('previousElementSibling' in document.documentElement)
        return qe(e.previousElementSibling);
      for (; (e = e.previousSibling); ) if (1 === e.nodeType) return qe(e);
      return qe(null);
    },
    getSameTypeSiblings: function getSameTypeSiblings() {
      for (
        var e = this.ele,
          t = e.parentNode,
          i = e.tagName.toLowerCase(),
          n = [],
          r = 0;
        t.children.length > r;
        r++
      ) {
        var o = t.children[r];
        1 === o.nodeType &&
          o.tagName.toLowerCase() === i &&
          n.push(t.children[r]);
      }
      return n;
    },
    getParents: function getParents() {
      try {
        var e = this.ele;
        if (!isElement(e)) return [];
        var t = [e];
        if (null === e || null === e.parentElement) return [];
        for (; null !== e.parentElement; ) t.push((e = e.parentElement));
        return t;
      } catch (e) {
        return [];
      }
    },
  };
  var Qe = {
    otherTags: [],
    getTargetElement: function getTargetElement(e, t) {
      var i = e;
      if ('object' !== z(i)) return null;
      if ('string' != typeof i.tagName) return null;
      var n = i.tagName.toLowerCase();
      if ('body' === n.toLowerCase() || 'html' === n.toLowerCase()) return null;
      if (!i || !i.parentNode || !i.parentNode.children) return null;
      var r = i.parentNode,
        o = this.hasElement(
          {
            event: (t && t.originalEvent) || t,
            element: e,
          },
          function (e) {
            return 'a' === e.tagName.toLowerCase() || Fe(e, Re.track_attr);
          },
        );
      if ('a' === n || 'button' === n || 'input' === n || 'textarea' === n)
        return i;
      if (He(this.otherTags, n) > -1) return i;
      if (
        'button' === r.tagName.toLowerCase() ||
        'a' === r.tagName.toLowerCase()
      )
        return r;
      if (
        'area' === n &&
        'map' === r.tagName.toLowerCase() &&
        qe(r).prev().tagName &&
        'img' === qe(r).prev().tagName.toLowerCase()
      )
        return qe(r).prev();
      if (o) return o;
      if ('div' === n && Re.collect_tags.div && this.isDivLevelValid(i))
        return ((Re &&
          Re.collect_tags &&
          Re.collect_tags.div &&
          Re.collect_tags.div.max_level) ||
          1) > 1 || this.isCollectableDiv(i)
          ? i
          : null;
      if (this.isStyleTag(n) && Re.collect_tags.div) {
        var a = this.getCollectableParent(i);
        if (a && this.isDivLevelValid(a)) return a;
      }
      return null;
    },
    getDivLevels: function getDivLevels(e, t) {
      return Qe.getElementPath(e, !0, t)
        .split(' > ')
        .filter(function (e) {
          return 'div' === e;
        }).length;
    },
    isDivLevelValid: function isDivLevelValid(e) {
      for (
        var t =
            (Re &&
              Re.collect_tags &&
              Re.collect_tags.div &&
              Re.collect_tags.div.max_level) ||
            1,
          i = e.getElementsByTagName('div'),
          n = i.length - 1;
        n >= 0;
        n--
      )
        if (Qe.getDivLevels(i[n], e) > t) return !1;
      return !0;
    },
    getElementPath: function getElementPath(e, t, i) {
      for (var n = []; e.parentNode; ) {
        if (e.id && !t && /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.id)) {
          n.unshift(e.tagName.toLowerCase() + '#' + e.id);
          break;
        }
        if (i && e === i) {
          n.unshift(e.tagName.toLowerCase());
          break;
        }
        if (e === document.body) {
          n.unshift('body');
          break;
        }
        n.unshift(e.tagName.toLowerCase()), (e = e.parentNode);
      }
      return n.join(' > ');
    },
    getClosestLi: function getClosestLi(e) {
      return (function (e, t) {
        for (; e && e !== document && 1 === e.nodeType; e = e.parentNode)
          if (e.tagName.toLowerCase() === t) return e;
        return null;
      })(e, 'li');
    },
    getElementPosition: function getElementPosition(e, t, i) {
      var n = Qe.getClosestLi(e);
      if (!n) return null;
      var r = e.tagName.toLowerCase(),
        o = n.getElementsByTagName(r),
        a = o.length,
        s = [];
      if (a > 1) {
        for (var c = 0; a > c; c++) {
          Qe.getElementPath(o[c], i) === t && s.push(o[c]);
        }
        if (s.length > 1) return He(s, e);
      }
      return (function (e) {
        if (!e.parentNode) return '';
        if (1 === qe(e).getSameTypeSiblings().length) return 0;
        for (var t = 0, i = e; (i = qe(i).previousElementSibling().ele); ) t++;
        return t;
      })(n);
    },
    getDomIndex: function getDomIndex(e) {
      if (!e.parentNode) return -1;
      for (
        var t = 0, i = e.tagName, n = e.parentNode.children, r = 0;
        n.length > r;
        r++
      )
        if (n[r].tagName === i) {
          if (e === n[r]) return t;
          t++;
        }
      return -1;
    },
    selector: function selector(e, t) {
      var i =
        e.parentNode && 9 == +e.parentNode.nodeType ? -1 : this.getDomIndex(e);
      return e.getAttribute &&
        e.getAttribute('id') &&
        /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.getAttribute('id')) &&
        (!Re || (Re && 'not_use_id' !== Re.element_selector)) &&
        !t
        ? '#' + e.getAttribute('id')
        : e.tagName.toLowerCase() + (~i ? ':nth-of-type(' + (i + 1) + ')' : '');
    },
    getDomSelector: function getDomSelector(e, t, i) {
      if (!e || !e.parentNode || !e.parentNode.children) return !1;
      t = t && t.join ? t : [];
      var n = e.nodeName.toLowerCase();
      return e && 'body' !== n && 1 === e.nodeType
        ? (t.unshift(this.selector(e, i)),
          e.getAttribute &&
          e.getAttribute('id') &&
          /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.getAttribute('id')) &&
          Re &&
          'not_use_id' !== Re.element_selector &&
          !i
            ? t.join(' > ')
            : this.getDomSelector(e.parentNode, t, i))
        : (t.unshift('body'), t.join(' > '));
    },
    getEleDetail: function getEleDetail(e) {
      var t = this.getDomSelector(e),
        i = Ge({
          target: e,
        });
      (i.$element_selector = t || ''),
        (i.$element_path = Qe.getElementPath(
          e,
          Re && 'not_use_id' === Re.element_selector,
        ));
      var n = Qe.getElementPosition(
        e,
        i.$element_path,
        Re && 'not_use_id' === Re.element_selector,
      );
      return 'number' == typeof n && (i.$element_position = n), i;
    },
    start: function start(e, t, i, n, r) {
      var o = TypeChecks.isObject(n) ? n : {},
        s = TypeChecks.isFunction(r)
          ? r
          : TypeChecks.isFunction(n)
          ? n
          : void 0;
      if (!TypeChecks.isObject(Re) || 'default' !== Re.clickmap) return !1;
      if (Re && Re.collect_element && !Re.collect_element(t)) return !1;
      var c = this.getEleDetail(t);
      if (Qe && Re.custom_property) {
        var l = Re.custom_property(t);
        TypeChecks.isObject(l) && (c = recursive(!0, c, l));
      }
      (c = recursive(!0, c, o)),
        'a' === i && Qe && !0 === Qe.isTrackLink
          ? Ve(
              {
                event: e,
                target: t,
              },
              ke.HEATMAP.clickId,
              c,
            )
          : je(ke.HEATMAP.clickId, c, s);
    },
    hasElement: function hasElement(e, t) {
      var i;
      if (e.event) {
        var n = e.event;
        i = n.path || (n._getPath && n._getPath());
      } else e.element && (i = qe(e.element).getParents());
      if (i && TypeChecks.isArray(i) && i.length > 0)
        for (var r = 0; i.length > r; r++)
          if ('object' === z(i[r]) && 1 === i[r].nodeType && t(i[r]))
            return i[r];
    },
    isStyleTag: function isStyleTag(e, t) {
      return (
        -1 >= He(['a', 'div', 'input', 'button', 'textarea'], e) &&
        (!t || (Re && Re.collect_tags && Re.collect_tags.div)
          ? !!(
              TypeChecks.isObject(Qe) &&
              TypeChecks.isObject(Re.collect_tags) &&
              TypeChecks.isObject(Re.collect_tags.div) &&
              TypeChecks.isArray(Re.collect_tags.div.ignore_tags) &&
              He(Re.collect_tags.div.ignore_tags, e) > -1
            )
          : He(
              [
                'mark',
                '/mark',
                'strong',
                'b',
                'em',
                'i',
                'u',
                'abbr',
                'ins',
                'del',
                's',
                'sup',
              ],
              e,
            ) > -1)
      );
    },
    isCollectableDiv: function isCollectableDiv(e, t) {
      try {
        if (0 === e.children.length) return !0;
        for (var i = 0; e.children.length > i; i++)
          if (1 === e.children[i].nodeType) {
            var n = e.children[i].tagName.toLowerCase();
            if (
              !(
                ('div' === n &&
                  (Re &&
                    Re.collect_tags &&
                    Re.collect_tags.div &&
                    Re.collect_tags.div.max_level) > 1) ||
                this.isStyleTag(n, t)
              )
            )
              return !1;
            if (!this.isCollectableDiv(e.children[i], t)) return !1;
          }
        return !0;
      } catch (e) {
        xe.error(e);
      }
      return !1;
    },
    getCollectableParent: function getCollectableParent(e, t) {
      try {
        var i = e.parentNode,
          n = i ? i.tagName.toLowerCase() : '';
        if ('body' === n) return !1;
        if (
          n &&
          'div' === n &&
          ((Re &&
            Re.collect_tags &&
            Re.collect_tags.div &&
            Re.collect_tags.div.max_level) > 1 ||
            this.isCollectableDiv(i, t))
        )
          return i;
        if (i && this.isStyleTag(n, t)) return this.getCollectableParent(i, t);
      } catch (e) {
        xe.error(e);
      }
      return !1;
    },
    initScrollMap: function initScrollMap() {
      if (!TypeChecks.isObject(Re) || 'default' !== Re.scroll_notice_map)
        return !1;
      var e = (function (e) {
        var t = {};
        return (
          (t.timeout = e.timeout || 1e3),
          (t.func = e.func),
          (t.hasInit = !1),
          (t.inter = null),
          (t.main = function (e, t) {
            this.func(e, t), (this.inter = null);
          }),
          (t.current_time = new Date()),
          (t.go = function (e) {
            var i = {};
            if (
              !(Re && TypeChecks.isFunction(Re.collect_url) && Re.collect_url())
            )
              return !1;
            this.inter ||
              ((i.$viewport_position =
                (document.documentElement &&
                  document.documentElement.scrollTop) ||
                window.pageYOffset ||
                document.body.scrollTop ||
                0),
              (i.$viewport_position = Math.round(i.$viewport_position) || 0),
              (i.$viewport_height =
                window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight ||
                0),
              (i.$viewport_width =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth ||
                0),
              e
                ? t.main(i, !0)
                : (this.inter = setTimeout(function () {
                    t.main(i);
                  }, this.timeout)));
          }),
          t
        );
      })({
        timeout: 1e3,
        func: function func(e, t) {
          var i =
              (document.documentElement &&
                document.documentElement.scrollTop) ||
              window.pageYOffset ||
              document.body.scrollTop ||
              0,
            n = new Date(),
            r = n - this.current_time;
          ((r > Re.scroll_delay_time && i - e.$viewport_position != 0) || t) &&
            ((e.event_duration = Math.min(
              Re.scroll_event_duration,
              parseInt(r) / 1e3,
            )),
            (e.event_duration = 0 > e.event_duration ? 0 : e.event_duration),
            je(ke.HEATMAP.stayId, e)),
            (this.current_time = n);
        },
      });
      EventUtils.addEvent(window, 'scroll', function () {
        e.go();
      }),
        EventUtils.addEvent(window, 'unload', function () {
          e.go('notime');
        });
    },
    initHeatmap: function initHeatmap() {
      var e = this;
      return (
        !(!TypeChecks.isObject(Re) || 'default' !== Re.clickmap) &&
        !(TypeChecks.isFunction(Re.collect_url) && !Re.collect_url()) &&
        ((Re.collect_elements =
          'all' === Re.collect_elements ? 'all' : 'interact'),
        void EventUtils.addEvent(
          document,
          'click',
          'all' === Re.collect_elements
            ? function (t) {
                var i = t || window.event;
                if (!i) return !1;
                var n = i.target || i.srcElement;
                if ('object' !== z(n)) return !1;
                if ('string' != typeof n.tagName) return !1;
                var r = n.tagName.toLowerCase();
                if ('body' === r || 'html' === r) return !1;
                if (!n || !n.parentNode || !n.parentNode.children) return !1;
                var o = n.parentNode.tagName.toLowerCase();
                'a' === o || 'button' === o
                  ? e.start(i, n.parentNode, o)
                  : e.start(i, n, r);
              }
            : function (t) {
                var i = t || window.event;
                if (!i) return !1;
                var n = e.getTargetElement(i.target || i.srcElement, t);
                n && e.start(i, n, n.tagName.toLowerCase());
              },
        ))
      );
    },
  };
  var Be = {
      trackHeatMap: function trackHeatMap(e, t, i) {
        if ('object' === z(e) && e.tagName) {
          var n = e.tagName.toLowerCase(),
            r = e.parentNode.tagName.toLowerCase();
          'button' === n ||
            'a' === n ||
            'a' === r ||
            'button' === r ||
            'input' === n ||
            'textarea' === n ||
            Fe(e, Re && Re.track_attr ? Re.track_attr : ['data-obus-click']) ||
            Qe.start(null, e, n, t, i);
        }
      },
      trackAllHeatMap: function trackAllHeatMap(e, t, i) {
        if ('object' === z(e) && e.tagName) {
          var n = e.tagName.toLowerCase();
          Qe.start(null, e, n, t, i);
        }
      },
      trackLink: Ve,
    },
    We = Qe.getEleDetail.bind(Qe);
  function ze(e, t, i, n) {
    return e
      ? ('string' == typeof i && z(e[t]) !== i && (e[t] = n),
        'function' != typeof i || i(e[t]) || (e[t] = n),
        e)
      : e;
  }
  function Ke(e) {
    var t = merge(!0, e),
      i = 'default',
      n = 'not_collect';
    for (var o in (!0 === e && ((t.clickmap = !0), (t.scroll_notice_map = !0)),
    'boolean' == typeof t.clickmap && (t.clickmap = t.clickmap ? i : n),
    ze(
      t,
      'clickmap',
      function (e) {
        return e === i;
      },
      n,
    ),
    'boolean' == typeof t.scroll_notice_map &&
      (t.scroll_notice_map = t.scroll_notice_map ? i : n),
    ze(
      t,
      'scroll_notice_map',
      function (e) {
        return e === i;
      },
      n,
    ),
    ze(t, 'scroll_delay_time', 'number', 4e3),
    ze(t, 'scroll_event_duration', 'number', 18e3),
    ze(
      t,
      'collect_tags',
      function (e) {
        return TypeChecks.isObject(e);
      },
      {},
    ),
    ze(
      t,
      'track_attr',
      function (e) {
        return TypeChecks.isArray(e);
      },
      ['data-obus-click'],
    ),
    ze(t, 'collect_url', 'function', function () {
      return !0;
    }),
    ze(t, 'collect_element', 'function', function () {
      return !0;
    }),
    ze(t, 'track_collect_input', 'function', function () {
      return !1;
    }),
    ze(
      t,
      'element_selector',
      function (e) {
        return 'not_use_id' === e;
      },
      '',
    ),
    ze(t, 'custom_property', 'function', function () {
      return {};
    }),
    ze(t, 'renderRefreshTime', 'number', 1e3),
    ze(t, 'loadTimeout', 'number', 1e3),
    ze(
      t,
      'get_vtrack_config',
      function (e) {
        return !0 !== e;
      },
      !1,
    ),
    (t.track_attr = t.track_attr.filter(function (e) {
      return e && 'string' == typeof e;
    })),
    !0 === t.collect_tags.div &&
      (t.collect_tags.div = {
        max_level: 1,
        ignore_tags: [
          'mark',
          '/mark',
          'strong',
          'b',
          'em',
          'i',
          'u',
          'abbr',
          'ins',
          'del',
          's',
          'sup',
        ],
      }),
    t.track_attr.push('data-obus-click'),
    t.collect_tags.div &&
      t.collect_tags.div.max_level > 3 &&
      (t.collect_tags.div.max_level = 1),
    t.collect_tags)) {
      'div' !== o && t.collect_tags[o] && Qe.otherTags.push(o);
    }
    return t;
  }
  var Je = function Je(e) {
      var t,
        i = recursive(!0, e, {
          heatmap: Ke(e.heatmap),
        });
      return (
        null === (t = e.logger) || void 0 === t || t.debug(i.heatmap),
        (function (e) {
          (xe = (e = e || {}).logger || console),
            (je = function je(t, i, n) {
              var r = e.dispatch;
              r &&
                r({
                  eventId: t,
                  eventGroup: ke.HEATMAP.eventGroup,
                  properties: i,
                }),
                n && n();
            }),
            (Re = e.heatmap) && je
              ? (Qe.initHeatmap(), Qe.initScrollMap())
              : xe.error('配置项异常');
        })(i)
      );
    },
    Ye = 30,
    Ze = Logger.clone({
      namespace: 'DB读写',
    }),
    Xe = (function () {
      function e() {
        K(this, e),
          (this.getVersion = function () {
            return Date.now();
          });
      }
      return (
        Y(e, [
          {
            key: 'writeTypeStgSafe',
            value: function value(e, t) {
              var i,
                n,
                r = 0;
              do {
                var o = t((i = this.readTypeStg(e)).data);
                if (!1 === o) return i.data;
                (i.data = o || i.data), (n = this.readTypeStg(e));
              } while (n && i.version !== n.version && r++ <= Ye);
              if (r > Ye)
                console.warn('writeTypeStgSafe try count greater than 30');
              else if (i.data === n.data && i.data.length === n.data.length)
                return n.data || [];
              return (
                this.writeTypeStg(e, {
                  data: i.data,
                  version: this.getVersion(),
                }),
                i.data || []
              );
            },
          },
          {
            key: 'writeTypeStgMultiSafe',
            value: function value(e, t) {
              var i = this,
                n = 0,
                r = [],
                o = e.map(function (e) {
                  return i.readTypeStg(e);
                }),
                a = function a() {
                  var t = o && n++ <= Ye * e.length;
                  return (
                    e.forEach(function (e, i) {
                      t = t && o[i].version !== r[i].version;
                    }),
                    t
                  );
                };
              do {
                var s = (r = e.map(function (e) {
                    return i.readTypeStg(e);
                  })).map(function (e) {
                    return e.data;
                  }),
                  c = t.apply(void 0, ae(s));
                if (!1 === c) return !1;
                (r = (c = c || s).map(function (e, t) {
                  return {
                    version: r[t].version,
                    data: e,
                  };
                })),
                  (o = e.map(function (e) {
                    return i.readTypeStg(e);
                  }));
              } while (a());
              n > Ye &&
                console.warn('writeTypeStgSafe try count greater than 30'),
                e.forEach(function (e, t) {
                  i.writeTypeStg(e, {
                    data: r[t].data,
                    version: i.getVersion(),
                  });
                });
            },
          },
          {
            key: 'readTypeStg',
            value: function value(e) {
              var t = store(this.getStgQueueName(e)),
                i = this.getDefValAndType(e);
              if (
                i &&
                TypeChecks.getType(null == t ? void 0 : t.data) !== i[0]
              ) {
                var n = {
                  data: i[1],
                  version: this.getVersion(),
                };
                return this.writeTypeStg(e, n), n;
              }
              return t;
            },
          },
          {
            key: 'readStg',
            value: function value(e) {
              return store(e);
            },
          },
          {
            key: 'writeTypeStg',
            value: function value(e, t) {
              var i = this.getDefValAndType(e);
              return i &&
                i[0] !== TypeChecks.getType(null == t ? void 0 : t.data)
                ? (Ze.error(
                    e,
                    '写入类型'
                      .concat(
                        TypeChecks.getType(null == t ? void 0 : t.data),
                        '和期待类型',
                      )
                      .concat(i[0], '不一致'),
                  ),
                  this.readTypeStg(e),
                  !1)
                : (store(this.getStgQueueName(e), t, !0), !0);
            },
          },
          {
            key: 'writeStg',
            value: function value(e, t) {
              store(e, t, !0);
            },
          },
          {
            key: 'getDefValAndType',
            value: function value(e) {
              return 'balance' === e ? ['Object', {}] : ['Array', []];
            },
          },
          {
            key: 'getStgQueueName',
            value: function value(e) {
              return 'obus-track_'
                .concat(Ne.config.app_id, '/')
                .concat(e, '-queue');
            },
          },
        ]),
        e
      );
    })(),
    et = 'otrack_jssdk_store',
    tt = (function () {
      function e() {
        K(this, e),
          (this.userId = ''),
          (this.appVersion = ''),
          (this.customAttrs = null),
          (this.isWebview = !1),
          (this.region = ''),
          (this.isFirstDay = !1),
          (this.isFirstTime = !1),
          (this.isLogin = !1),
          (this.deviceId = ''),
          this.initStore();
        var t = !1;
        if (readCookie(et)) {
          var i = null;
          try {
            i = deserialize(Ie(readCookie(et)) || 'null');
          } catch (e) {
            try {
              i = deserialize(readCookie(et) || 'null');
            } catch (e) {
              Logger.error('cookies 设备信息获取失败');
            }
          }
          i &&
            ((this.deviceId = i.deviceId || ''),
            (this.userId = i.userId || ''),
            (this.customAttrs = i.customAttrs || {}),
            (this.isLogin = !!this.userId),
            (this.isFirstDay = deserialize(
              readCookie('otrack_jssdk_is_first_day') || 'false',
            )),
            i.deviceId ||
              ((this.deviceId = generateUUID()),
              (this.isFirstTime = !0),
              (this.isFirstDay = !0),
              (t = !0)));
        } else
          '' === this.deviceId &&
            ((this.deviceId = generateUUID()),
            (this.isFirstTime = !0),
            (this.isFirstDay = !0),
            (t = !0));
        if (t) {
          var n = new Date();
          n.setDate(n.getDate() + 1),
            n.setHours(0, 0, 0, 0),
            this.writeStore(),
            createCookie(
              'otrack_jssdk_is_first_day',
              serialize(this.isFirstDay),
              n,
              {
                cross_subdomain: Ne.config.is_cross_subdomain,
              },
            );
        }
      }
      return (
        Y(e, [
          {
            key: 'initStore',
            value: function value() {
              var e = Ne.config.is_cross_subdomain,
                t = readCookie(et),
                i = 'otrack_jssdk_is_first_day',
                n = readCookie(i),
                r = new Date();
              r.setDate(r.getDate() + 1),
                r.setHours(0, 0, 0, 0),
                e
                  ? (createCookie(et, '', -1), createCookie(i, '', -1))
                  : (createCookie(et, '', -1, {
                      cross_subdomain: !0,
                    }),
                    createCookie(i, 'false', -1, {
                      cross_subdomain: !0,
                    }));
              var o = readCookie(et);
              null != t &&
                null == o &&
                (createCookie(et, t, 73e3, {
                  cross_subdomain: e,
                }),
                n &&
                  createCookie(i, n, r, {
                    cross_subdomain: e,
                  }));
            },
          },
          {
            key: 'getCustomHead',
            value: function value() {
              return this.customAttrs || {};
            },
          },
          {
            key: 'getDeviceId',
            value: function value() {
              return this.deviceId;
            },
          },
          {
            key: 'setCustomHead',
            value: function value(e) {
              if (void 0 === e)
                return (this.customAttrs = {}), void this.writeStore();
              if (TypeChecks.isObject(e)) {
                for (var t in e) null == e[t] && (e[t] = '');
                (this.customAttrs = W(W({}, this.customAttrs), e)),
                  this.writeStore();
              } else Logger.error('registerGlobalAttrs的参数必须是属性');
            },
          },
          {
            key: 'setAppVersion',
            value: function value(e) {
              this.appVersion = e || '';
            },
          },
          {
            key: 'getAppVersion',
            value: function value() {
              return this.appVersion || '';
            },
          },
          {
            key: 'setDeviceId',
            value: function value(e) {
              (this.deviceId = e || ''),
                Logger.info(
                  ''
                    .concat(new Date().toLocaleString(), ' setDeviceId: ')
                    .concat(this.deviceId),
                ),
                this.writeStore();
            },
          },
          {
            key: 'setUserId',
            value: function value(e) {
              if ('string' != typeof e)
                return Logger.error('userId的数据类型必需为string');
              (this.userId = e || ''),
                (this.isLogin = !!this.userId),
                Logger.info(
                  ''
                    .concat(new Date().toLocaleString(), ' setUserId: ')
                    .concat(this.userId),
                ),
                this.writeStore();
            },
          },
          {
            key: 'setIsWebview',
            value: function value(e) {
              this.isWebview = !!e;
            },
          },
          {
            key: 'getIsWebview',
            value: function value() {
              return this.isWebview;
            },
          },
          {
            key: 'getUserId',
            value: function value() {
              return this.userId;
            },
          },
          {
            key: 'writeStore',
            value: function value() {
              createCookie(
                et,
                be(
                  serialize({
                    deviceId: this.deviceId,
                    userId: this.userId,
                    customAttrs: this.customAttrs,
                  }),
                ),
                73e3,
                {
                  cross_subdomain: Ne.config.is_cross_subdomain,
                },
              );
            },
          },
          {
            key: 'isFirstDayFromCookies',
            value: function value() {
              var e =
                this.isFirstDay &&
                deserialize(readCookie('otrack_jssdk_is_first_day') || 'null');
              return !e && this.isFirstDay && (this.isFirstDay = !1), e;
            },
          },
        ]),
        e
      );
    })(),
    it = Logger.clone({
      namespace: '对账数据',
      isShowLog: !1,
    }),
    nt = (function (e) {
      X(i, Xe);
      var t = re(i);
      function i() {
        var e;
        K(this, i);
        for (var n = arguments.length, r = Array(n), o = 0; n > o; o++)
          r[o] = arguments[o];
        return (
          ((e = t.call.apply(t, [this].concat(r))).memoryCache = {
            events: [],
            posts: [],
          }),
          (e.timerMap = {
            events: 0,
            posts: 0,
          }),
          (e.totalCreate = 0),
          (e.reportTotalCreate = [0, 0]),
          e
        );
      }
      return (
        Y(i, [
          {
            key: 'registerCreate',
            value: function value(e, t) {
              this.memoryCache.events.push(e),
                this.memoryCache.events.length > 20 &&
                  (this.timerMap.events = window.setTimeout(
                    this.registerMemoCb.bind(this),
                    0,
                  )),
                0 === this.timerMap.events &&
                  (this.timerMap.events = window.setTimeout(
                    this.registerMemoCb.bind(this),
                    50,
                  ));
            },
          },
          {
            key: 'registerUpload',
            value: function value(e, t) {
              this.register(e, 1, t);
            },
          },
          {
            key: 'registerMemoCb',
            value: function value(e) {
              this.register(this.memoryCache.events, 0, e),
                (this.memoryCache.events = []),
                window.clearTimeout(this.timerMap.events),
                (this.timerMap.events = 0);
            },
          },
          {
            key: 'register',
            value: function value(e, t, i) {
              var n = this;
              if (e) {
                var r = {},
                  o = 0 === t ? 'event_count' : 'post_count';
                (e && TypeChecks.isArray(e) ? e : [e])
                  .map(function (e, t) {
                    return 60 * Math.floor(+e.$event_time / 6e4) * 1e3;
                  })
                  .forEach(function (e) {
                    0 === t && (n.totalCreate += 1),
                      (r[e] = r[e] ? r[e] + 1 : 1);
                  }),
                  (this.reportTotalCreate[t] += Object.keys(r).reduce(function (
                    e,
                    t,
                  ) {
                    return e + r[t];
                  },
                  0)),
                  it.debug(
                    '[对账调试]对账数据产生内存统计',
                    o,
                    this.reportTotalCreate,
                  );
                var s = this.writeTypeStgSafe(ve.BALANCE, function (e) {
                  for (var t in (it.debug('[对账调试]写入前', e),
                  it.debug('[对账调试]写入中', o, r),
                  r))
                    r.hasOwnProperty(t) &&
                      ((e[t] = e[t] || {
                        sequence_id: generateUUID(),
                        event_count: 0,
                        post_count: 0,
                      }),
                      (e[t][o] += r[t]));
                  return e;
                });
                it.debug('[对账调试]写入后', s);
              }
            },
          },
        ]),
        i
      );
    })(),
    rt = (function () {
      function e() {
        K(this, e);
      }
      return (
        Y(e, null, [
          {
            key: 'userInfo',
            get: function get() {
              return (
                this._userInfoInst || (this._userInfoInst = new tt()),
                this._userInfoInst
              );
            },
          },
          {
            key: 'trackBalanceCreate',
            get: function get() {
              return (
                this._balanceGenInst || (this._balanceGenInst = new nt()),
                this._balanceGenInst
              );
            },
          },
        ]),
        e
      );
    })();
  (rt._userInfoInst = void 0), (rt._balanceGenInst = void 0);
  var ot,
    at = (function () {
      function e() {
        var t = this;
        K(this, e),
          (this.spanConf = {
            life: 864e5,
            renewal: 18e5,
            cookieUpdateInterval: 6e4,
          }),
          (this.cookieNameConst = void 0),
          (this.sessionMeta = void 0),
          (this.cookieUpdatedTime = 0),
          (this.sessionMeta = {
            id: '',
            createTime: 0,
            renewalTime: 0,
          }),
          (this.cookieNameConst =
            'obus-track_' + Ne.config.app_id + '_session'),
          (this.spanConf.renewal = 6e4 * Ne.config.session_cutting_time),
          this.sessionMeta.id || this.restoreSession(),
          EventUtils.addEvent(window, 'beforeunload', function () {
            t.persist();
          }),
          EventUtils.addEvent(window, 'unload', function () {
            t.persist();
          });
      }
      return (
        Y(e, [
          {
            key: 'update',
            value: function value() {
              var e = Date.now();
              e - this.sessionMeta.createTime > this.spanConf.life ||
              e - this.sessionMeta.renewalTime > this.spanConf.renewal ||
              '' == this.sessionMeta.id
                ? this.renew()
                : (this.cookieUpdatedTime &&
                    this.spanConf.cookieUpdateInterval >=
                      e - this.cookieUpdatedTime) ||
                  ((this.sessionMeta.renewalTime = e), this.setCookies());
            },
          },
          {
            key: 'getSessionId',
            value: function value() {
              return this.sessionMeta.id;
            },
          },
          {
            key: 'restoreSession',
            value: function value() {
              var e = readCookie(this.cookieNameConst);
              if (e) this.restoreSessionWithData(e);
              else {
                var t = store(this.cookieNameConst);
                t && this.restoreSessionWithData(t);
              }
              this.sessionMeta.id || this.renew();
            },
          },
          {
            key: 'restoreSessionWithData',
            value: function value(e) {
              var t = e.split(',');
              t.length > 0 && (this.sessionMeta.id = t[0]);
              try {
                t.length > 1 &&
                  ((this.sessionMeta.createTime = +new Date(+t[1])),
                  (this.sessionMeta.createTime =
                    this.sessionMeta.createTime > 0
                      ? this.sessionMeta.createTime
                      : 0)),
                  t.length > 2 &&
                    ((this.sessionMeta.renewalTime = +new Date(+t[2])),
                    (this.sessionMeta.renewalTime =
                      this.sessionMeta.renewalTime > 0
                        ? this.sessionMeta.renewalTime
                        : 0));
              } catch (e) {
                console.log('otrack 日期初始化异常');
              }
            },
          },
          {
            key: 'renew',
            value: function value() {
              (this.sessionMeta = {
                id: random(),
                createTime: Date.now(),
                renewalTime: Date.now(),
              }),
                this.setCookies();
            },
          },
          {
            key: 'setCookies',
            value: function value() {
              var e = this.sessionMeta,
                t = e.createTime + this.spanConf.life,
                i = e.renewalTime + this.spanConf.renewal,
                n = t > i ? i : t;
              createCookie(
                this.cookieNameConst,
                [e.id, e.createTime, e.renewalTime].join(','),
                new Date(n),
                {
                  cross_subdomain: Ne.config.is_cross_subdomain,
                },
              ),
                (this.cookieUpdatedTime = Date.now());
            },
          },
          {
            key: 'persist',
            value: function value() {
              var e = this.sessionMeta;
              store(
                this.cookieNameConst,
                [e.id, e.createTime, e.renewalTime].join(','),
              );
            },
          },
        ]),
        e
      );
    })(),
    st = (function () {
      function e() {
        K(this, e), (this.session = void 0), (this.session = new at());
      }
      return (
        Y(e, [
          {
            key: 'getHeader',
            value: function value() {
              var e,
                t,
                i = rt.userInfo,
                n = {
                  $platform: 'web',
                  $lib_version:
                    (null === (e = Ne.getPkgInfo()) || void 0 === e
                      ? void 0
                      : e.version) || '',
                  $lib_type:
                    'object' ===
                      ('undefined' == typeof exports
                        ? 'undefined'
                        : z(exports)) && 'undefined' != typeof module
                      ? 'npm'
                      : 'script',
                  $timezone_offset: new Date().getTimezoneOffset(),
                  $screen_height: Number(screen.height) || 0,
                  $screen_width: Number(screen.width) || 0,
                  $orientation: getOrientation,
                  $doc_width: getDocWidth,
                  $doc_height: getViewportHeight,
                  $connection_type: function $connection_type() {
                    var e =
                      navigator.connection ||
                      navigator.mozConnection ||
                      navigator.webkitConnection;
                    return (e && e.effectiveType) || '';
                  },
                  $browser_type: browserInfo.type,
                  $browser_version: browserInfo.versions,
                  $os:
                    os +
                    ',' +
                    (i.getIsWebview() ? 'webview' : detect_device.device),
                  $session_id: this.session.getSessionId(),
                  $browser_language:
                    navigator.language || navigator.userLanguage || '',
                  $browser_charset:
                    (null === (t = document) || void 0 === t
                      ? void 0
                      : t.charset.toUpperCase()) || '',
                },
                r = {
                  $region: function $region() {
                    return Ne.config.region;
                  },
                  $region_code: function $region_code() {
                    return Ne.config.region_code;
                  },
                  $device_id: function $device_id() {
                    return rt.userInfo.deviceId;
                  },
                  $is_login: function $is_login() {
                    return rt.userInfo.isLogin;
                  },
                  $user_id: i.getUserId.bind(i),
                  $app_version: i.getAppVersion.bind(i),
                },
                o = W(W({}, n), r),
                a = Object.create(null);
              return (
                Object.keys(o).forEach(function (e) {
                  var t = o[e];
                  _extends(a, Z({}, e, 'function' == typeof t ? t() : t));
                }),
                this.session.update(),
                a
              );
            },
          },
        ]),
        e
      );
    })(),
    ct = ['head', 'pending'],
    ut = (function (e) {
      X(i, Xe);
      var t = re(i);
      function i(e) {
        var n;
        return (
          K(this, i),
          ((n = t.call(this)).isSending = !1),
          (n.continueFailCount = 0),
          (n.failIgnoreList = []),
          (n.identity = void 0),
          (n.logId = ''),
          (n.options = void 0),
          (n.url = ''),
          (n.reportHeader = void 0),
          (n.consumeStartThrottle = null),
          (n.options = e),
          (n.identity = e.identity),
          (n.reportHeader = new st()),
          (n.url = Ee(
            '$HOST/v3/track/js/$APPID',
            Ne.uploadHost,
            Ne.config.app_id,
          )),
          n.consumeStart(!0),
          n
        );
      }
      return (
        Y(i, [
          {
            key: 'consumeStart',
            value: function value(e, t) {
              this.consumeStartThrottle ||
                (this.consumeStartThrottle = throttle(
                  this.consumeStartOrg.bind(this),
                  100,
                  {
                    leading: !0,
                  },
                )),
                this.consumeStartThrottle(e, t);
            },
          },
          {
            key: 'consumeStartOrg',
            value: function value(e, t) {
              var i,
                n = this.readTypeStg(this.options.queue);
              if (
                !n ||
                0 ===
                  (null == n || null === (i = n.data) || void 0 === i
                    ? void 0
                    : i.length) ||
                this.isSending
              )
                return !1;
              (this.logId = t || ''),
                (this.isSending = !0),
                this.startTask(e, 0);
            },
          },
          {
            key: 'startTask',
            value: function value(e) {
              var t = this,
                i =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : 0,
                n = this.readTypeStg(this.options.queue)
                  .data.filter(function (e) {
                    return !t.failIgnoreList.includes(t.identity(e));
                  })
                  .filter(function (t) {
                    return e || 1 !== t.pending;
                  })
                  .shift();
              if (
                !(
                  n &&
                  Object.keys(n).length &&
                  (n.body.length || Object.keys(n.body).length) &&
                  this.isSending &&
                  5 > i
                )
              )
                return this.stopTask();
              this.continueFailCount++;
              var r = Date.now(),
                a = this.getRequestData(n),
                s = a.head,
                c = ie(a, ct);
              readCookie('__VPN__') &&
                Logger.error(
                  '埋点聚合',
                  W(
                    {
                      head: s,
                    },
                    c,
                  ),
                );
              var u = (function (e) {
                var t = be(e);
                return {
                  data: {
                    data: t,
                    crc: (function (e) {
                      var t = 0;
                      if (0 == e.length) return t;
                      for (var i = 0; e.length > i; i++)
                        (t = (t << 5) - t + e.charCodeAt(i)), (t &= t);
                      return t;
                    })(t),
                  },
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                };
              })(
                W(
                  {
                    head: s,
                  },
                  c,
                ),
              );
              this.setItemStatus(a, 1),
                fetch$1(
                  this.url +
                    '?app_key='
                      .concat(Ne.config.app_key, '&timestamp=')
                      .concat(r),
                  W(
                    W({}, u),
                    {},
                    {
                      method: 'POST',
                      timeout: Ne.config.fail_timeout,
                      reTryCount: Ne.config.fail_retry_count,
                      success: function success() {
                        t.success && t.success(a),
                          t.cleanDb(a),
                          t.startTask(e, 0);
                      },
                      fail: function fail(n, r) {
                        switch (((n = n || ''), +((r = r || 999) || 999))) {
                          case 442:
                          case 435:
                            t.cleanDb(a),
                              t.logger.error(
                                t.logId,
                                '原因: '
                                  .concat(n, ', code: ')
                                  .concat(
                                    r,
                                    ' 处于[442, 435], 上报失败本地删除数据',
                                  ),
                                c,
                              );
                            break;
                          case 999:
                            t.logger.error(
                              t.logId,
                              '原因: '
                                .concat(n, ', code: ')
                                .concat(
                                  r,
                                  ' 不处于[442, 435], 上报失败本地不删除数据',
                                ),
                              c,
                            ),
                              t.setItemStatus(a, 0),
                              t.failIgnoreList.push(t.identity(a));
                            break;
                          default:
                            (asyncFlag() || 408 != r) &&
                              t.logger.error(
                                t.logId,
                                '上报失败，原因: '
                                  .concat(n, ', code: ')
                                  .concat(r),
                                c,
                              ),
                              t.setItemStatus(a, 0);
                        }
                        t.startTask(e, ++i);
                      },
                    },
                  ),
                );
            },
          },
          {
            key: 'stopTask',
            value: function value() {
              return (
                (this.isSending = !1),
                (this.continueFailCount = 0),
                (this.failIgnoreList = []),
                this.options.consumeEnd && this.options.consumeEnd(),
                !1
              );
            },
          },
          {
            key: 'cleanDb',
            value: function value(e) {
              var t = this;
              this.writeTypeStgSafe(this.options.queue, function (i) {
                var n = i.filter(function (i) {
                  return t.identity(e) !== t.identity(i);
                });
                return n.length !== i.length && n;
              });
            },
          },
          {
            key: 'setItemStatus',
            value: function value(e) {
              var t = this,
                i =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : 0;
              this.writeTypeStgSafe(this.options.queue, function (n) {
                var r = n.map(function (n) {
                  return t.identity(e) === t.identity(n)
                    ? W(
                        W({}, n),
                        {},
                        {
                          pending: i,
                        },
                      )
                    : n;
                });
                return r.length > 0 && r;
              });
            },
          },
          {
            key: 'sendBeacon',
            value: function value(e) {
              var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0;
              (this.isSending = !0), this.startTask(e, t);
            },
          },
        ]),
        i
      );
    })(),
    lt = ['head'],
    dt = (function (e) {
      X(i, ut);
      var t = re(i);
      function i() {
        var e;
        return (
          K(this, i),
          ((e = t.call(this, {
            queue: ve.BALANCE_REQ,
            identity: function identity(e) {
              return e.request_id;
            },
          })).logger = Logger.clone({
            namespace: '对账上报',
            isShowLog: !0,
            isShowMills: !1,
          })),
          (e.url = Ee(
            '$HOST/v3/balance/js/$APPID',
            Ne.uploadHost,
            Ne.config.app_id,
          )),
          e
        );
      }
      return (
        Y(i, [
          {
            key: 'getRequestData',
            value: function value(e) {
              return (
                (e.body.eventCompleteness = serialize(
                  e.body.eventCompleteness,
                )),
                W(
                  W({}, e),
                  {},
                  {
                    head: this.reportHeader.getHeader(),
                    custom_head: rt.userInfo.getCustomHead(),
                  },
                )
              );
            },
          },
          {
            key: 'success',
            value: function value(e) {
              var t = ie(e, lt);
              this.logger.debug('上报成功', Ne.config.is_print_header ? e : t);
            },
          },
          {
            key: 'report',
            value: function value() {
              var e = this.readTypeStg(ve.BALANCE);
              if (
                0 >=
                Object.keys(e.data).sort(function (e, t) {
                  return +e - +t;
                }).length
              )
                return !1;
              this.writeTypeStgMultiSafe(
                [ve.BALANCE, ve.BALANCE_REQ],
                function (e, t) {
                  if (!e || !Object.keys(e).length) return !1;
                  var i = {
                    request_id: random(),
                    body: {
                      eventCompleteness: e,
                    },
                  };
                  return t.push(i), [{}, t];
                },
              ),
                this.consumeStart(!1);
            },
          },
        ]),
        i
      );
    })(),
    ft = ['head'],
    pt = (function (e) {
      X(i, ut);
      var t = re(i);
      function i() {
        var e;
        K(this, i);
        var n = 0,
          r = 0;
        return (
          ((e = t.call(this, {
            queue: he.REQUEST,
            consumeEnd: function consumeEnd() {
              var t;
              (n && (window.clearTimeout(n), (n = 0)),
              'number' == typeof Ne.config.balance_stats_interval &&
                Ne.config.balance_stats_interval)
                ? (r && (window.clearTimeout(r), (r = 0)),
                  (n = window.setTimeout(function () {
                    e.writeTypeStg(he.TRACK_PENDING, {
                      data: [],
                      version: Date.now(),
                    });
                  }, 1e3 * Ne.config.balance_stats_interval + 2e3)),
                  (r = window.setTimeout(function () {
                    var t;
                    null === (t = e.balanceReport) ||
                      void 0 === t ||
                      t.report();
                  }, 1e3 * Ne.config.balance_stats_interval)))
                : ((n = window.setTimeout(function () {
                    e.writeTypeStg(he.TRACK_PENDING, {
                      data: [],
                      version: Date.now(),
                    });
                  }, 2e3)),
                  null === (t = e.balanceReport) || void 0 === t || t.report());
            },
            identity: function identity(e) {
              return e.request_id;
            },
          })).balanceReport = void 0),
          (e.url = ''),
          (e.logger = Logger.clone({
            namespace: '埋点上报',
            isShowLog: !0,
            isShowMills: !1,
          })),
          (e.url = Ee(
            '$HOST/v3/track/js/$APPID',
            Ne.uploadHost,
            Ne.config.app_id,
          )),
          Ne.config.balance && (e.balanceReport = new dt()),
          e
        );
      }
      return (
        Y(i, [
          {
            key: 'getRequestData',
            value: function value(e) {
              return W(
                W({}, e),
                {},
                {
                  head: this.reportHeader.getHeader(),
                  custom_head: rt.userInfo.getCustomHead(),
                },
              );
            },
          },
          {
            key: 'success',
            value: function value(e) {
              ie(e, ft);
              this.logger.info(
                '上报成功',
                e.body.map(function (e) {
                  return e.$sequence_id;
                }),
              ),
                (rt.userInfo.isFirstTime = !1),
                rt.trackBalanceCreate.registerUpload(e.body, this.logId);
            },
          },
        ]),
        i
      );
    })(),
    ht = ['browser_type', 'browser_version'],
    vt = ['properties'],
    gt = function gt() {
      return random(4, {
        letters: !1,
      });
    },
    _t = !1,
    mt = (function (e) {
      X(i, Xe);
      var t = re(i);
      function i(e) {
        var n, r, a;
        K(this, i),
          ((a = t.call(this)).durationEventMap = {}),
          (a.batchSend = void 0),
          (a.trackTimer = 0),
          (a.logId = gt()),
          (a.consumeTrackCount = 0),
          (a.customPropertiesAttach = function () {
            return {};
          }),
          (a.headInfo =
            null === (n = new pt()) ||
            void 0 === n ||
            null === (r = n.balanceReport) ||
            void 0 === r
              ? void 0
              : r.reportHeader.getHeader()),
          (a.browserInfo = (function () {
            var e = navigator.userAgent.toLowerCase(),
              t = function t(_t2) {
                return _t2.test(e);
              },
              i = function i(t) {
                return ('' + e.match(t))
                  .replace(/[^0-9|_.]/g, '')
                  .replace(/_/g, '.');
              },
              n = 'unknow';
            t(/windows|win32|win64|wow32|wow64/g)
              ? (n = 'windows')
              : t(/macintosh|macintel/g)
              ? (n = 'macos')
              : t(/x11/g)
              ? (n = 'linux')
              : t(/android|adr/g)
              ? (n = 'android')
              : t(/ios|iphone|ipad|ipod|iwatch/g) && (n = 'ios');
            var r = 'unknow';
            'windows' === n
              ? t(/windows nt 5.0|windows 2000/g)
                ? (r = '2000')
                : t(/windows nt 5.1|windows xp/g)
                ? (r = 'xp')
                : t(/windows nt 5.2|windows 2003/g)
                ? (r = '2003')
                : t(/windows nt 6.0|windows vista/g)
                ? (r = 'vista')
                : t(/windows nt 6.1|windows 7/g)
                ? (r = '7')
                : t(/windows nt 6.2|windows 8/g)
                ? (r = '8')
                : t(/windows nt 6.3|windows 8.1/g)
                ? (r = '8.1')
                : t(/windows nt 10.0|windows 10/g) && (r = '10')
              : 'macos' === n
              ? (r = i(/os x [\d._]+/g))
              : 'android' === n
              ? (r = i(/android [\d._]+/g))
              : 'ios' === n && (r = i(/os [\d._]+/g));
            var o = 'unknow';
            'windows' === n || 'macos' === n || 'linux' === n
              ? (o = 'desktop')
              : ('android' === n || 'ios' === n || t(/mobile/g)) &&
                (o = 'mobile');
            var a = 'unknow',
              s = 'unknow';
            t(/applewebkit/g)
              ? ((a = 'webkit'),
                t(/edge/g)
                  ? (s = 'edge')
                  : t(/opr/g)
                  ? (s = 'opera')
                  : t(/chrome/g)
                  ? (s = 'chrome')
                  : t(/safari/g) && (s = 'safari'))
              : t(/gecko/g) && t(/firefox/g)
              ? ((a = 'gecko'), (s = 'firefox'))
              : t(/presto/g)
              ? ((a = 'presto'), (s = 'opera'))
              : t(/trident|compatible|msie/g) &&
                ((a = 'trident'), (s = 'iexplore'));
            var c = 'unknow';
            'webkit' === a
              ? (c = i(/applewebkit\/[\d._]+/g))
              : 'gecko' === a
              ? (c = i(/gecko\/[\d._]+/g))
              : 'presto' === a
              ? (c = i(/presto\/[\d._]+/g))
              : 'trident' === a && (c = i(/trident\/[\d._]+/g));
            var u = 'unknow';
            'chrome' === s
              ? (u = i(/chrome\/[\d._]+/g))
              : 'safari' === s
              ? (u = i(/version\/[\d._]+/g))
              : 'firefox' === s
              ? (u = i(/firefox\/[\d._]+/g))
              : 'opera' === s
              ? (u = i(/opr\/[\d._]+/g))
              : 'iexplore' === s
              ? (u = i(/(msie [\d._]+)|(rv:[\d._]+)/g))
              : 'edge' === s && (u = i(/edge\/[\d._]+/g));
            var l = 'none',
              d = 'unknow';
            return (
              t(/micromessenger/g)
                ? ((l = 'wechat'), (d = i(/micromessenger\/[\d._]+/g)))
                : t(/qqbrowser/g)
                ? ((l = 'qq'), (d = i(/qqbrowser\/[\d._]+/g)))
                : t(/ucbrowser/g)
                ? ((l = 'uc'), (d = i(/ucbrowser\/[\d._]+/g)))
                : t(/qihu 360se/g)
                ? (l = '360')
                : t(/2345explorer/g)
                ? ((l = '2345'), (d = i(/2345explorer\/[\d._]+/g)))
                : t(/metasr/g)
                ? (l = 'sougou')
                : t(/lbbrowser/g)
                ? (l = 'liebao')
                : t(/maxthon/g) &&
                  ((l = 'maxthon'), (d = i(/maxthon\/[\d._]+/g))),
              _extends(
                {
                  engine: a,
                  engineVs: c,
                  platform: o,
                  supporter: s,
                  supporterVs: u,
                  system: n,
                  systemVs: r,
                },
                'none' === l
                  ? {}
                  : {
                      shell: l,
                      shellVs: d,
                    },
              )
            );
          })()),
          (a.oTrack = null),
          (a.pickEventQToReqQThrottle = null),
          (a.flush = throttle(
            function () {
              return (
                !Ne.isReady() && !!Ne.config.flush && void a.pickEventQToReqQ(2)
              );
            },
            2e3,
            {
              leading: !0,
            },
          ));
        var s = W({}, e);
        return (
          void 0 !== s.oTrack && (a.oTrack = s.oTrack),
          Ne.registerCallbacks(function (e) {
            var t,
              i,
              n,
              r = a.readTypeStg(he.DEFERRED);
            ((a.batchSend = new pt()),
            e.app_version &&
              rt.userInfo.setAppVersion('' + e.app_version || ''),
            Logger.info(
              e.app_id + ' 当前环境: '.concat(e.env || 'prod'),
              '设备ID: '.concat(
                null === (t = rt.userInfo) || void 0 === t
                  ? void 0
                  : t.deviceId,
              ),
            ),
            e.is_print_header) &&
              Logger.info(
                '公共头',
                null === (i = a.batchSend) ||
                  void 0 === i ||
                  null === (n = i.balanceReport) ||
                  void 0 === n
                  ? void 0
                  : n.reportHeader.getHeader(),
              );
            r.data.length &&
              (a.readTypeStg(he.DEFERRED).data.forEach(function (e) {
                var t,
                  i = se((t = e)) || ce(t) || ue(t) || de(),
                  n = i[0],
                  r = i.slice(1);
                -1 !== ['track'].indexOf(n) && a[n].apply(ne(a), r);
              }),
              a.writeTypeStgSafe(he.DEFERRED, function () {
                return [];
              })),
              a.pickEventQToReqQOriginal(3);
          }),
          _t ||
            ((_t = !0),
            EventUtils.addEvent(window, 'beforeunload', function () {
              var e;
              asyncFlag(!1),
                null === (e = a.batchSend) || void 0 === e || e.sendBeacon(!0);
            }),
            EventUtils.addEvent(window, 'unload', function () {
              var e;
              asyncFlag(!1),
                null === (e = a.batchSend) || void 0 === e || e.sendBeacon(!0);
            }),
            EventUtils.addEvent(window, 'online', function () {
              var e;
              null === (e = a.batchSend) || void 0 === e || e.consumeStart(!0);
            })),
          a
        );
      }
      return (
        Y(i, [
          {
            key: 'track',
            value: function value(e, t) {
              var i,
                n,
                r,
                s,
                c = arguments,
                u = Ne.config.pageview.url_alias,
                l = Ne.config.reported_platforms,
                f = Ne.config.quarantine_report,
                p = {};
              if (((this.logId = gt()), e.eventId)) {
                if (e.eventGroup) {
                  if (t && 'function' != typeof t)
                    Logger.error('track方法回调函数参数非法');
                  else {
                    var h, v;
                    if (
                      ((e.properties = e.properties || {}),
                      void 0 === e.properties.data_sequence_id &&
                        (e.properties.data_sequence_id =
                          this.oTrack.getDataSequenceId()),
                      ke.PageDuration.eventId !== e.eventId)
                    )
                      (p.$title =
                        e.title ||
                        u[location.pathname || '/'] ||
                        document.title),
                        (p.$referrer = UrlListener.getPrevUrl()),
                        (p.$referrer_host =
                          (null === (h = parseUrl(p.$referrer)) || void 0 === h
                            ? void 0
                            : h.host) || ''),
                        (p.$url =
                          document.URL ||
                          document.documentURI ||
                          location.href ||
                          ''),
                        (p.$url_path =
                          location.pathname ||
                          '/' +
                            p.$url
                              .replace(/(#.*)/, '')
                              .split('/')
                              .slice(3)
                              .join('/'));
                    else
                      (p.$title = e.title),
                        (p.$referrer = e.referrer),
                        (p.$referrer_host =
                          (null === (v = parseUrl(p.$referrer)) || void 0 === v
                            ? void 0
                            : v.host) || ''),
                        (p.$url = e.url),
                        (p.$url_path = e.url_path);
                    if (
                      (ke.PageView.eventId === e.eventId
                        ? ((p.$is_first_day = e.is_first_day),
                          (p.$is_first_time = e.is_first_time))
                        : this.oTrack.getAutoTrackParam &&
                          (e.properties = W(
                            W(
                              {},
                              spreadFunction(this.oTrack.getAutoTrackParam()()),
                            ),
                            e.properties,
                          )),
                      Ne.isReady())
                    ) {
                      var g = Ne.config,
                        m = (function (e, t) {
                          if (
                            ((e.eventId = e.eventId + ''),
                            (e.eventGroup = e.eventGroup + ''),
                            0 === e.eventId.indexOf('$') &&
                              /^\$track_/.test(e.eventGroup))
                          )
                            return !1;
                          if (0 === t.event_rule.length) return !0;
                          !Oe.white &&
                            t.event_rule &&
                            t.event_rule.forEach(function (e) {
                              (Oe.white = Oe.white || {}),
                                (Oe.white[
                                  ''.concat(e.eventId, '|').concat(e.eventGroup)
                                ] = !0);
                            }),
                            !Oe.black &&
                              t.event_blacklist &&
                              t.event_blacklist.forEach(function (e) {
                                var t = e.blackKey;
                                (Oe.black = Oe.black || {}),
                                  ((t &&
                                    TypeChecks.isArray(t) &&
                                    t.length >= 0) ||
                                    void 0 === t) &&
                                    (Oe.black[
                                      ''
                                        .concat(e.eventId, '|')
                                        .concat(e.eventGroup)
                                    ] = t);
                              });
                          var i = ''
                              .concat(e.eventId, '|')
                              .concat(e.eventGroup),
                            n = !Oe.white || !Oe.white[i];
                          if (!Oe.black || !t.event_blacklist) return n;
                          var r = Oe.black[i];
                          return (
                            !(!Oe.black.hasOwnProperty(i) || void 0 !== r) ||
                            (r &&
                              r.length > 0 &&
                              r.forEach(function (t) {
                                e.properties.hasOwnProperty(t) &&
                                  delete e.properties[t];
                              }),
                            n)
                          );
                        })(e, {
                          event_rule: g.event_rule,
                          event_blacklist: g.event_blacklist,
                        });
                      if (m) Logger.warn('事件被过滤', e);
                      else {
                        Ne.config.pageview.watch_utm &&
                          (e.properties = W(
                            W({}, e.properties),
                            this.oTrack.getUtm
                              ? this.oTrack.getUtm(e.properties)
                              : {},
                          )),
                          (e.properties = W(
                            W(
                              W({}, W({}, this.oTrack.store.getSessionProps())),
                              e.properties,
                            ),
                            this.customPropertiesAttach(),
                          ));
                        var k = Ne.config.on_track;
                        if (k && 'function' == typeof k) {
                          var w = e.eventId,
                            b = e.eventGroup,
                            T = e.properties,
                            I = ie(e, vt);
                          k.call(this.oTrack, {
                            oTrack: this.oTrack,
                            properties: T,
                            context: I,
                          }),
                            (e.eventId = w),
                            (e.eventGroup = b);
                        }
                        (e.properties = W(
                          W({}, e.properties),
                          {},
                          {
                            _track_id: Number(
                              (getRandom() + '').slice(2, 5) +
                                (getRandom() + '').slice(2, 4) +
                                (new Date().getTime() + '').slice(-4),
                            ),
                            _flush_time: new Date().getTime(),
                            $item_id: (e.item_id || '') + '',
                            $item_type: (e.item_type || '') + '',
                            $project: Ne.config.project,
                          },
                        )),
                          (e.properties.$item_id && e.properties.$item_type) ||
                            (delete e.properties.$item_id,
                            delete e.properties.$item_type);
                        var S = W(
                          W({}, p),
                          {},
                          {
                            $event_id: e.eventId,
                            $event_group: e.eventGroup,
                            $event_info: serialize(e.properties),
                            $event_time:
                              0 === e.eventId.indexOf('$') &&
                              e.properties.$visit_time
                                ? e.properties.$visit_time
                                : Date.now(),
                            $sequence_id: generateUUID(),
                          },
                        );
                        if ((Logger.info(this.logId, '埋点产生', S, z(S)), f))
                          this.pushTrackQueue(he.TRACK, S, t);
                        else {
                          var E =
                            (null === (i = window) ||
                            void 0 === i ||
                            null === (n = i.App_AutoEvent_Js_Bridge) ||
                            void 0 === n
                              ? void 0
                              : n.track) ||
                            (null === (r = window) ||
                            void 0 === r ||
                            null === (s = r.App_Js_Bridge) ||
                            void 0 === s
                              ? void 0
                              : s.track);
                          if (!l.includes('web') || E) {
                            var C,
                              $,
                              A,
                              P,
                              j =
                                ((C = this.headInfo),
                                ($ = S),
                                (A = rt.userInfo.getCustomHead()),
                                {
                                  head: ie(
                                    (P = function P(e) {
                                      var t = {};
                                      return (
                                        Object.keys(e).forEach(function (i) {
                                          var n =
                                            0 === i.indexOf('$')
                                              ? i.replace('$', '')
                                              : i;
                                          t[n] = e[i];
                                        }),
                                        t
                                      );
                                    })(C),
                                    ht,
                                  ),
                                  body: (function (e) {
                                    return Array.isArray(e)
                                      ? e.map(function (e) {
                                          return P(e);
                                        })
                                      : [P(e)];
                                  })($),
                                  custom_head: P(A),
                                });
                            l.includes('app') && E
                              ? 0 !==
                                (null == S ? void 0 : S.$event_id.indexOf('$'))
                                ? window.App_Js_Bridge.track(JSON.stringify(j))
                                : window.App_AutoEvent_Js_Bridge.track(
                                    JSON.stringify(j),
                                  )
                              : Logger.info('未配置app上报或H5不在app中访问');
                          } else this.pushTrackQueue(he.TRACK, S, t);
                        }
                      }
                    } else
                      this.writeTypeStgSafe(he.DEFERRED, function (e) {
                        return (
                          e.push(['track'].concat(ae([].slice.call(c)))), e
                        );
                      });
                  }
                } else Logger.error('track方法事件模块必填');
              } else Logger.error('track方法eventId不能为空');
            },
          },
          {
            key: 'startEvent',
            value: function value(e, t) {
              if (this.durationEventMap[''.concat(e, '-').concat(t)])
                return (
                  Logger.warn(
                    'event id: '
                      .concat(e, ', event group: ')
                      .concat(t, ' 已经start'),
                  ),
                  !1
                );
              Logger.info(
                'startEvent event id: '.concat(e, ', event group: ').concat(t),
              ),
                (this.durationEventMap[''.concat(e, '-').concat(t)] =
                  new Date().getTime());
            },
          },
          {
            key: 'stopEvent',
            value: function value(e, t, i) {
              if (!this.durationEventMap[''.concat(e, '-').concat(t)])
                return (
                  Logger.warn(
                    'event id: '
                      .concat(e, ', event group: ')
                      .concat(t, ' 未开始'),
                  ),
                  !1
                );
              Logger.info(
                'Stop event id: '
                  .concat(e, ', event group: ')
                  .concat(t, ', props: '),
                i,
              ),
                (i.$duration =
                  new Date().getTime() -
                  this.durationEventMap[''.concat(e, '-').concat(t)]),
                delete this.durationEventMap[''.concat(e, '-').concat(t)],
                this.track({
                  eventId: e,
                  eventGroup: t,
                  properties: i,
                });
            },
          },
          {
            key: 'pushTrackQueue',
            value: function value(e, t, i) {
              var n = this;
              if (-1 === ye.indexOf(e))
                return (
                  Logger.warn(this.logId, '未知的事件类型 type: '.concat(e)), !1
                );
              rt.trackBalanceCreate.registerCreate(t, this.logId);
              var r = this.writeTypeStgSafe(e, function (e) {
                return (
                  e.every(function (e) {
                    return e.$sequence_id !== t.$sequence_id;
                  }) && e.push(t),
                  e
                );
              });
              return Ne.config.fast
                ? (this.pickEventQToReqQ(2), void (i && i(this)))
                : i
                ? (this.pickEventQToReqQ(2), void i(this))
                : (Ne.config.max_batch_events > r.length ||
                    setTimeout(function () {
                      n.pickEventQToReqQ(0),
                        window.clearTimeout(n.trackTimer),
                        (n.trackTimer = 0);
                    }, 30 * Math.random()),
                  void (
                    0 === this.trackTimer &&
                    (this.trackTimer = window.setTimeout(function () {
                      n.pickEventQToReqQ(1), (n.trackTimer = 0);
                    }, 1e3 * Ne.config.interval_time))
                  ));
            },
          },
          {
            key: 'pickEventQToReqQ',
            value: function value(e) {
              return (
                this.pickEventQToReqQThrottle ||
                  (this.pickEventQToReqQThrottle = throttle(
                    this.pickEventQToReqQOriginal.bind(this),
                    100,
                    {
                      leading: !0,
                    },
                  )),
                this.pickEventQToReqQThrottle(e)
              );
            },
          },
          {
            key: 'pickEventQToReqQOriginal',
            value: function value(e) {
              var t,
                i = this,
                n = Ne.config.max_batch_events;
              4 !== e && (this.consumeTrackCount = 0);
              this.writeTypeStgMultiSafe(
                [he.TRACK, he.REQUEST],
                function (e, t) {
                  if (
                    !e ||
                    !e.length ||
                    t.length >= Ne.config.max_request_queue
                  )
                    return !1;
                  var r = i.readTypeStg(he.TRACK_PENDING),
                    o = e.slice(0, n).filter(function (e) {
                      return !r.data.includes(e.$sequence_id);
                    });
                  i.writeTypeStgSafe(he.TRACK_PENDING, function (e) {
                    return (
                      0 !== (null == o ? void 0 : o.length) &&
                      (o.forEach(function (t) {
                        e.includes(t.$sequence_id) || e.push(t.$sequence_id);
                      }),
                      e.slice(-50))
                    );
                  });
                  var a = e.filter(function (e) {
                    return o.every(function (t) {
                      return (
                        t.$sequence_id !== e.$sequence_id &&
                        !r.data.includes(e.$sequence_id)
                      );
                    });
                  });
                  if (o && o.length > 0) {
                    var s = {
                      request_id: random(),
                      body: o,
                    };
                    t.push(s);
                  }
                  return [a, t];
                },
              );
              for (
                var r = this.readTypeStg(he.TRACK);
                r.data.length >= Ne.config.max_batch_events &&
                1e3 > this.consumeTrackCount;

              )
                this.consumeTrackCount++, this.pickEventQToReqQOriginal(4);
              null === (t = this.batchSend) ||
                void 0 === t ||
                t.consumeStart(!1, this.logId);
            },
          },
          {
            key: 'setCustomProperties',
            value: function value(e) {
              this.customPropertiesAttach =
                'object' === z(e)
                  ? function () {
                      return e;
                    }
                  : e;
            },
          },
        ]),
        i
      );
    })(),
    yt = {
      url: '',
      url_path: '',
      title: '',
      referrer: '',
      event_info: null,
      _storeDuration: 0,
      _lastViewTime: 0,
    },
    kt = 'prev_visit_page';
  !(function (e) {
    (e[(e.DURATION = 0)] = 'DURATION'), (e[(e.PAGE_VIEW = 1)] = 'PAGE_VIEW');
  })(ot || (ot = {}));
  var wt = (function () {
      function e(t, i) {
        var n = this;
        K(this, e),
          (this.trackTime = !1),
          (this.inactivityCounter = 0),
          (this.inactivityTime = 15),
          (this.getAutoTrackParams = null),
          (this.pageDuration = yt),
          (this.trackDispatch = void 0),
          (this.logger = new LoggerFactory({
            namespace: 'page_visit',
          })),
          (this.oTrack = null),
          (this.oTrack = i);
        var r = Ne.config;
        (this.trackDispatch = t || function () {}),
          (this.pageDuration = W(W({}, yt), storeSession(kt))),
          this.pageDuration._lastViewTime > 0 &&
            this.toTrackQueue(ot.DURATION, this.pageDuration, !0),
          this.startCounter(),
          'auto' === r.pageview.track_pageview_type.toLocaleLowerCase() &&
            r.is_single_page_app &&
            UrlListener.push(function (e, t) {
              (t && t.href === e.href) ||
                setTimeout(function () {
                  n.trackPageView();
                }, r.pageview.delay);
            }),
          setTimeout(function () {
            n.trackPageView(
              r.pageview.is_trigger_pageload &&
                !r.pageview.track_ignore(location),
            );
          }, r.pageview.delay),
          this.trackVersion(),
          this.trackPageLoad();
      }
      return (
        Y(e, [
          {
            key: 'trackPageView',
            value: function value(e, t) {
              var i = W(W({}, this.oTrack.detectSourceType()), t);
              void 0 === e && (e = !0),
                this.getAutoTrackParams &&
                  TypeChecks.isFunction(this.getAutoTrackParams) &&
                  (i = W(W({}, spreadFunction(this.getAutoTrackParams())), i)),
                this.pageDuration &&
                  this.toTrackQueue(ot.DURATION, this.pageDuration, !1);
              var n = random(6),
                r = Date.now(),
                o = {
                  url: window.location.href || '/',
                  url_path: window.location.pathname || '/',
                  title:
                    Ne.config.pageview.url_alias[location.pathname || '/'] ||
                    document.title,
                  referrer: UrlListener.getPrevUrl(),
                  event_info: W(
                    W({}, i),
                    {},
                    {
                      $visit_id: n,
                      $visit_time: r,
                    },
                  ),
                  _lastViewTime: getTimestamp(),
                };
              this.storeSession(o),
                !Ne.config.pageview.track_ignore(location) &&
                  e &&
                  this.toTrackQueue(
                    ot.PAGE_VIEW,
                    W(
                      W({}, i),
                      {},
                      {
                        $visit_id: n,
                        $visit_time: r,
                      },
                    ),
                  );
            },
          },
          {
            key: 'startCounter',
            value: function value() {
              var e = this,
                t = 'hidden';
              this.startTime();
              var i = function i() {
                document[t] ? e.stopTime() : e.startTime();
              };
              t in document
                ? document.addEventListener('visibilitychange', i)
                : (t = 'mozHidden') in document
                ? document.addEventListener('mozvisibilitychange', i)
                : (t = 'webkitHidden') in document
                ? document.addEventListener('webkitvisibilitychange', i)
                : (t = 'msHidden') in document
                ? document.addEventListener('msvisibilitychange', i)
                : 'onfocusin' in document
                ? (EventUtils.addEvent(window, 'focusin', function () {
                    e.startTime();
                  }),
                  EventUtils.addEvent(window, 'focusout', function () {
                    e.stopTime();
                  }))
                : (EventUtils.addEvent(window, 'focus', function () {
                    e.startTime();
                  }),
                  EventUtils.addEvent(window, 'blur', function () {
                    e.stopTime();
                  }),
                  EventUtils.addEvent(window, 'pageshow', function () {
                    e.startTime();
                  }),
                  EventUtils.addEvent(window, 'pagehide', function () {
                    e.stopTime();
                  }));
              var n = function n() {
                e.inactivityTime > e.inactivityCounter || e.startTime(),
                  (e.inactivityCounter = 0);
              };
              EventUtils.addEvent(window, 'mousemove', n),
                EventUtils.addEvent(window, 'click', n),
                EventUtils.addEvent(window, 'keydown', n),
                EventUtils.addEvent(window, 'scroll', n),
                EventUtils.addEvent(window, 'beforeunload', function () {
                  e.stopTime();
                }),
                EventUtils.addEvent(window, 'unload', function () {
                  e.stopTime();
                }),
                setInterval(function () {
                  e.inactivityCounter++,
                    e.inactivityTime > e.inactivityCounter || e.stopTime();
                }, 6e4);
            },
          },
          {
            key: 'startTime',
            value: function value() {
              this.trackTime ||
                ((this.trackTime = !0),
                (this.pageDuration._lastViewTime =
                  getTimestamp() - this.pageDuration._storeDuration),
                (this.pageDuration._storeDuration = 0),
                this.storeSession({
                  _storeDuration: this.pageDuration._storeDuration,
                  _lastViewTime: this.pageDuration._lastViewTime,
                }));
            },
          },
          {
            key: 'stopTime',
            value: function value() {
              this.trackTime &&
                ((this.trackTime = !1),
                (this.pageDuration._storeDuration =
                  getTimestamp() - this.pageDuration._lastViewTime),
                this.storeSession({
                  _storeDuration: this.pageDuration._storeDuration,
                }));
            },
          },
          {
            key: 'setAutoTrackParam',
            value: function value(e) {
              var t = e;
              'object' === z(e) &&
                (t = function t() {
                  return e;
                }),
                (this.getAutoTrackParams = t);
            },
          },
          {
            key: 'getAutoTrackParam',
            value: function value() {
              return (
                this.getAutoTrackParams ||
                function () {
                  return {};
                }
              );
            },
          },
          {
            key: 'toTrackQueue',
            value: function value(e, t, i) {
              if (e === ot.DURATION) {
                var n = 0;
                if (
                  (i || this.trackTime
                    ? (n =
                        0 !== this.pageDuration._storeDuration
                          ? this.pageDuration._storeDuration
                          : getTimestamp() - this.pageDuration._lastViewTime)
                    : this.trackTime || (n = this.pageDuration._storeDuration),
                  n > 0 &&
                    '' !== this.pageDuration.url &&
                    Ne.config.is_track_visittime)
                ) {
                  var r = t || {},
                    o = r.event_info,
                    a = r.url,
                    s = r.url_path,
                    c = r.title,
                    u = r.referrer;
                  this.trackDispatch(
                    W(
                      W({}, ke.PageDuration),
                      {},
                      {
                        url: a,
                        url_path: s,
                        title: c,
                        referrer: u,
                        properties: W(
                          {
                            duration: n,
                          },
                          o,
                        ),
                      },
                    ),
                  );
                }
                return (
                  (this.pageDuration = W({}, yt)), this.storeSession(null), !0
                );
              }
              this.trackDispatch(
                W(
                  W({}, ke.PageView),
                  {},
                  {
                    properties: W({}, 'object' === z(t) ? t : null),
                    is_first_day: rt.userInfo.isFirstDayFromCookies(),
                    is_first_time: rt.userInfo.isFirstTime,
                  },
                ),
              );
            },
          },
          {
            key: 'storeSession',
            value: function value(e) {
              if (null == e) return storeSession(kt, null);
              (this.pageDuration = W(W(W({}, yt), this.pageDuration), e)),
                this.pageDuration.referrer ||
                  (this.pageDuration.referrer = UrlListener.getPrevUrl()),
                storeSession(kt, this.pageDuration);
            },
          },
          {
            key: 'trackVersion',
            value: function value() {
              var e = this,
                t = O(Ne.config.region.toLowerCase());
              fetch$1(''.concat(t, '/api/getVersion'), {
                success: function success(t) {
                  var i;
                  if (
                    (null === (i = Ne.getPkgInfo()) || void 0 === i
                      ? void 0
                      : i.version) !== t.version
                  ) {
                    var n = window,
                      r =
                        n.performance ||
                        n.webkitPerformance ||
                        n.msPerformance ||
                        n.mozPerformance;
                    if (r.getEntries && 'function' == typeof r.getEntries) {
                      var o = r.getEntries().find(function (e) {
                        return e.name.includes('/otrack/');
                      });
                      if (o && o.name) {
                        var a,
                          s = o.toJSON() || {},
                          c = {
                            url: window.location.href || '/',
                            url_path: window.location.pathname || '/',
                            title:
                              Ne.config.pageview.url_alias[
                                location.pathname || '/'
                              ] || document.title,
                            referrer: UrlListener.getPrevUrl(),
                            properties: W(
                              {
                                serverVersion: t.version,
                                pkgVersion:
                                  null === (a = Ne.getPkgInfo()) || void 0 === a
                                    ? void 0
                                    : a.version,
                              },
                              s,
                            ),
                          };
                        o && e.trackDispatch(W(W({}, ke.TRACK_VERSION), c));
                      }
                    }
                  }
                },
              });
            },
          },
          {
            key: 'trackPageLoad',
            value: function value() {
              var e,
                t = this,
                i = function e() {
                  var i = window,
                    n =
                      i.performance ||
                      i.webkitPerformance ||
                      i.msPerformance ||
                      i.mozPerformance,
                    r = 0,
                    a = 0;
                  if (n && n.timing) {
                    var s = n.timing;
                    0 === s.fetchStart || 0 === s.domContentLoadedEventEnd
                      ? Logger.error('performance 数据获取异常')
                      : ((r = Number(
                          (
                            (r = s.domContentLoadedEventEnd - s.fetchStart) /
                            1e3
                          ).toFixed(3),
                        )),
                        n.getEntries &&
                          'function' == typeof n.getEntries &&
                          (n.getEntries().map(function (e) {
                            'transferSize' in e && (a += +e.transferSize);
                          }),
                          (a =
                            a >= 0 && 10737418240 > a
                              ? Number((a / 1024).toFixed(3))
                              : -1)));
                  } else (r = -1), Logger.info('浏览器不支持 performance');
                  var c = {
                    $page_event_duration: r,
                    $page_resource_size: a,
                  };
                  t.trackDispatch(
                    W(
                      W({}, ke.PageLoad),
                      {},
                      {
                        properties: W({}, 'object' === z(c) ? c : null),
                      },
                    ),
                  ),
                    EventUtils.removeEvent(window, 'load', e);
                };
              'complete' ==
              (null === (e = document) || void 0 === e ? void 0 : e.readyState)
                ? i()
                : EventUtils.addEvent(window, 'load', i);
            },
          },
        ]),
        e
      );
    })(),
    bt = '1.6.6',
    Tt = (function () {
      function e(t) {
        K(this, e),
          (this.oTrack = null),
          (this.store = null),
          (this.conf = null),
          (this.autoTrackEnabled = !1),
          (this.regexList = {});
        var i = W({}, t);
        (this.oTrack = i.oTrack),
          (this.store = i.store),
          (this.conf = Ne.config),
          this.conf.preset_properties ||
            (this.conf.preset_properties = {
              latest_utm: !0,
              latest_referrer_host: !1,
              latest_landing_page: !1,
            });
      }
      return (
        Y(e, [
          {
            key: 'init',
            value: function value() {
              var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : {};
              Logger.info('神策init初始化配置: ', e),
                void 0 !== e.preset_properties &&
                  (this.conf.preset_properties = W(
                    W({}, this.conf.preset_properties),
                    e.preset_properties,
                  )),
                this.watchUTM(this.conf.preset_properties.latest_utm),
                void 0 !== e.cross_subdomain &&
                  (this.conf.is_cross_subdomain = e.cross_subdomain),
                void 0 !== e.name && (this.conf.namespace = e.name),
                void 0 !== e.is_single_page &&
                  (this.conf.is_single_page_app = e.is_single_page),
                void 0 !== e.max_referrer_string_length &&
                  (this.conf.max_referrer_string_length =
                    e.max_referrer_string_length || 200),
                e.debug_mode && (this.conf.log_level = 'debug'),
                e.project && (this.conf.project = e.project + '' || 'default');
            },
          },
          {
            key: 'watchUTM',
            value: function value(e) {
              this.conf.pageview.watch_utm = !!e;
            },
          },
          {
            key: 'quick',
            value: function value(e) {
              for (
                var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), n = 1;
                t > n;
                n++
              )
                i[n - 1] = arguments[n];
              return this[e].apply(this, i);
            },
          },
          {
            key: 'autoTrackWithoutProfile',
            value: function value(e) {
              this.autoTrack(
                W(
                  W({}, e),
                  {},
                  {
                    not_set_profile: !0,
                  },
                ),
              );
            },
          },
          {
            key: 'autoTrack',
            value: function value(e) {
              (this.autoTrackEnabled = !0),
                (this.conf.pageview.is_trigger_pageload = !0);
              var t = !0;
              e && ((t = !e.not_set_profile), delete e.not_set_profile),
                this.sendFirstProfile(this.setOnceProfile.bind(this), !0, t),
                e && this.oTrack.setCustomProperties(e);
            },
          },
          {
            key: 'autoTrackSinglePage',
            value: function value(e) {
              this.conf.is_single_page_app = !0;
              var t = !0;
              e && ((t = !e.not_set_profile), delete e.not_set_profile),
                this.sendFirstProfile(this.setOnceProfile.bind(this), !1, t),
                this.oTrack.trackPageView(!0, e);
            },
          },
          {
            key: 'isReady',
            value: function value(e) {
              'function' == typeof e && Ne.registerCallbacks(e);
            },
          },
          {
            key: 'trackHeatMap',
            value: function value(e, t, i) {
              this.oTrack.heatmap
                ? this.oTrack.heatmap.trackHeatMap(e, t, i)
                : Logger.info(
                    'mini版jssdk不支持heatmap能力，若需要请使用完整版',
                  );
            },
          },
          {
            key: 'trackAllHeatMap',
            value: function value(e, t, i) {
              this.oTrack.heatmap
                ? this.oTrack.heatmap.trackAllHeatMap(e, t, i)
                : Logger.info(
                    'mini版jssdk不支持heatmap能力，若需要请使用完整版',
                  );
            },
          },
          {
            key: 'getPresetProperties',
            value: function value() {
              var e,
                t,
                i,
                n = this.oTrack.getHeader(),
                r = this.detectSourceType(!1),
                o = this.getUtm(r);
              return W(
                W({}, n),
                {},
                {
                  $url:
                    (null === (e = window) || void 0 === e
                      ? void 0
                      : e.location.href) || '/',
                  $url_path:
                    (null === (t = window) || void 0 === t
                      ? void 0
                      : t.location.pathname) || '/',
                  $title:
                    null === (i = document) || void 0 === i ? void 0 : i.title,
                },
                o,
              );
            },
          },
          {
            key: 'getAnonymousID',
            value: function value() {
              var e = this.store.getIdentities();
              return e.$identity_anonymous_id || e.$identity_login_id || '';
            },
          },
          {
            key: 'identify',
            value: function value(e) {
              if (this.autoTrackEnabled)
                throw Error('identify方法调用必须放在开启autoTrack之前');
              var t = e + '';
              t.length > 0 || Logger.error('参数不能为空'),
                this.oTrack.setDeviceId(t),
                this.store.setIdentities({
                  $identity_cookie_id: t,
                });
            },
          },
          {
            key: 'login',
            value: function value(e, t) {
              if (this.oTrack.getUserId())
                return Logger.error('已经登录过，不可重复登录'), !1;
              var i = e + '';
              i.length > 0 || Logger.error('参数不能为空'),
                this.trackSignup(i, '', {}, t);
            },
          },
          {
            key: 'logout',
            value: function value() {
              var e = this.store.getIdentities().$identity_anonymous_id;
              this.oTrack.setUserId(''),
                this.store.setIdentities({
                  $identity_login_id: e,
                  $identity_anonymous_id: generateUUID(),
                });
            },
          },
          {
            key: 'registerPage',
            value: function value(e) {
              this.oTrack.setAutoTrackParam(function () {
                return W({}, e);
              });
            },
          },
          {
            key: 'clearPageRegister',
            value: function value(e) {
              if (TypeChecks.isArray(e)) {
                var t = this.oTrack.getAutoTrackParam()();
                e.forEach(function (e) {
                  e in t && delete t[e];
                }),
                  this.registerPage(t);
              } else !0 === e && this.oTrack.setAutoTrackParam({});
            },
          },
          {
            key: 'register',
            value: function value(e) {
              this.store.setProps(e);
            },
          },
          {
            key: 'registerOnce',
            value: function value(e) {
              this.store.setPropsOnce(e);
            },
          },
          {
            key: 'clearAllRegister',
            value: function value(e) {
              this.store.clearAllProps(e);
            },
          },
          {
            key: 'setProfile',
            value: function value(e, t) {
              var i = W(
                W({}, ke.Sensors),
                {},
                {
                  properties: e,
                },
              );
              (i.eventId = i.eventId + 'profile_set'), this.oTrack.track(i, t);
            },
          },
          {
            key: 'setOnceProfile',
            value: function value(e, t) {
              var i = W(
                W({}, ke.Sensors),
                {},
                {
                  properties: e,
                },
              );
              (i.eventId = i.eventId + 'profile_set_once'),
                this.oTrack.track(i, t);
            },
          },
          {
            key: 'sendFirstProfile',
            value: function value(e, t, i) {
              if (rt.userInfo.isFirstTime && i) {
                var n = this.detectSourceType(!0),
                  r = this.getUtm(n);
                e(
                  W(
                    W({}, r),
                    {},
                    {
                      $first_referrer: t
                        ? r.$first_referrer
                        : r.$first_referrer.slice(
                            0,
                            this.conf.max_referrer_string_length,
                          ),
                    },
                  ),
                );
              }
            },
          },
          {
            key: 'getUtm',
            value: function value(e) {
              var t = {};
              if (!this.conf.pageview.watch_utm) return t;
              if (!isSameOrigin()) {
                if (
                  (we.utm.forEach(function (e) {
                    t['$' + e] = getQuery(e) || '';
                  }),
                  rt.userInfo.isFirstTime && t.$utm_source)
                )
                  return (
                    (t.$source_type = 'utm'),
                    (t.$first_traffic_source_type = '付费广告流量'),
                    e.$latest_search_keyword &&
                      (t.$first_search_keyword = e.$latest_search_keyword),
                    t
                  );
                we.utm.forEach(function (e) {
                  t['$latest_' + e] = getQuery(e) || '';
                }),
                  t.$utm_source &&
                    ((t.$source_type = 'utm'),
                    (t.$latest_traffic_source_type = '付费广告流量'));
              }
              return t;
            },
          },
          {
            key: 'detectSourceType',
            value: function value() {
              var e,
                t =
                  arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0],
                i = {},
                n = null === (e = window) || void 0 === e ? void 0 : e.location;
              if (n) {
                var r;
                (i.$latest_referrer =
                  (null === (r = document) || void 0 === r
                    ? void 0
                    : r.referrer) || ''),
                  (i.$latest_traffic_source_type = i.$latest_referrer
                    ? '引荐流量'
                    : '直接流量'),
                  (i.$latest_referrer_host = '');
                var o = parseUrl(i.$latest_referrer);
                o
                  ? ((i.$latest_referrer = ''
                      .concat(o.schema)
                      .concat(o.host)
                      .concat(o.path)),
                    (i.$latest_referrer_host = o.host || ''),
                    (i.$latest_search_keyword = '未取到值'))
                  : (i.$latest_search_keyword = '未取到值_直接打开'),
                  this.conf.preset_properties.latest_landing_page &&
                    (i.$latest_landing_page = n.href || '');
                for (var a = 0; we.social.length > a; a++) {
                  var s = we.social[a],
                    c = this.regexList[s];
                  if (
                    (c ||
                      (c = this.regexList[s] =
                        RegExp('\\b'.concat(s, '\\b'), 'i')),
                    c.test(i.$latest_referrer_host))
                  ) {
                    (i.$source_type = 'social'),
                      (i.$latest_traffic_source_type = '社交网站流量');
                    break;
                  }
                }
                for (var u = 0; we.search.length > u; u++) {
                  var l = we.search[u],
                    d = this.regexList[l];
                  if (
                    (d ||
                      (d = this.regexList[l] =
                        RegExp('\\b'.concat(l, '\\b'), 'i')),
                    d.test(i.$latest_referrer_host))
                  ) {
                    (i.$source_type = 'search'),
                      (i.$latest_traffic_source_type = '自然搜索流量');
                    for (
                      var f = Object.keys(we.keyword), p = 0;
                      f.length > p;
                      p++
                    ) {
                      if (RegExp('\\b'.concat(f[p], '\\b'), 'i').test(l)) {
                        var h = we.keyword[f[p]];
                        if (((i.$latest_search_keyword = ''), o))
                          for (
                            var v = 0;
                            h.length > v &&
                            ((i.$latest_search_keyword = o.query[h[v]] || ''),
                            !i.$latest_search_keyword);
                            v++
                          );
                        i.$latest_search_keyword ||
                          (i.$latest_search_keyword = i.$latest_referrer
                            ? '未取到值'
                            : '未取到值_直接打开');
                        break;
                      }
                    }
                    break;
                  }
                }
                this.conf.preset_properties.latest_referrer_host ||
                  delete i.$latest_referrer_host;
              }
              if (t && rt.userInfo.isFirstTime) {
                var g, _;
                (i.$first_visit_time = Date.now()),
                  (i.$first_referrer =
                    (null === (g = document) || void 0 === g
                      ? void 0
                      : g.referrer) || '');
                var m = parseUrl(i.$first_referrer);
                m && (i.$first_referrer_host = m.host || '');
                var y = navigator || {};
                (i.$first_browser_language =
                  y.language || y.userLanguage || ''),
                  (i.$first_browser_charset =
                    (null === (_ = document) || void 0 === _
                      ? void 0
                      : _.charset.toUpperCase()) || '');
              }
              return i;
            },
          },
          {
            key: 'unsetProfile',
            value: function value(e, t) {
              if ('string' == typeof e) e = [e];
              else if (!TypeChecks.isArray(e))
                return void Logger.error('参数类型不合法');
              var i = {};
              e.forEach(function (e) {
                return (i[e] = !0);
              });
              var n = W(
                W({}, ke.Sensors),
                {},
                {
                  properties: i,
                },
              );
              (n.eventId = n.eventId + 'profile_unset'),
                this.oTrack.track(n, t);
            },
          },
          {
            key: 'deleteProfile',
            value: function value(e) {
              var t = W({}, ke.Sensors);
              (t.eventId = t.eventId + 'profile_delete'),
                this.oTrack.track(t, e),
                this.oTrack.setUserId('');
            },
          },
          {
            key: 'incrementProfile',
            value: function value(e, t) {
              'string' == typeof e && (e = Z({}, e, 1));
              var i = {};
              Object.keys(e).forEach(function (t) {
                return (i[t] = Number(e[t]));
              });
              var n = W(
                W({}, ke.Sensors),
                {},
                {
                  properties: i,
                },
              );
              (n.eventId = n.eventId + 'profile_increment'),
                this.oTrack.track(n, t);
            },
          },
          {
            key: 'appendProfile',
            value: function value(e, t) {
              var i = {},
                n = !0;
              if (
                (Object.keys(e).forEach(function (t) {
                  (i[t] = 'string' == typeof e[t] ? [e[t]] : e[t]), (n = !1);
                }),
                !n)
              ) {
                var r = W(
                  W({}, ke.Sensors),
                  {},
                  {
                    properties: i,
                  },
                );
                (r.eventId = r.eventId + 'profile_append'),
                  this.oTrack.track(r, t);
              }
            },
          },
          {
            key: 'track',
            value: function value(e, t, i) {
              var n = this.oTrack.tracker;
              if ('string' != typeof e) return n.track.apply(n, arguments);
              var r = {},
                o = t || {};
              return (
                (r.eventId = o.eventId ? o.eventId + '' : e),
                (r.eventGroup = o.eventGroup ? o.eventGroup + '' : '$track_sa'),
                (r.properties = W({}, t)),
                n.track.call(n, r, i)
              );
            },
          },
          {
            key: 'trackSignup',
            value: function value(e, t, i, n) {
              'string' != typeof e && (e += ''), this.oTrack.setUserId(e);
              var r = W(
                  W({}, i),
                  {},
                  {
                    original_id: this.getAnonymousID(),
                    distinct_id: e,
                  },
                ),
                o = W(
                  W({}, ke.Sensors),
                  {},
                  {
                    properties: r,
                  },
                );
              (o.eventId = o.eventId + (t || 'signup')),
                this.oTrack.track(o, n);
              var a = this.store.getIdentities();
              this.store.setIdentities({
                $identity_login_id: e,
                $identity_anonymous_id: a.$identity_login_id,
              });
            },
          },
          {
            key: 'setItem',
            value: function value(e, t, i) {
              var n = W(
                W({}, ke.Sensors),
                {},
                {
                  item_type: e,
                  item_id: t,
                  properties: W({}, i),
                },
              );
              (n.eventId = n.eventId + 'item_set'), this.oTrack.track(n);
            },
          },
          {
            key: 'deleteItem',
            value: function value(e, t) {
              var i = W(
                W({}, ke.Sensors),
                {},
                {
                  item_type: e,
                  item_id: t,
                },
              );
              (i.eventId = i.eventId + 'item_delete'), this.oTrack.track(i);
            },
          },
          {
            key: 'trackLink',
            value: function value(e, t, i) {
              this.oTrack.heatmap
                ? this.oTrack.heatmap.trackLink(e, t, i)
                : Logger.info(
                    'mini版jssdk不支持heatmap能力，若需要请使用完整版',
                  );
            },
          },
          {
            key: 'getAppStatus',
            value: function value() {
              try {
                var e,
                  t =
                    (null === (e = window) || void 0 === e
                      ? void 0
                      : e.App_AutoEvent_Js_Bridge) || {},
                  i = t.call_app && t.call_app();
                if (i) {
                  var n = JSON.parse(i);
                  n.is_login
                    ? (this.login(n.distinct_id), (n.is_login_id = !0))
                    : (n.is_login_id = !1),
                    delete n.is_login,
                    delete n.distinct_id,
                    'Android' === n.type &&
                      rt.userInfo.setAppVersion(n.android_version);
                  var r = {};
                  Object.keys(n).forEach(function (e) {
                    (r['$'.concat(e)] = n[e]),
                      'brand' === e &&
                        ((r.$manufacturer = n[e]), delete r.$brand);
                  });
                  try {
                    var o,
                      a =
                        null === (o = navigator) || void 0 === o
                          ? void 0
                          : o.userAgent.match(/(\(.+?\))/);
                    if (a) {
                      var s = a[0].match(/([\.\d\_\-]+)/) || [];
                      r.$os_version = s[0] || '';
                    }
                  } catch (e) {
                    r.$os_version = '';
                  }
                  return r;
                }
              } catch (e) {
                console.error(e);
              }
              return {};
            },
          },
          {
            key: 'uuid',
            value: function value() {
              var e = UUID();
              return e;
            },
          },
          {
            key: 'getDataSequenceId',
            value: function value() {
              return ''
                .concat(this.oTrack.getDeviceId(), '_')
                .concat(Date.now());
            },
          },
          {
            key: 'bind',
            value: function value() {
              Logger.info('bind方法暂未实现');
            },
          },
          {
            key: 'unbind',
            value: function value() {
              Logger.info('unbind方法暂未实现');
            },
          },
          {
            key: 'loginWithKey',
            value: function value() {
              Logger.info('loginWithKey方法暂未实现');
            },
          },
          {
            key: 'use',
            value: function value(e, t) {
              Logger.info('use方法暂未实现');
            },
          },
        ]),
        e
      );
    })(),
    It = 'otrack_jssdk_session',
    St = (function () {
      function e(t) {
        K(this, e),
          (this.oTrack = null),
          (this.state = {
            props: {},
            identities: {
              $identity_cookie_id: '',
              $identity_anonymous_id: '',
              $identity_login_id: '',
            },
            lib: {
              $lib: 'js',
              $lib_method: 'code',
              $lib_version: '1.24.6',
            },
          }),
          (this.sessionState = {});
        var i = W({}, t);
        void 0 !== i.oTrack && (this.oTrack = i.oTrack);
      }
      return (
        Y(e, [
          {
            key: 'init',
            value: function value() {
              this.initSessionState(),
                this.initState(),
                (this.state.h5app = this.oTrack.getAppStatus());
              var e = W({}, this.state.identities);
              if (!e.$identity_cookie_id) {
                var t = this.oTrack.getDeviceId();
                t || ((t = generateUUID()), this.oTrack.setDeviceId(t)),
                  (e.$identity_cookie_id = t),
                  (e.$identity_anonymous_id = e.$identity_cookie_id),
                  (e.$identity_login_id = e.$identity_cookie_id);
              }
              e.$identity_anonymous_id ||
                (e.$identity_anonymous_id = generateUUID()),
                e.$identity_login_id ||
                  (e.$identity_login_id = e.$identity_anonymous_id),
                (this.state.identities = e),
                this.oTrack.setCustomHead(this.state);
            },
          },
          {
            key: 'initState',
            value: function value() {
              var e = this.oTrack.getCustomHead();
              this.state = W(W({}, this.state), e);
            },
          },
          {
            key: 'getIdentities',
            value: function value() {
              return this.initState(), this.state.identities;
            },
          },
          {
            key: 'setIdentities',
            value: function value(e) {
              var t =
                1 >= arguments.length ||
                void 0 === arguments[1] ||
                arguments[1];
              this.initState(),
                (this.state.identities = t
                  ? W(W({}, this.state.identities), e)
                  : W(W({}, e), this.state.identities)),
                this.oTrack.setCustomHead(this.state);
            },
          },
          {
            key: 'getProps',
            value: function value() {
              return this.initState(), this.state.props;
            },
          },
          {
            key: 'setProps',
            value: function value(e) {
              var t =
                1 >= arguments.length ||
                void 0 === arguments[1] ||
                arguments[1];
              this.initState(),
                (this.state.props = t
                  ? W(W({}, this.state.props), e)
                  : W(W({}, e), this.state.props)),
                this.oTrack.setCustomHead(this.state);
            },
          },
          {
            key: 'setPropsOnce',
            value: function value(e) {
              var t = this;
              this.initState(),
                Object.keys(e).forEach(function (i) {
                  i in t.state.props || (t.state.props[i] = e[i]);
                }),
                this.oTrack.setCustomHead(this.state);
            },
          },
          {
            key: 'initSessionState',
            value: function value() {
              var e;
              try {
                e = deserialize(Ie(readCookie(It)) || 'null');
              } catch (e) {
                Logger.error('cookies ' + It + ' 获取失败');
              }
              e && (this.sessionState = e);
            },
          },
          {
            key: 'sessionSave',
            value: function value() {
              createCookie(It, be(serialize(this.sessionState)), 0, {
                cross_subdomain: Ne.config.is_cross_subdomain,
              });
            },
          },
          {
            key: 'getSessionProps',
            value: function value() {
              return this.sessionState;
            },
          },
          {
            key: 'setSessionProps',
            value: function value(e) {
              (this.sessionState = W(W({}, this.sessionState), e)),
                this.sessionSave();
            },
          },
          {
            key: 'clearAllProps',
            value: function value(e) {
              var t = this;
              (this.sessionState = {}),
                this.sessionSave(),
                e && TypeChecks.isArray(e)
                  ? e.forEach(function (e) {
                      e in t.state.props && delete t.state.props[e];
                    })
                  : (this.state.props = {}),
                this.oTrack.setCustomHead(this.state);
            },
          },
          {
            key: 'getDistinctId',
            value: function value() {
              return this.oTrack.getUserId() || this.oTrack.getDeviceId();
            },
          },
          {
            key: 'getFirstId',
            value: function value() {
              return this.oTrack.getDeviceId();
            },
          },
          {
            key: 'getOriginDistinctId',
            value: function value() {
              return (
                this.oTrack.getUserId() ||
                this.getIdentities().$identity_cookie_id
              );
            },
          },
          {
            key: 'getOriginUnionId',
            value: function value() {
              var e = {},
                t = this.getOriginDistinctId(),
                i = this.oTrack.getDeviceId();
              return (
                t
                  ? ((e.login_id = t), (e.anonymous_id = i))
                  : (e.anonymous_id = i),
                e
              );
            },
          },
          {
            key: 'getUnionId',
            value: function value() {
              return this.getOriginUnionId();
            },
          },
        ]),
        e
      );
    })();
  new Promise(function (e) {
    if (
      !(null == Array ? void 0 : Array.prototype.includes) ||
      !(null == Object ? void 0 : Object.keys)
    ) {
      var t = document.createElement('script');
      (t.onload = function () {
        e(!0);
      }),
        document.head.appendChild(t),
        t.setAttribute('async', 'async'),
        t.setAttribute('src', Te('polyfill.umd.min.js'));
    }
  }),
    Ne.setPkgInfo({
      name: '@oplus/obus-track-sdk',
      version: bt,
    });
  var Et = ['track', 'startEvent', 'stopEvent', 'flush', 'setCustomProperties'],
    Ct = [
      'setCustomHead',
      'getCustomHead',
      'getDeviceId',
      'setDeviceId',
      'setAppVersion',
      'getAppVersion',
      'setUserId',
      'getUserId',
      'setCustomClientId',
      'getCustomClientId',
      'isFirstDayFromCookies',
      'setIsWebview',
      'getIsWebview',
    ];
  function $t(e) {
    var t = this;
    if (e) {
      for (
        var i = e.split('.'), n = i[i.length - 1], r = 0;
        i.length - 1 > r && null != (t = t[i[r]]);
        r++
      );
      if (null != t) {
        if (t && 'function' == typeof t[n]) {
          for (
            var a = arguments.length, s = Array(a > 1 ? a - 1 : 0), c = 1;
            a > c;
            c++
          )
            s[c - 1] = arguments[c];
          return t[n].apply(t, s);
        }
        return t[n];
      }
    } else Logger.error(''.concat(e, ' 不能为空'));
  }
  var At = (function () {
    function e(t) {
      var i = this;
      K(this, e),
        (this.trackEvent = void 0),
        (this.sensorsStore = void 0),
        (this.dispatch = function (e) {
          Ne.config.sdk_auto_track && i.trackEvent.track(e);
        });
      var n = window;
      if (n.otrack) throw Error('oTrack has been instanced');
      (n.OTrack = n.otrack = this), Ne.init(t, this);
      var r = (this.trackEvent = new mt({
        oTrack: this,
      }));
      Ct.forEach(function (e) {
        i[e] = function () {
          return $t.apply(
            rt.userInfo,
            [e].concat(Array.prototype.slice.call(arguments)),
          );
        };
      }),
        Et.forEach(function (e) {
          i[e] = function () {
            return $t.apply(
              r,
              [e].concat(Array.prototype.slice.call(arguments)),
            );
          };
        });
      var o = (this.sensorsStore = new St({
          oTrack: this,
        })),
        a = new Tt({
          oTrack: this,
          store: o,
        });
      Object.getOwnPropertyNames(Tt.prototype)
        .filter(function (e) {
          return 'constructor' !== e;
        })
        .forEach(function (e) {
          i[e] = function () {
            return $t.apply(
              a,
              [e].concat(Array.prototype.slice.call(arguments)),
            );
          };
        }),
        (this.getHeader = function () {
          return $t.apply(
            r,
            ['batchSend.reportHeader.getHeader'].concat(
              Array.prototype.slice.call(arguments),
            ),
          );
        }),
        (this.updateCloudConfig = function (e) {
          return $t.call(r, 'cloudAppConfig.refresh', !0, function () {
            (null == e || e) && window.location.reload();
          });
        });
      var s = new wt(this.dispatch, this);
      (this.setAutoTrackParam = s.setAutoTrackParam.bind(s)),
        (this.getAutoTrackParam = s.getAutoTrackParam.bind(s)),
        (this.trackPageView = s.trackPageView.bind(s)),
        this.sensorsStore.init(),
        'function' == typeof t.on_created &&
          t.on_created.call(this, {
            oTrack: this,
            options: t,
          });
    }
    return (
      Y(
        e,
        [
          {
            key: 'options',
            get: function get() {
              return Ne.config;
            },
          },
          {
            key: 'store',
            get: function get() {
              return this.sensorsStore;
            },
          },
          {
            key: 'tracker',
            get: function get() {
              return this.trackEvent;
            },
          },
        ],
        [
          {
            key: 'VERSION',
            get: function get() {
              return bt;
            },
          },
        ],
      ),
      e
    );
  })();
  At.CLOUD_VERSION = w$1.VERSION;
  var Dt = 'data-exposure-id',
    Ot = (function () {
      function e(t) {
        K(this, e),
          (this.observeNodeList = []),
          (this.options = void 0),
          (this.observer = null),
          (this.durationTimer = {}),
          (this.options = _extends(
            W(
              W({}, Ne.config.exposure),
              {},
              {
                dispatch: t,
              },
            ),
          )),
          (1 >= this.options.intersection_threshold &&
            this.options.intersection_threshold > 0) ||
            (this.options.intersection_threshold = 1),
          (this.options.duration_threshold > 3e3 ||
            0 > this.options.duration_threshold) &&
            (this.options.duration_threshold = 0),
          this.init();
      }
      return (
        Y(e, [
          {
            key: 'init',
            value: function value() {
              var e = this;
              this.observer = new IntersectionObserver(
                function (t, i) {
                  t.forEach(function (t) {
                    var i = t.target,
                      n = i.getAttribute(Dt),
                      r = e.observeNodeList.find(function (e) {
                        return e.el === i;
                      });
                    if (n && r)
                      if (
                        t.isIntersecting &&
                        t.intersectionRatio >= e.options.intersection_threshold
                      ) {
                        if (e.durationTimer[n] && 0 !== e.durationTimer[n])
                          return;
                        e.durationTimer[n] = window.setTimeout(function () {
                          var t = recursive(
                            !0,
                            {
                              properties: We(i),
                            },
                            r.data,
                          );
                          e.options.dispatch(t),
                            e.options.once ? e.unobserve(i) : e.clean(i);
                        }, e.options.duration_threshold);
                      } else e.durationTimer[n] && e.clean(i);
                  });
                },
                {
                  root: null,
                  rootMargin: this.options.root_margin,
                  threshold: this.options.intersection_threshold,
                },
              );
            },
          },
          {
            key: 'observe',
            value: function value(e, t) {
              e.getAttribute(Dt) || e.setAttribute(Dt, random(8)),
                this.observeNodeList.find(function (t) {
                  return t.el === e;
                }) ||
                  (this.observeNodeList.push({
                    el: e,
                    data: t,
                  }),
                  this.observer && this.observer.observe(e));
            },
          },
          {
            key: 'unobserve',
            value: function value(e) {
              var t;
              this.clean(e),
                (this.observeNodeList = this.observeNodeList.filter(function (
                  t,
                ) {
                  return t.el !== e;
                })),
                null === (t = this.observer) || void 0 === t || t.unobserve(e);
            },
          },
          {
            key: 'clean',
            value: function value(e) {
              var t = e.getAttribute(Dt);
              t &&
                (window.clearTimeout(this.durationTimer[t]),
                delete this.durationTimer[t]);
            },
          },
        ]),
        e
      );
    })();
  !(function () {
    if (
      'object' !==
      ('undefined' == typeof __wxConfig ? 'undefined' : z(__wxConfig))
    )
      return new Promise(function (e) {
        var t;
        if (
          !(
            'IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'intersectionRatio' in
              (null === (t = window) || void 0 === t
                ? void 0
                : t.IntersectionObserverEntry.prototype)
          )
        ) {
          var i,
            n =
              null === (i = document) || void 0 === i
                ? void 0
                : i.createElement('script');
          (n.onload = function () {
            e(!0);
          }),
            document.head.appendChild(n),
            n.setAttribute('async', 'async'),
            n.setAttribute('src', Te('IntersectionObserver.min.js'));
        }
      });
    console.log('wx', __wxConfig, '__wxConfig 在index.ts');
  })();
  var Nt = (function (e) {
    X(i, e);
    var t = re(i);
    function i(e) {
      var n;
      K(this, i);
      var r = (n = t.call(this, e)).dispatch,
        a = new Ot(r);
      return (
        (n.exposure = {
          observe: a.observe.bind(a),
          unobserve: a.unobserve.bind(a),
        }),
        Je({
          logger: Logger.clone({
            namespace: 'heatmap',
          }),
          heatmap: Ne.config.heatmap,
          dispatch: r,
        }),
        (n.heatmap = {
          trackHeatMap: Be.trackHeatMap.bind(Be),
          trackAllHeatMap: Be.trackAllHeatMap.bind(Be),
          trackLink: Be.trackLink.bind(Be),
        }),
        (function (e) {
          var t,
            i = function i(t) {
              e({
                eventId: '$track_perf_'.concat(t.name.toLocaleLowerCase()),
                eventGroup: '$track_develop',
                properties: {
                  value: t.value.toFixed(3),
                },
              });
            };
          (null === (t = window) || void 0 === t ? void 0 : t.performance) &&
            Ne.config.develop.performance &&
            (S(i), x(i), b(i), W$1(i), Z$1(i));
        })(r),
        Me(
          function (e) {
            r(
              W(
                W({}, ke.JS_ERROR_CATCH),
                {},
                {
                  properties: W(
                    W({}, e),
                    {},
                    {
                      msg:
                        'string' == typeof e.msg
                          ? e.msg.slice(0, Ne.config.develop.errorSplit)
                          : e.msg,
                    },
                  ),
                },
              ),
            );
          },
          function () {
            return {
              catch_js_error: Ne.config.develop.catch_js_error,
              errorRatio: Ne.config.develop.errorRatio,
            };
          },
        ),
        (n.getEleDetail = We),
        n
      );
    }
    return Y(i);
  })(At);
  function ObusReport() {
    var options =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var otrack = new Nt({
      app_id: options.appId || '',
      app_key: options.appKey || '',
      region: options.region || 'cn',
      env: options.env || 'prod',
      is_single_page_app:
        options.isSinglePageApp !== undefined ? options.isSinglePageApp : true,
      // ...更多 Obus 的初始化配置
    });

    var commonBody = options.commonBody || {};
    function send() {
      var body =
        arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var head =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var deepClone = function deepClone(obj) {
        return JSON.parse(JSON.stringify(obj));
      };
      try {
        var eventBodies = Array.isArray(body) ? body : [body];
        eventBodies.forEach(function (item) {
          var logMapData = item.logMap;
          if (typeof logMapData === 'string') {
            try {
              logMapData = JSON.parse(logMapData);
            } catch (e) {
              console.error('Error parsing logMap:', e);
            }
          }
          if (logMapData && _typeof$1(logMapData) === 'object') {
            item = _objectSpread(_objectSpread({}, item), logMapData);
            delete item.logMap;
          }
          var mergedBody = _objectSpread(
            _objectSpread({}, deepClone(commonBody)),
            item,
          );
          var reportData = {
            eventId: mergedBody.eventID || '',
            eventGroup:
              mergedBody.eventGroup ||
              mergedBody.logTag ||
              options.logTag ||
              '',
            properties: _objectSpread(
              _objectSpread({}, deepClone(head)),
              mergedBody,
            ),
          };
          console.log('obus report data:', reportData);
          otrack.track(reportData);
        });
      } catch (e) {
        console.log('obus report send error', e);
      }
    }
    return {
      send: send,
    };
  }

  var iflowScene = query.get('iflowScene') || undefined;
  var buuid = query.get('__buuid__') || undefined;
  var dcsReport = new DcsReport({
    appId: '105301',
    logTag: '10012',
    // testEnvironmentFlag: true,
    defaultHead: {
      appId: '105301',
      logTag: '10012',
      imei: buuid,
    },
    commonBody: {},
  });
  var obusReport = {
    send: function send() {
      // do sth
    },
  };
  // 判断是否已经实例化过 避免重复实例化报错
  if (window.obusReport) {
    obusReport = window.obusReport;
  } else {
    obusReport = new ObusReport({
      appId: '130900',
      appKey: '1360',
      logTag: '10012',
      env: 'prod',
      // pre 测试 prod 正式
      commonBody: {
        imei: buuid,
      },
    });
    window.obusReport = obusReport;
  }

  // 相关搜索埋点事件
  function relatedSearchReport(data, eventID) {
    var module =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var browserInfo = getBrowserInfo();
    dcsReport.send(
      [
        {
          appId: '2007',
          logTag: '10006',
          imei: browserInfo.imei || '',
          duid: browserInfo.duid || '',
          buuid: buuid,
          logMap: JSON.stringify(data),
          eventID: eventID,
          module: module || iflowScene || '',
        },
      ],
      {
        appId: '2007',
        logTag: '10006',
        imei: browserInfo.imei || '',
        duid: browserInfo.duid || '',
        buuid: buuid,
      },
    );
    obusReport.send(
      [
        {
          appId: '130900',
          logTag: '10006',
          imei: browserInfo.imei || '',
          duid: browserInfo.duid || '',
          buuid: buuid,
          logMap: JSON.stringify(data),
          eventID: eventID,
          module: module || iflowScene || '',
        },
      ],
      {
        appId: '130900',
        logTag: '10006',
        imei: browserInfo.imei || '',
        duid: browserInfo.duid || '',
        buuid: buuid,
      },
    );
  }

  var uuid = v4();
  window.__relatedSearchInfo__ = {};
  function getSearchData(_x) {
    return _getSearchData.apply(this, arguments);
  }
  function _getSearchData() {
    _getSearchData = _asyncToGenerator(
      /*#__PURE__*/ regenerator.mark(function _callee(docInfo) {
        var _window$BrowserIFlow4,
          _window$BrowserIFlow5,
          _window$BrowserPriv3,
          _window$BrowserPriv3$,
          _window$wv$invoke;
        var inBrowserVersion,
          inBrowser,
          source,
          title,
          keywords,
          out_id,
          openSource,
          session,
          appSession,
          sequenceId,
          _window$wv,
          res,
          keyword,
          params,
          _window$__relatedSear4,
          data,
          resultData,
          reportParams,
          querys,
          newContent,
          newReportParams;
        return regenerator.wrap(
          function _callee$(_context) {
            while (1)
              switch ((_context.prev = _context.next)) {
                case 0:
                  inBrowserVersion = isBrowserVersionHigherThan('8.5');
                  inBrowser = window.wv.isMethodValid(
                    'BrowserIFlow.clickRelativeSearch',
                  );
                  source = docInfo.source;
                  title = docInfo.title;
                  keywords = docInfo.keywords;
                  out_id = docInfo.outId || '';
                  window.__relatedSearchInfo__.articleTitle = docInfo.title;
                  window.__relatedSearchInfo__.requestId = v4();
                  openSource =
                    ((_window$BrowserIFlow4 = window.BrowserIFlow) === null ||
                    _window$BrowserIFlow4 === void 0 ||
                    (_window$BrowserIFlow5 =
                      _window$BrowserIFlow4.getLaunchMode) === null ||
                    _window$BrowserIFlow5 === void 0
                      ? void 0
                      : _window$BrowserIFlow5.call(_window$BrowserIFlow4)) ||
                    '';
                  session =
                    (_window$BrowserPriv3 = window.BrowserPriv) === null ||
                    _window$BrowserPriv3 === void 0 ||
                    (_window$BrowserPriv3$ =
                      _window$BrowserPriv3.getSession) === null ||
                    _window$BrowserPriv3$ === void 0
                      ? void 0
                      : _window$BrowserPriv3$.call(_window$BrowserPriv3);
                  appSession = session ? window.btoa(session) : '';
                  sequenceId = v4();
                  if (
                    !(
                      window.wv.isMethodValid('BrowserIFlow.isBrowserHome') &&
                      ((_window$wv$invoke = window.wv.invoke(
                        'BrowserIFlow.isBrowserHome',
                      )) === null || _window$wv$invoke === void 0
                        ? void 0
                        : _window$wv$invoke.data) === false
                    )
                  ) {
                    _context.next = 14;
                    break;
                  }
                  return _context.abrupt('return', {
                    code: 0,
                    data: {},
                  });
                case 14:
                  if (inBrowserVersion) {
                    _context.next = 21;
                    break;
                  }
                  if (
                    !(
                      (_window$wv = window.wv) !== null &&
                      _window$wv !== void 0 &&
                      _window$wv.getRelativeSearchData
                    )
                  ) {
                    _context.next = 19;
                    break;
                  }
                  res = window.wv.getRelativeSearchData();
                  console.log('client data', res);
                  return _context.abrupt('return', res);
                case 19:
                  _context.next = 46;
                  break;
                case 21:
                  if (!inBrowser) {
                    _context.next = 46;
                    break;
                  }
                  keyword = '';
                  if (keywords && keywords.length) {
                    keyword = keywords.join(',');
                  }
                  params = {
                    f: 'json',
                    keyword: title || '',
                    out_id: out_id || '',
                    search_id: uuid,
                    source: source || '',
                    tagword: keyword,
                    relsearchType: 'detail',
                    engine: getEngine(),
                  };
                  _context.prev = 25;
                  _context.next = 28;
                  return fetchGetRelatedSearch(params);
                case 28:
                  data = _context.sent;
                  resultData = {
                    code: data.code,
                    msg: data.msg,
                    data: {},
                  };
                  if (data.code == 0) {
                    data.detailResult
                      ? (resultData.data = data.detailResult)
                      : (resultData.data = {});
                    data.transparent
                      ? (resultData.transparent = data.transparent)
                      : (resultData.transparent = '');
                    data.sid
                      ? (resultData.sid = data.sid)
                      : (resultData.sid = '');
                    data.algSource
                      ? (resultData.algSource = data.algSource)
                      : (resultData.algSource = '');
                    resultData.link = data.link;
                    resultData.engine = data.engine;
                    resultData.code = data.code;
                  }

                  /* 前端请求埋点START */
                  reportParams = {
                    ifSuccess: resultData.code == 0 ? true : false,
                    // 请求是否成功
                    errorCode: resultData.msg,
                    // 错误原因，由服务端返回
                    source: source,
                    //文章/视频的源（7.23版本开始，会统计视频）
                    searchId: uuid,
                    // 当前检索操作标识
                    sid: resultData.sid,
                    //当前流量抽样标识
                    transparent: resultData.transparent,
                    //服务端数据
                    jumpEngine: getEngine(),
                    //跳转的三方引擎
                    relatedSearchType: 'detail',
                    //  相关搜索类型
                    videoDisplayPercentage: '',
                    // 请求时的播放进度
                    frontReport: true,
                    algSource: resultData.algSource,
                    // 算法源
                    sequenceId: sequenceId,
                  };
                  console.log('请求埋点数据: ', reportParams);
                  relatedSearchReport(reportParams, '20083827');
                  /* 前端请求埋点END */

                  // 8.15新增   产品：刘多庆(80323734)
                  /**  新请求埋点上报STAR */
                  querys = resultData.data.querys;
                  newContent = '';
                  if (querys.length) {
                    querys.forEach(function (k, i) {
                      newContent =
                        newContent + ''.concat(i, ':').concat(k.query, '|');
                    });
                  }
                  newReportParams = {
                    openSource: openSource,
                    app_session: appSession,
                    requestId:
                      ((_window$__relatedSear4 =
                        window.__relatedSearchInfo__) === null ||
                      _window$__relatedSear4 === void 0
                        ? void 0
                        : _window$__relatedSear4.requestId) || v4(),
                    // 请求id
                    algSource: resultData.algSource,
                    // 算法源
                    searchPage: 'infoDetailPage',
                    //搜索页面
                    searchLocation: 'relatedSearch',
                    // 搜索具体位置
                    query: title,
                    // 搜索query
                    sequenceId: sequenceId,
                    //日志序列号id
                    showContent: newContent,
                  };
                  relatedSearchReport(newReportParams, '20089002', '12009');
                  /**  新请求埋点上报END */

                  //8.6新增  透传相关搜索词信息给客户端
                  sendDataToBrowser(resultData);
                  return _context.abrupt('return', resultData);
                case 43:
                  _context.prev = 43;
                  _context.t0 = _context['catch'](25);
                  console.error(
                    'fetchGetRelatedSearch is error: ',
                    _context.t0,
                  );
                case 46:
                case 'end':
                  return _context.stop();
              }
          },
          _callee,
          null,
          [[25, 43]],
        );
      }),
    );
    return _getSearchData.apply(this, arguments);
  }
  function exposeRelatedNewsStat(data, docInfo) {
    var _window$BrowserIFlow, _window$BrowserIFlow$, _window$BrowserPriv;
    var inBrowserVersion = isBrowserVersionHigherThan('8.5');
    var querys = data.data.querys;
    var link = data.link;
    var title = docInfo.title;
    var source = docInfo.source;
    var sid = data.sid;
    var transparent = data.transparent;
    var algSource = data.algSource;
    var openSource =
      ((_window$BrowserIFlow = window.BrowserIFlow) === null ||
      _window$BrowserIFlow === void 0 ||
      (_window$BrowserIFlow$ = _window$BrowserIFlow.getLaunchMode) === null ||
      _window$BrowserIFlow$ === void 0
        ? void 0
        : _window$BrowserIFlow$.call(_window$BrowserIFlow)) || '';
    var session =
      (_window$BrowserPriv = window.BrowserPriv) === null ||
      _window$BrowserPriv === void 0
        ? void 0
        : _window$BrowserPriv.getSession();
    var appSession = session ? window.btoa(session) : '';
    var sequenceId = v4();
    if (!inBrowserVersion) {
      // 客户端曝光埋点
      window.wv &&
        window.wv.onRelativeSearchExpose &&
        window.wv.onRelativeSearchExpose();
    } else {
      var _window$__relatedSear;
      var content = '';
      if (querys.length) {
        querys.forEach(function (k, i) {
          content = content + ''.concat(i, ':').concat(k.query, ';');
        });
      }
      var reportParams = {
        link: link,
        // 所在文章/视频的链接
        title: title,
        // 标题
        content: content,
        // 曝光内容，包括相关搜索关键词所在位置及文案, 数据格式: [下标]:title, 例子::"0:郭正亮结婚了吗;1:外国人看郭正亮;2:郭正亮谈美国视频;3:寰宇全视界郭正亮;"
        source: source,
        // 文章/视频的源
        searchId: uuid,
        // 当前检索操作标识
        sid: sid,
        // 当前流量抽样标识
        transparent: transparent,
        // 服务端数据
        jumpEngine: getEngine(),
        // 跳转的三方引擎
        relatedSearchType: 'detail',
        //  相关搜索类型
        frontReport: true,
        algSource: algSource,
        // 算法源
        sequenceId: sequenceId, //日志序列号id
      };

      console.log('相关搜索曝光埋点数据: ', reportParams);
      relatedSearchReport(reportParams, '20083828');

      /**  新曝光埋点上报STAR */
      var newContent = '';
      if (querys.length) {
        querys.forEach(function (k, i) {
          newContent = newContent + ''.concat(i, ':').concat(k.query, '|');
        });
      }
      var newReportParams = {
        app_session: appSession,
        // 用户session信息
        requestId:
          ((_window$__relatedSear = window.__relatedSearchInfo__) === null ||
          _window$__relatedSear === void 0
            ? void 0
            : _window$__relatedSear.requestId) || v4(),
        // 请求id
        algSource: algSource,
        // 算法源
        sId: sid,
        // 实验id
        searchPage: 'infoDetailPage',
        // 搜索页面
        searchLocation: 'relatedSearch',
        //搜索具体位置
        query: title,
        // 搜索请求提交的query
        sequenceId: sequenceId,
        //日志序列号id
        showContent: newContent,
        //展示的query_title
        openSource: openSource,
      };
      relatedSearchReport(newReportParams, '20089003', '12009');

      /**  新曝光埋点上报END */
    }
  }

  function clickReportStat(data, docInfo) {
    var _window$__relatedSear2,
      _window$BrowserIFlow2,
      _window$BrowserIFlow3,
      _window$BrowserPriv2,
      _window$BrowserPriv2$;
    var inBrowserVersion = isBrowserVersionHigherThan('8.5');
    var pos = data.pos;
    var link = data.link;
    var sid = data.sid;
    var title = data.title;
    var transparent = data.transparent;
    var source = docInfo.source;
    var articleTitle =
      ((_window$__relatedSear2 = window.__relatedSearchInfo__) === null ||
      _window$__relatedSear2 === void 0
        ? void 0
        : _window$__relatedSear2.articleTitle) || '';
    var algSource = data.algSource;
    var openSource =
      ((_window$BrowserIFlow2 = window.BrowserIFlow) === null ||
      _window$BrowserIFlow2 === void 0 ||
      (_window$BrowserIFlow3 = _window$BrowserIFlow2.getLaunchMode) === null ||
      _window$BrowserIFlow3 === void 0
        ? void 0
        : _window$BrowserIFlow3.call(_window$BrowserIFlow2)) || '';
    var session =
      (_window$BrowserPriv2 = window.BrowserPriv) === null ||
      _window$BrowserPriv2 === void 0 ||
      (_window$BrowserPriv2$ = _window$BrowserPriv2.getSession) === null ||
      _window$BrowserPriv2$ === void 0
        ? void 0
        : _window$BrowserPriv2$.call(_window$BrowserPriv2);
    var appSession = session ? window.btoa(session) : '';
    var sequenceId = v4();
    if (inBrowserVersion) {
      var _window$__relatedSear3;
      var reportParams = {
        pos: pos,
        // 相关搜索关键词所在位置
        title: title,
        // 标题
        link: link,
        //  所在文章/视频的链接
        source: source,
        // 文章/视频的源（7.23版本开始，会统计视频）
        searchId: uuid,
        // 当前检索操作标识
        sid: sid,
        // 当前流量抽样标识
        transparent: transparent,
        // 服务端数据
        jumpEngine: getEngine(),
        // 跳转的三方引擎
        relatedSearchType: 'detail',
        //  相关搜索类型
        frontReport: true,
        algSource: algSource,
        // 算法源
        sequenceId: sequenceId,
      };
      console.log('相关搜索点击埋点数据: ', reportParams);
      relatedSearchReport(reportParams, '20083829');

      /**  新点击埋点上报STAR */
      var newReportParams = {
        app_session: appSession,
        // 用户session信息
        requestId:
          ((_window$__relatedSear3 = window.__relatedSearchInfo__) === null ||
          _window$__relatedSear3 === void 0
            ? void 0
            : _window$__relatedSear3.requestId) || v4(),
        // 请求id
        algSource: algSource,
        // 算法源
        sId: sid,
        // 实验id
        // algTransparent: '', // 算法侧带的信息
        searchPage: 'infoDetailPage',
        // 搜索页面
        searchLocation: 'relatedSearch',
        //搜索具体位置
        query: articleTitle,
        // 搜索请求提交的query
        sequenceId: sequenceId,
        //日志序列号id
        showContent: title,
        //展示的query_title
        openSource: openSource,
      };
      relatedSearchReport(newReportParams, '20089004', '12009');

      /**  新点击埋点上报END */
    }
  }

  function sendDataToBrowser(data) {
    //  8.6新增  透传相关搜索词信息给客户端
    if (window.wv && window.wv.isMethodValid('BrowserIFlow.sendData')) {
      if (JSON.stringify(data) === '{}') {
        window.wv.invoke('BrowserIFlow.sendData', ['relSearchWordInfo', '']);
      } else {
        var sendData = {
          words: [],
          algSource: data.algSource,
        };
        data.data.querys.forEach(function (item) {
          sendData.words.push({
            word: item.query,
            jumpUrl: item.jumpUrl,
            jumpEngine: item.jumpEngine ? item.jumpEngine : getEngine(),
          });
        });
        window.wv.invoke('BrowserIFlow.sendData', [
          'relSearchWordInfo',
          JSON.stringify(sendData),
        ]);
      }
    }
  }

  exports.clickReportStat = clickReportStat;
  exports.exposeRelatedNewsStat = exposeRelatedNewsStat;
  exports.getSearchData = getSearchData;

  Object.defineProperty(exports, '__esModule', { value: true });
});
//# sourceMappingURL=feeds-relatedSearch.umd.js.map
